import React, { useState, useEffect } from 'react';
import { http } from '../../lib/http';
import MealPreferencesModal from '../../components/shared/MealPreferencesModal';
import { minStartDateToronto, tomorrowToronto, nextServiceDayToronto, renewalMinStartDate } from '../../lib/time';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Alert, AlertDescription } from '../../components/ui/alert';
import { lookupPlanPrice, sumAddOnsPrice, fetchLivePricing, getAllAddOns, getBasePrice, getHSTAmount, formatPrice } from '../../lib/pricing';
import {
  Loader2,
  Bell,
  MessageSquare,
  Utensils,
  ChevronRight,
  LogOut,
  User,
  Home,
  Briefcase,
  FileText,
  Sparkles,
  Star,
  Ruler,
  Menu,
  X,
  Calendar,
  CreditCard,
  Target,
  Dumbbell,
  Settings,
  Edit,
  Edit2,
  Trash2,
  Plus,
  Save,
  Activity,
  Award,
  BookOpen,
  Coffee,
  Smile,
  Zap,
  Check,
  DollarSign,
  Package,
  CheckCircle2,
  AlertCircle,
  XCircle,
  Lock
} from "lucide-react";

export default function CustomerDashboardNew() {
  // Helper function to format date without timezone issues
  const formatDateWithoutTimezone = (dateString) => {
    if (!dateString) return 'N/A';
    // Split the date string and create date parts to avoid timezone conversion
    const parts = dateString.split('-');
    if (parts.length === 3) {
      const year = parts[0];
      const month = parts[1];
      const day = parts[2].split(' ')[0]; // Remove any time component
      // Create date using local timezone (month is 0-indexed in JavaScript)
      const date = new Date(year, month - 1, day);
      return date.toLocaleDateString();
    }
    return dateString; // Return as-is if format is unexpected
  };

  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [showRenewalModal, setShowRenewalModal] = useState(false);
  const [showRenewSameModal, setShowRenewSameModal] = useState(false);
  const [showChangePlanModal, setShowChangePlanModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [renewalReminder, setRenewalReminder] = useState(null);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [renewalFormData, setRenewalFormData] = useState({
    newStartDate: '',
    mealPlanType: '2 Meals a Day',
    mealPlanTerm: '5 Days Veg',
    nvPreference: '',
    selectedMeals: ['Lunch', 'Dinner'],
    nvDayVegSlot: 'Lunch',
    chickenDays: [],
    dailyVegMeals: ['Breakfast', 'Lunch'],
    nvDayVegMeal: 'Breakfast',
    nvDayVegMeals: ['Breakfast', 'Lunch'],
    vegMealChoice: 'Breakfast',
    addOns: [],
    planTerm: 'Monthly'
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Change Password state
  const [changePwOld, setChangePwOld] = useState('');
  const [changePwNew, setChangePwNew] = useState('');
  const [changePwConfirm, setChangePwConfirm] = useState('');
  const [changePwLoading, setChangePwLoading] = useState(false);
  const [showChangePwPasswords, setShowChangePwPasswords] = useState(false);
  const [changePwError, setChangePwError] = useState('');
  const [changePwSuccess, setChangePwSuccess] = useState('');

  // Broadcast and Personal Message state
  const [broadcasts, setBroadcasts] = useState([]);
  const [personalMessages, setPersonalMessages] = useState([]);
  const [showPersonalMessageModal, setShowPersonalMessageModal] = useState(false);
  const [currentPersonalMessage, setCurrentPersonalMessage] = useState(null);

  // Today's Menu state
  const [todayMenu, setTodayMenu] = useState(null);
  const [isWeekend, setIsWeekend] = useState(false);
  const [isFutureMenu, setIsFutureMenu] = useState(false); // Flag for showing future menu
  const [menuDate, setMenuDate] = useState(null); // Actual menu date
  // Removed showMenuDropdown state
  const [weeklyMenu, setWeeklyMenu] = useState([]);
  const [selectedWeeklyDay, setSelectedWeeklyDay] = useState(null); // Which day's menu to show in weekly view

  // Meal Preferences state
  const [preferences, setPreferences] = useState(null);
  const [showPreferencesModal, setShowPreferencesModal] = useState(false);
  const [preferenceFormData, setPreferenceFormData] = useState({
    selected_meals: [],
    nv_day_veg_slot: '',
    chicken_days: [],
    veg_meal_choice: '',
    daily_veg_meals: [],
    nv_day_veg_meal: '',
    nv_day_veg_meals: [],
    veg_day_meals: []
  });



  // Reflection state
  const [showReflectionModal, setShowReflectionModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [todayReflection, setTodayReflection] = useState(null);
  const [motivationalMessage, setMotivationalMessage] = useState('');

  // To-Do state
  const [showTodoModal, setShowTodoModal] = useState(false);
  const [todos, setTodos] = useState({
    todays_tasks: [],
    upcoming_tasks: [],
    completed_tasks: [],
    today_date: ''
  });

  // Gym Time state
  const [gymActiveTab, setGymActiveTab] = useState('planner'); // planner, workout, progress, splits
  const [weeklyPlan, setWeeklyPlan] = useState({});
  const [activeSession, setActiveSession] = useState(null);
  const [gymProgress, setGymProgress] = useState(null);

  // Power Quote state
  const [powerQuote, setPowerQuote] = useState(null);

  // Daily Meal Selection state (Feature 1)
  const [dailyMeals, setDailyMeals] = useState([]);
  const [dailyMealsDefault, setDailyMealsDefault] = useState(['Lunch', 'Dinner']);
  const [dailyMealsMax, setDailyMealsMax] = useState(2); // 2 or 3 based on plan
  const [dailyMealsPlanType, setDailyMealsPlanType] = useState('2 Meals');
  const [savingDailyMeals, setSavingDailyMeals] = useState(null); // date being saved
  const [activeMealSlots, setActiveMealSlots] = useState({
    editable: false,
    selected_meals: ['Lunch', 'Dinner'],
    nv_day_veg_slot: '',
    plan_context: null,
    summary_text: ''
  });
  const [savingActiveMealSlots, setSavingActiveMealSlots] = useState(false);

  useEffect(() => {
    if ((activeMealSlots.selected_meals || []).length === 2) {
      setRenewalFormData((prev) => ({
        ...prev,
        selectedMeals: prev.selectedMeals?.length === 2 ? prev.selectedMeals : activeMealSlots.selected_meals,
        nvDayVegSlot: prev.nvDayVegSlot || activeMealSlots.nv_day_veg_slot || activeMealSlots.selected_meals[0] || '',
        chickenDays: prev.chickenDays?.length > 0 ? prev.chickenDays : (preferences?.chicken_days || [])
      }));
    }
  }, [activeMealSlots.selected_meals, activeMealSlots.nv_day_veg_slot, preferences?.chicken_days]);

  // Pause Schedule state (Feature 2) - REMOVED

  // My Information Modal state
  const [showMyInfoModal, setShowMyInfoModal] = useState(false);

  // Active Tab state for reorganized dashboard
  const [activeTab, setActiveTab] = useState('overview'); // overview, productivity, workmode, gymmode, measurements

  // Notification dropdown ref for click-outside detection
  const notificationRef = React.useRef(null);

  // Track Measurements state
  const [measurements, setMeasurements] = useState([]);
  const [showMeasurementModal, setShowMeasurementModal] = useState(false);
  const [measurementPresets, setMeasurementPresets] = useState([
    { name: 'Weight', unit: 'kg', value: '' },
    { name: 'Chest', unit: 'inches', value: '' },
    { name: 'Biceps', unit: 'inches', value: '' },
    { name: 'Waist', unit: 'inches', value: '' },
    { name: 'Glutes', unit: 'inches', value: '' }
  ]);
  const [measurementDate, setMeasurementDate] = useState(new Date().toISOString().split('T')[0]);
  const [showAddPresetModal, setShowAddPresetModal] = useState(false);
  const [newPreset, setNewPreset] = useState({ name: '', unit: 'inches' });
  const [measurementViewType, setMeasurementViewType] = useState('week'); // week or month

  // Profile Edit State
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [profileFormData, setProfileFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    address: {
      street: '',
      city: '',
      postalCode: '',
      deliveryInstructions: ''
    }
  });



  // Cancel Subscription State
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState('');

  // Pause Subscription State
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [pauseStartDate, setPauseStartDate] = useState('');
  const [pauseEndDate, setPauseEndDate] = useState('');
  const [pauseReason, setPauseReason] = useState('');
  const [pausedData, setPausedData] = useState({ is_paused: false, pause_start_date: null, pause_end_date: null });

  // Add-ons State
  const [showAddonsModal, setShowAddonsModal] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [addonPreviewCost, setAddonPreviewCost] = useState(null);

  // Dietary Preferences & Feedback State
  const [showDietaryModal, setShowDietaryModal] = useState(false);
  const [dietaryFormData, setDietaryFormData] = useState({
    foodPreferences: [],
    ingredientsToAvoid: [],
    allergyInfo: '',
    generalFeedback: ''
  });
  const [savingPreferences, setSavingPreferences] = useState(false);

  // Load dietary prefs into form
  useEffect(() => {
    if (showDietaryModal && preferences) {
      setDietaryFormData({
        foodPreferences: Array.isArray(preferences.foodPreferences) ? preferences.foodPreferences.join(', ') : (preferences.foodPreferences || ''),
        ingredientsToAvoid: Array.isArray(preferences.allergies) ? preferences.allergies.join(', ') : (preferences.allergies || ''),
        allergyInfo: preferences.dietaryNotes || '',
        generalFeedback: ''
      });
    }
  }, [showDietaryModal, preferences]);

  const handleSaveDietaryPreferences = async () => {
    try {
      setSavingPreferences(true);
      setError('');

      const allergies = typeof dietaryFormData.ingredientsToAvoid === 'string'
        ? dietaryFormData.ingredientsToAvoid.split(',').map(s => s.trim()).filter(s => s)
        : dietaryFormData.ingredientsToAvoid;

      const foodPreferences = typeof dietaryFormData.foodPreferences === 'string'
        ? dietaryFormData.foodPreferences.split(',').map(s => s.trim()).filter(s => s)
        : dietaryFormData.foodPreferences;

      // Save dietary preferences with backend-compatible field names
      await http.patch('/customer/preferences/dietary', {
        allergies,
        dietaryNotes: dietaryFormData.allergyInfo,
        foodPreferences,
      });

      // If general feedback was entered, submit it separately to the feedback collection
      if (dietaryFormData.generalFeedback && dietaryFormData.generalFeedback.trim()) {
        await http.post('/customer/feedback', { message: dietaryFormData.generalFeedback.trim() });
      }

      setSuccess('Preferences & Feedback saved successfully!');
      setShowDietaryModal(false);
      loadData();
    } catch (error) {
      console.error('Save Dietary Prefs Error:', error);
      setError('Failed to save preferences: ' + (error.response?.data?.message || error.message));
    } finally {
      setSavingPreferences(false);
    }
  };




  useEffect(() => {
    // Load live pricing on mount
    fetchLivePricing().then(() => {
      console.log('✅ Live pricing loaded for Customer Dashboard');
    });

    loadData();
    loadPausedDates();

    // Check for payment return status
    const params = new URLSearchParams(window.location.search);
    const currentUrl = window.location.href; // Backup check



    // Check URL params OR Session Storage (backup)
    const renewalSuccess = params.get('renewal_success');
    const renewalCancel = params.get('renewal_cancel');
    const sessionId = params.get('session_id');
    const addonSuccess = params.get('addon_success');
    const addonCancel = params.get('addon_cancel');

    if (renewalSuccess === 'true' && sessionId) {
      // ... existing renewal logic ...
      // (Simplified for this snippet, assuming renewal logic is handled elsewhere or I just append)
    }

    if (addonSuccess === 'true' && sessionId) {
      console.log('✅ Add-on payment success! Verifying...');
      // remove params from URL
      window.history.replaceState({}, document.title, window.location.pathname);

      // Verify payment with backend
      http.post('/customer/verify-addon-payment', { sessionId })
        .then(response => {
          setSuccess('Add-ons added successfully!');
          setTimeout(() => setSuccess(''), 5000);
          loadData(); // Reload customer data
        })
        .catch(err => {
          console.error('Failed to verify add-on payment:', err);
          setError('Payment successful but failed to update subscription. Please contact support.');
        });
    }

    if (addonCancel === 'true') {
      window.history.replaceState({}, document.title, window.location.pathname);
      setError('Add-on payment cancelled.');
      setTimeout(() => setError(''), 5000);
    }

    // Check for cancelled renewal
    if (renewalCancel === 'true') {
      // window.history.replaceState({}, '', '/customer/dashboard');
      setError('Payment process was cancelled.');
    }
  }, []);

  // Click outside to close notifications
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showNotifications]);

  // Removed: Auto-mark delivery notifications (delivery history feature removed for performance)


  const loadData = async () => {
    try {
      setLoading(true);
      setError('');

      // Load profile
      const profileRes = await http.get('/customer/me');
      const isTruckerUser = profileRes.data?.customer?.planKey?.includes('Truckers');
      if (profileRes.data?.ok) {
        setProfile(profileRes.data.customer);



      }

      // Load notifications
      const notificationsRes = await http.get('/customer/notifications');
      let notifs = [];
      let renewalNotif = null;
      if (notificationsRes.data?.ok) {
        notifs = notificationsRes.data.notifications;
        setNotifications(notifs);
        setUnreadCount(notifs.filter(n => n.status === 'unread').length);

        // Check for unread personal messages and show modal
        const unreadPersonalMsg = notifs.find(n => n.type === 'personal_message' && n.status === 'unread');
        if (unreadPersonalMsg) {
          setCurrentPersonalMessage(unreadPersonalMsg);
          setShowPersonalMessageModal(true);
        }

        // Check for renewal reminders
        renewalNotif = notifs.find(n =>
          n.type === 'renewal_reminder' && n.status === 'unread'
        );

        console.log('Found Renewal Notification:', renewalNotif);

        if (renewalNotif) {
          const reminderData = renewalNotif.data || {};
          setRenewalReminder({
            id: renewalNotif._id,
            notificationId: renewalNotif.id,
            message: renewalNotif.message,
            daysUntilRenewal: reminderData.days_until_renewal,
            renewalDate: reminderData.renewal_date || 'N/A',
            amountDue: reminderData.amount_due,
            planKey: reminderData.plan_name || 'Your Plan',
            totalAmount: reminderData.amount_due || '0.00',
            renewalId: reminderData.renewal_id
          });
        }
      }

      // Profile-based renewal banner fallback (when no notification exists)
      // Skip if customer already has a pending renewal — show confirmation instead
      if (!renewalNotif && profileRes.data?.ok) {
        const cust = profileRes.data.customer;

        if (cust.hasPendingRenewal) {
          // Customer already renewed — show confirmation banner instead of "renew now"
          setRenewalReminder({
            id: null,
            notificationId: null,
            isPendingRenewal: true,
            message: `Your next plan is scheduled to start on ${cust.pendingRenewalStartDate}. You'll continue receiving meals on your current plan until ${cust.planEndDate}.`,
            daysUntilRenewal: 99, // positive = blue banner
            renewalDate: cust.pendingRenewalStartDate || 'N/A',
            planKey: cust.pendingRenewalPlan || cust.planKey || cust.plan || 'Your Plan',
            totalAmount: cust.totalAmount || cust.totalPrice || cust.planPrice || '0.00',
            renewalId: null,
          });
        } else {
          let subStatus = cust.subscriptionStatus || cust.status;
          const endDateStr = cust.planEndDate;

          // Bridge the "banner gap" between midnight and the 12 PM Toronto
          // cron that flips active -> expired on the day after planEndDate.
          if (subStatus === 'active' && endDateStr) {
            const todayToronto = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Toronto' });
            if (todayToronto > endDateStr) {
              subStatus = 'expired';
            }
          }

          let shouldShowBanner = false;
          let daysUntilRenewal = null;

          // Check if endDate is within 48 hours (Toronto-aware)
          if (endDateStr && subStatus === 'active') {
            const nowToronto = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Toronto' });
            const nowNoon = new Date(nowToronto + 'T12:00:00Z');
            const endNoon = new Date(endDateStr + 'T12:00:00Z');
            const hoursUntilEnd = ((endNoon - nowNoon) / (1000 * 60 * 60)) + 12; // +12 for end-of-day
            daysUntilRenewal = Math.ceil(hoursUntilEnd / 24);
            if (hoursUntilEnd <= 48 && hoursUntilEnd > 0) {
              shouldShowBanner = true;
            }
          }

          // Check if status is expired, ex-customer, or cancelled
          if (subStatus === 'expired' || subStatus === 'ex-customer' || subStatus === 'cancelled') {
            shouldShowBanner = true;
            daysUntilRenewal = 0;
          }

          if (shouldShowBanner) {
            setRenewalReminder({
              id: null,
              notificationId: null,
              message: subStatus === 'expired' || subStatus === 'ex-customer' || subStatus === 'cancelled'
                ? 'Your subscription has ended. Renew now to continue receiving meals!'
                : `Your plan ends ${daysUntilRenewal <= 1 ? 'tomorrow' : 'in ' + daysUntilRenewal + ' days'}. Please renew your plan before 6 PM on ${endDateStr} to keep your meals coming!`,
              daysUntilRenewal: daysUntilRenewal,
              renewalDate: endDateStr || 'N/A',
              amountDue: cust.totalAmount || cust.totalPrice || cust.planPrice || '0.00',
              planKey: cust.planKey || cust.plan || 'Your Plan',
              totalAmount: cust.totalAmount || cust.totalPrice || cust.planPrice || '0.00',
              renewalId: null,
            });
          }
        }
      }

      // Load broadcast messages
      const broadcastsRes = await http.get('/customer/broadcasts');
      if (broadcastsRes.data?.ok) {
        setBroadcasts(broadcastsRes.data.broadcasts || []);
      }

      // Load meal preferences
      const preferencesRes = await http.get('/customer/preferences');
      if (preferencesRes.data?.ok && preferencesRes.data.preferences) {
        setPreferences(preferencesRes.data.preferences);
        setPreferenceFormData({
          selected_meals: preferencesRes.data.preferences.selected_meals || [],
          nv_day_veg_slot: preferencesRes.data.preferences.nv_day_veg_slot || '',
          chicken_days: preferencesRes.data.preferences.chicken_days || [],
          veg_meal_choice: preferencesRes.data.preferences.veg_meal_choice || '',
          daily_veg_meals: preferencesRes.data.preferences.daily_veg_meals || [],
          nv_day_veg_meal: preferencesRes.data.preferences.nv_day_veg_meal || '',
          nv_day_veg_meals: preferencesRes.data.preferences.nv_day_veg_meals || [],
          veg_day_meals: preferencesRes.data.preferences.veg_day_meals || []
        });
      }

      try {
        const activeMealSlotsRes = await http.get('/customer/active-meal-slots');
        if (activeMealSlotsRes.data?.ok) {
          setActiveMealSlots({
            editable: !!activeMealSlotsRes.data.editable,
            selected_meals: activeMealSlotsRes.data.selected_meals || ['Lunch', 'Dinner'],
            nv_day_veg_slot: activeMealSlotsRes.data.nv_day_veg_slot || '',
            plan_context: activeMealSlotsRes.data.plan_context || null,
            summary_text: activeMealSlotsRes.data.summary_text || ''
          });
        }
      } catch (e) {
        console.log('Active meal slots not available:', e.message);
      }



      // Load today's reflection
      if (!isTruckerUser) {
        const reflectionRes = await http.get('/customer/reflection/today');
        if (reflectionRes.data?.ok) {
          setTodayReflection(reflectionRes.data.reflection);
        }

        // Load motivational message
        const motivationRes = await http.get('/customer/reflection/motivation');
        if (motivationRes.data?.ok) {
          setMotivationalMessage(motivationRes.data.message);
        }

        // Load to-dos
        const todosRes = await http.get('/customer/todos');
        if (todosRes.data?.ok) {
          setTodos({
            todays_tasks: todosRes.data.todays_tasks || [],
            upcoming_tasks: todosRes.data.upcoming_tasks || [],
            completed_tasks: todosRes.data.completed_tasks || [],
            today_date: todosRes.data.today_date || ''
          });
        }

        // Load gym data
        const gymPlanRes = await http.get('/customer/gym/workout-plan');
        if (gymPlanRes.data?.ok) {
          setWeeklyPlan(gymPlanRes.data.weekly_plan || {});
        }

        const activeSessionRes = await http.get('/customer/gym/active-session');
        if (activeSessionRes.data?.ok) {
          setActiveSession(activeSessionRes.data.session);
        }

        const gymProgressRes = await http.get('/customer/gym/progress');
        if (gymProgressRes.data?.ok) {
          setGymProgress(gymProgressRes.data);
        }
      } // end !isTruckerUser

      // Load today's power quote
      const powerQuoteRes = await http.get('/customer/power-quote');
      if (powerQuoteRes.data?.success && powerQuoteRes.data.quote) {
        setPowerQuote(powerQuoteRes.data.quote);
      }

      // Removed: Load delivery history (feature removed for performance optimization)

      // Load today's menu
      if (!isTruckerUser) {
        const todayMenuRes = await http.get('/customer/today-menu');
        console.log('Today menu response:', todayMenuRes.data);
        if (todayMenuRes.data?.success) {
          console.log('Setting today menu:', todayMenuRes.data.menu);
          setTodayMenu(todayMenuRes.data.menu);
          setIsWeekend(todayMenuRes.data.is_weekend || false);
          setIsFutureMenu(todayMenuRes.data.is_future_menu || false);
          setMenuDate(todayMenuRes.data.date);
        } else {
          console.log('No menu or unsuccessful response');
        }

        // Load weekly menu
        const weeklyMenuRes = await http.get('/customer/weekly-menu');
        if (weeklyMenuRes.data?.success) {
          const menu = weeklyMenuRes.data.menu || [];
          setWeeklyMenu(menu);
          const todayName = new Date().toLocaleDateString('en-US', { weekday: 'long' });
          const todayItem = menu.find(m => m.day === todayName);
          setSelectedWeeklyDay(todayItem || (menu.length > 0 ? menu[0] : null));
        }

        // Load daily meal selections (Feature 1)
        try {
          const dailyMealsRes = await http.get('/customer/daily-meals');
          if (dailyMealsRes.data?.ok) {
            setDailyMeals(dailyMealsRes.data.days || []);
            setDailyMealsDefault(dailyMealsRes.data.default_meals || ['Lunch', 'Dinner']);
            setDailyMealsMax(dailyMealsRes.data.max_meals || 2);
            setDailyMealsPlanType(dailyMealsRes.data.plan_type || '2 Meals');
          }
        } catch (e) { console.log('Daily meals not available:', e.message); }
      } // end !isTruckerUser menu/meals
      // Load pause schedules (Feature 2) - REMOVED

    } catch (e) {
      console.error('Error loading customer data:', e);
      setError(e?.response?.data?.message || e?.message || 'Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  const markNotificationRead = async (notificationId) => {
    try {
      await http.post(`/customer/notifications/${notificationId}/mark-read`);
      loadData();
    } catch (error) {
      console.error('Failed to mark notification as read:', error);
    }
  };

  const deleteNotification = async (notificationId) => {
    if (!window.confirm('Delete this notification permanently?')) return;

    try {
      await http.delete(`/customer/notifications/${notificationId}`);
      loadData();
    } catch (error) {
      console.error('Failed to delete notification:', error);
      alert('Failed to delete notification');
    }
  };

  // Load measurements
  const loadMeasurements = async () => {
    try {
      const response = await http.get('/customer/measurements');
      console.log('Measurements response:', response.data);
      if (response.data?.ok && response.data?.measurements) {
        setMeasurements(response.data.measurements);
      } else if (response.data?.measurements) {
        setMeasurements(response.data.measurements);
      }
    } catch (error) {
      console.error('Failed to load measurements:', error);
    }
  };

  // Save measurement
  const saveMeasurement = async () => {
    try {
      // Convert presets to measurement object
      const measurementData = {
        date: measurementDate,
        measurements: measurementPresets.reduce((acc, preset) => {
          if (preset.value) {
            acc[preset.name.toLowerCase()] = {
              value: preset.value,
              unit: preset.unit
            };
          }
          return acc;
        }, {})
      };

      const response = await http.post('/customer/measurements', measurementData);
      console.log('Save measurement response:', response.data);

      // Reset form
      setShowMeasurementModal(false);
      setMeasurementPresets(prev => prev.map(p => ({ ...p, value: '' })));
      setMeasurementDate(new Date().toISOString().split('T')[0]);

      await loadMeasurements();
      alert('Measurement saved successfully!');
    } catch (error) {
      console.error('Failed to save measurement:', error);
      alert('Failed to save measurement: ' + (error.response?.data?.message || error.message));
    }
  };

  // Add new preset
  const addPreset = () => {
    if (!newPreset.name.trim()) {
      alert('Please enter a preset name');
      return;
    }

    setMeasurementPresets([...measurementPresets, { ...newPreset, value: '' }]);
    setNewPreset({ name: '', unit: 'inches' });
    setShowAddPresetModal(false);
  };

  // Remove preset
  const removePreset = (index) => {
    setMeasurementPresets(measurementPresets.filter((_, i) => i !== index));
  };

  // Update preset value
  const updatePresetValue = (index, value) => {
    const updated = [...measurementPresets];
    updated[index].value = value;
    setMeasurementPresets(updated);
  };

  // Update preset unit
  const updatePresetUnit = (index, unit) => {
    const updated = [...measurementPresets];
    updated[index].unit = unit;
    setMeasurementPresets(updated);
  };

  // Open Edit Profile Modal
  const handleEditProfileClick = () => {
    console.log('Edit Profile Clicked. Profile:', profile);
    if (!profile) {
      console.error('Profile is null, cannot edit');
      alert('Debug: Profile data is missing. Cannot edit.');
      return;
    }
    console.log('Setting profile form data:', profile);
    setProfileFormData({
      firstName: profile.firstName || '',
      lastName: profile.lastName || '',
      phone: profile.phone || '',
      address: {
        street: profile.address?.street || '',
        city: profile.address?.city || '',
        postalCode: profile.address?.postalCode || '',
        deliveryInstructions: profile.address?.deliveryInstructions || ''
      }
    });
    console.log('Showing Edit Modal');
    setShowEditProfileModal(true);
    console.log('Modal state set to true. Current state will update on next render.');
  };

  // Handle Update Profile
  const handleUpdateProfile = async () => {
    console.log('Update Profile Clicked. Data:', profileFormData);
    try {
      // Basic validation
      if (!profileFormData.firstName || !profileFormData.lastName || !profileFormData.phone) {
        alert('Please fill in Name and Phone fields.');
        return;
      }

      await http.put('/customer/profile', profileFormData);

      // Success
      setShowEditProfileModal(false);
      setSuccess('Profile updated successfully!');
      setTimeout(() => setSuccess(''), 3000);
      loadData(); // Reload profile
    } catch (error) {
      console.error('Update Profile Error:', error);
      setError(error.response?.data?.message || 'Failed to update profile');
      alert('Failed to update profile: ' + (error.response?.data?.message || error.message));
    }
  };

  // Handle Cancel Subscription
  const handleCancelSubscription = async () => {
    try {
      const requestData = {
        request_type: 'cancellation',
        requested_changes: {
          decision: 'cancel',
          cancellation_reason: cancelReason.trim()
        },
        notes: `Customer requested cancellation: ${cancelReason.trim()}`
      };

      await http.post('/customer/update-requests', requestData);

      setShowCancelModal(false);
      setSuccess('⚠️ Cancellation request submitted. Our team will contact you to confirm.');
      setTimeout(() => setSuccess(''), 5000);
    } catch (error) {
      console.error('Failed to submit cancellation request:', error);
      setError(error.response?.data?.message || 'Failed to submit cancellation request. Please try again.');
      setTimeout(() => setError(''), 5000);
    }
  };

  // Handle Pause Subscription
  const handlePauseSubscription = async () => {
    try {
      if (!pauseStartDate) {
        alert('Please select a start date to pause');
        return;
      }

      // Derive pause type from the dates provided
      let payload;
      if (!pauseEndDate) {
        // No end date → indefinite
        payload = { type: 'indefinite', startDate: pauseStartDate };
      } else if (pauseStartDate === pauseEndDate) {
        // Same day → single day
        payload = { type: 'single_day', pauseDate: pauseStartDate };
      } else {
        // Different dates → date range
        payload = { type: 'date_range', startDate: pauseStartDate, endDate: pauseEndDate };
      }

      const response = await http.post('/customer/pause', payload);

      setSuccess(`Subscription paused successfully.`);
      setTimeout(() => setSuccess(''), 5000);
      setShowPauseModal(false);
      loadData(); // Reload to update renewal date
      loadPausedDates();
    } catch (error) {
      console.error('Failed to pause subscription:', error);
      setError(error.response?.data?.message || 'Failed to pause subscription');
      setTimeout(() => setError(''), 5000);
    }
  };

  const handleUnpauseSubscription = async () => {
    try {
      if (!window.confirm('Are you sure you want to resume your subscription?')) return;
      const response = await http.post('/customer/unpause', {});
      setSuccess(`Subscription resumed successfully.`);
      setTimeout(() => setSuccess(''), 5000);
      loadData();
      loadPausedDates();
    } catch (error) {
      console.error('Failed to unpause subscription:', error);
      setError(error.response?.data?.message || 'Failed to unpause subscription');
      setTimeout(() => setError(''), 5000);
    }
  };

  // Handle Change Password
  const handleChangePassword = async (e) => {
    e.preventDefault();
    setChangePwError('');
    setChangePwSuccess('');

    if (!changePwOld || !changePwNew || !changePwConfirm) {
      setChangePwError('All fields are required');
      return;
    }
    if (changePwNew.length < 8) {
      setChangePwError('New password must be at least 8 characters');
      return;
    }
    if (changePwNew !== changePwConfirm) {
      setChangePwError('New passwords do not match');
      return;
    }

    setChangePwLoading(true);
    try {
      const res = await http.put('/customer/change-password', {
        old_password: changePwOld,
        new_password: changePwNew,
      });
      setChangePwSuccess(res.data?.message || 'Password changed successfully');
      setChangePwOld('');
      setChangePwNew('');
      setChangePwConfirm('');
      setTimeout(() => setChangePwSuccess(''), 5000);
    } catch (error) {
      setChangePwError(error.response?.data?.message || 'Failed to change password');
      setTimeout(() => setChangePwError(''), 5000);
    } finally {
      setChangePwLoading(false);
    }
  };

  // Handle Add Add-ons
  const handleAddAddons = async () => {
    try {
      if (selectedAddons.length === 0) {
        alert('Please select at least one add-on');
        return;
      }

      // Call backend to create checkout session
      const response = await http.post('/customer/add-addons', { addOns: selectedAddons });

      if (response.data.url) {
        window.location.href = response.data.url; // Redirect to Stripe
      }
    } catch (error) {
      console.error('Failed to add add-ons:', error);
      alert(error.response?.data?.message || 'Failed to initiate add-on payment.');
    }
  };

  // Load paused dates
  const loadPausedDates = async () => {
    try {
      const response = await http.get('/customer/paused-dates');
      if (response.data && response.data.ok) {
        const ap = response.data.activePause;
        setPausedData({
          is_paused: response.data.is_paused,
          pause_start_date: ap?.startDate ? new Date(ap.startDate).toISOString().slice(0, 10) : null,
          pause_end_date: ap?.endDate ? new Date(ap.endDate).toISOString().slice(0, 10) : null,
        });
      }
    } catch (error) {
      console.error('Failed to load paused dates:', error);
    }
  };

  // Delete measurement
  const deleteMeasurement = async (measurementId) => {
    if (!window.confirm('Delete this measurement record permanently?')) return;

    try {
      await http.delete(`/customer/measurements/${measurementId}`);
      await loadMeasurements();
      alert('Measurement deleted successfully');
    } catch (error) {
      console.error('Failed to delete measurement:', error);
      alert('Failed to delete measurement: ' + (error.response?.data?.message || error.message));
    }
  };


  // Check if customer needs to set preferences based on plan
  const needsPreferences = () => {
    if (!profile?.mealCount || !profile?.vegType) return false;
    // 3 meals + pure veg = fully preset (B+L+D all veg), no choices needed
    if (profile.mealCount === '3_meals' && profile.vegType === '5_days_veg') return false;
    // ALL other plans need preferences:
    // - 2 Meals + Veg: customer must choose which 2 meals (B+L, L+D, B+D)
    // - Any Non-Veg plan: customer must choose chicken days and veg meals
    return true;
  };

  const mealPreferenceSummaryLines = getMealPreferenceSummaryLines();
  const canEditCurrentPlanMeals = !!activeMealSlots.plan_context?.is2MealPlan;
  const canEditLockedMealPreferences = needsPreferences() && (!preferences || preferences.schedule_status !== 'set');
  const showMealPreferenceModeToggle = canEditCurrentPlanMeals || needsPreferences();

  // Get preference questions based on plan type (uses normalised enum fields)
  const getPreferenceQuestions = () => {
    const mc = profile?.mealCount;   // '2_meals' | '3_meals'
    const vt = profile?.vegType;     // '5_days_veg' | '5_days_nonveg' | '2NV_3V'
    if (!mc || !vt) return [];

    const nvCount = preferences?.nvMealCount || 0;  // 0, 1, or 2
    const questions = [];

    // ── 2 Meals a Day plans ──
    if (mc === '2_meals') {
      // Always ask which 2 meal slots
      questions.push({
        type: 'two_meals',
        key: 'selected_meals',
        title: 'Which 2 meals would you like?',
        description: 'Select exactly 2 meal slots. Default is Lunch and Dinner.',
        options: ['Breakfast', 'Lunch', 'Dinner'],
        required: 2
      });

      if (vt === '5_days_nonveg') {
        // 2 meals, 5 days non-veg: one slot veg, the other non-veg
        questions.push({
          type: 'single_meal',
          key: 'nv_day_veg_slot',
          title: 'Which VEG meal would you like?',
          description: 'One selected meal slot will stay veg and the other will be non-veg.',
          options: ['Breakfast', 'Lunch', 'Dinner'],
          required: 1
        });
      } else if (vt === '2NV_3V') {
        // 2 meals, 2NV/3V: pick chicken days
        questions.push({
          type: 'chicken_days',
          key: 'chicken_days',
          title: 'Which 2 days would you like non-veg?',
          description: 'Select exactly 2 days for non-veg meals (chicken will be from menu)',
          options: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          required: 2
        });
        if (nvCount < 2) {
          // Not "Both NV" — one slot stays veg on chicken days
          questions.push({
            type: 'single_meal',
            key: 'nv_day_veg_slot',
            title: 'On non-veg days, which selected meal stays VEG?',
            description: 'The other selected slot will be non-veg on those days.',
            options: ['Breakfast', 'Lunch', 'Dinner'],
            required: 1
          });
        }
      }
      // 2 meals + 5_days_veg: only the "which 2 meals" question above
    }

    // ── 3 Meals a Day plans ──
    else if (mc === '3_meals') {
      if (vt === '5_days_nonveg') {
        if (nvCount === 2) {
          // 3 meals, 5 days NV, 2 NV/day → pick 1 veg meal
          questions.push({
            type: 'single_meal',
            key: 'veg_meal_choice',
            title: 'Which 1 VEG meal would you like daily?',
            description: 'Two meals will be chicken (from menu). Select 1 vegetarian meal.',
            options: ['Breakfast', 'Lunch', 'Dinner'],
            required: 1
          });
        } else {
          // 3 meals, 5 days NV, 1 NV/day (or unspecified) → pick 2 veg meals
          questions.push({
            type: 'two_meals',
            key: 'daily_veg_meals',
            title: 'Which 2 VEG meals would you like daily?',
            description: 'One meal will be chicken (from menu). Select 2 vegetarian meals.',
            options: ['Breakfast', 'Lunch', 'Dinner'],
            required: 2
          });
        }
      } else if (vt === '2NV_3V') {
        if (nvCount === 2) {
          // 3 meals, 2NV/3V, 2 NV/day → chicken days + 1 veg meal on NV days
          questions.push({
            type: 'chicken_days',
            key: 'chicken_days',
            title: 'Which 2 days would you like non-veg?',
            description: 'Select exactly 2 days for non-veg meals (2 chicken meals from menu)',
            options: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            required: 2
          });
          questions.push({
            type: 'single_meal',
            key: 'nv_day_veg_meal',
            title: 'On non-veg days, which 1 VEG meal?',
            description: 'Two meals will be chicken. Select 1 vegetarian meal for those days.',
            options: ['Breakfast', 'Lunch', 'Dinner'],
            required: 1
          });
        } else {
          // 3 meals, 2NV/3V, 1 NV/day (or unspecified) → chicken days + 2 veg meals on NV days
          questions.push({
            type: 'chicken_days',
            key: 'chicken_days',
            title: 'Which 2 days would you like non-veg?',
            description: 'Select exactly 2 days for non-veg meals (chicken will be from menu)',
            options: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            required: 2
          });
          questions.push({
            type: 'two_meals',
            key: 'nv_day_veg_meals',
            title: 'On non-veg days, which 2 VEG meals?',
            description: 'One meal will be chicken. Select 2 vegetarian meals for those days.',
            options: ['Breakfast', 'Lunch', 'Dinner'],
            required: 2
          });
        }
        // Note: On 3 veg days, it's automatic B+L+D (no question needed)
      }
      // 3 meals + 5_days_veg: no questions (needsPreferences returns false)
    }

    return questions;
  };


  // Helper: Determine user's specific meal for today
  const getMyDailyMeal = () => {
    if (!profile || !todayMenu || !preferences) return null;

    const dayOfWeek = new Date().toLocaleDateString('en-US', { weekday: 'long' });
    const todaySchedule = preferences.weekly_schedule?.[dayOfWeek.toLowerCase()];
    if (!todaySchedule) return null;

    const items = [];
    let nonVegCount = 0;

    ['breakfast', 'lunch', 'dinner'].forEach((mealKey) => {
      const slotType = todaySchedule[mealKey];
      if (!slotType) return;

      if (slotType === 'non_veg') {
        nonVegCount += 1;
        items.push({
          label: `${mealKey.charAt(0).toUpperCase() + mealKey.slice(1)} (Non-Veg)`,
          ...todayMenu.chicken_meal
        });
      } else {
        items.push({
          label: mealKey.charAt(0).toUpperCase() + mealKey.slice(1),
          ...todayMenu[mealKey]
        });
      }
    });

    return {
      type: nonVegCount > 0 ? 'Non-Veg Day' : 'Vegetarian Day',
      description: `Today (${dayOfWeek}) follows your saved meal schedule.`,
      items,
      color: nonVegCount > 0 ? 'orange' : 'green'
    };
  };

  const openMealPreferencesModal = () => {
    setError('');
    setShowPreferencesModal(true);
  };

  function getMealPreferenceSummaryLines() {
    const source = preferences || {};
    const lines = [];

    if (source.selectedMeals?.length > 0) {
      lines.push(`Meals: ${source.selectedMeals.map(m => m.charAt(0).toUpperCase() + m.slice(1)).join(', ')}`);
    }
    if (source.nvDays?.length > 0) {
      lines.push(`Non-Veg Days: ${source.nvDays.map(d => d.charAt(0).toUpperCase() + d.slice(1)).join(', ')}`);
    }
    if (source.nvMealCount > 0) {
      lines.push(`Non-Veg Meals/Day: ${source.nvMealCount}`);
    }
    if (source.nvMealSelection?.length > 0) {
      lines.push(`Non-Veg Slots: ${source.nvMealSelection.map(m => m.charAt(0).toUpperCase() + m.slice(1)).join(', ')}`);
    }
    if (source.allergies?.length > 0) {
      lines.push(`Allergies: ${source.allergies.join(', ')}`);
    }
    if (source.dietaryNotes) {
      lines.push(`Notes: ${source.dietaryNotes}`);
    }

    return lines;
  }

  const saveCurrentPlanMeals = async ({ closeModal = false } = {}) => {
    setSavingActiveMealSlots(true);
    try {
      const response = await http.post('/customer/active-meal-slots', {
        selected_meals: activeMealSlots.selected_meals,
        nv_day_veg_slot: activeMealSlots.nv_day_veg_slot
      });
      if (response.data?.ok) {
        setSuccess('Current-plan meal slots updated.');
        setTimeout(() => setSuccess(''), 3000);
        if (closeModal) {
          setShowPreferencesModal(false);
        }
        await loadData();
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update meal slots');
    } finally {
      setSavingActiveMealSlots(false);
    }
  };


  const closePersonalMessageModal = async () => {
    if (currentPersonalMessage) {
      // Mark as read
      await markNotificationRead(currentPersonalMessage.id);
    }
    setShowPersonalMessageModal(false);
    setCurrentPersonalMessage(null);
  };


  const handleRenewalDecision = async (notificationId, decision, label) => {
    setSelectedNotification(notificationId);

    if (decision === 'renew_same') {
      // Auto-fill start date to day after current end date (or next weekday)
      setRenewalFormData(prev => ({ ...prev, newStartDate: renewalStartMin }));
      setShowRenewSameModal(true);
    } else if (decision === 'change_plan') {
      // Auto-fill start date to day after current end date (or next weekday)
      setRenewalFormData(prev => ({ ...prev, newStartDate: renewalStartMin }));
      setShowChangePlanModal(true);
    } else if (decision === 'cancel') {
      // Ask for cancellation reason
      const reason = prompt('Please tell us why you want to cancel your subscription:\n\n(This helps us improve our service)');

      if (!reason || !reason.trim()) {
        alert('Cancellation reason is required. Please try again if you wish to cancel.');
        return;
      }

      if (!confirm('Are you sure you want to cancel your subscription? This will stop your meal deliveries.')) return;

      try {
        const requestData = {
          request_type: 'cancellation',
          requested_changes: {
            decision: 'cancel',
            cancellation_reason: reason.trim(),
            notification_id: notificationId
          },
          notes: `Customer requested cancellation: ${reason.trim()}`
        };

        await http.post('/customer/update-requests', requestData);
        await http.post(`/customer/notifications/${notificationId}/mark-read`);

        alert('⚠️ Cancellation request submitted. Our team will contact you to confirm.');
        loadData();
      } catch (error) {
        console.error('Error submitting cancellation:', error);
        setError(error.response?.data?.message || 'Failed to submit cancellation request. Please try again.');
      }
    }
  };

  const getEffectiveRenewalNvPreference = () => {
    if (renewalFormData.nvPreference) return renewalFormData.nvPreference;
    if (!renewalFormData.mealPlanTerm.includes('Non-Veg')) return '-';
    return renewalFormData.mealPlanType === '2 Meals a Day' ? '1 NV + 1 Veg' : '1 NV/day';
  };

  const isRenewalHybridPlan = () => renewalFormData.mealPlanTerm === '2 Days Non-Veg, 3 Days Veg';

  const submitRenewSame = async () => {
    if (!renewalFormData.newStartDate) {
      setError('Please select a renewal start date');
      return;
    }

    try {
      console.log('Step 1: Sending renewal request...');
      const response = await http.post('/customer/renewal/respond', {
        customer_id: profile?.id,
        response_type: 'renew_same',
        target_date: renewalFormData.newStartDate,
        notes: `Customer confirmed renewal of same plan starting ${renewalFormData.newStartDate}`
      });

      console.log('Step 2: Got response:', response.data);

      if (response.data && response.data.success) {
        console.log('Step 3: Success! Closing modal...');
        setShowRenewSameModal(false);
        setError('');

        // Use notification data from response instead of querying
        const notificationData = response.data.notification_data;

        if (notificationData) {
          console.log('Step 4: Using embedded notification data...');
          setPaymentDetails({
            title: '✅ Renewal Confirmed',
            plan: notificationData.plan,
            totalAmount: notificationData.total_amount,
            renewalDate: notificationData.new_renewal_date,
            etransferEmail: notificationData.etransfer_email,
            customerName: notificationData.customer_name
          });

          console.log('Step 5: Showing payment modal...');
          setShowPaymentModal(true);

          // Mark notification as read after showing modal
          if (selectedNotification) {
            http.post(`/customer/notifications/${selectedNotification}/mark-read`).catch(err =>
              console.log('Failed to mark notification as read:', err)
            );
          }
        } else {
          console.warn('No notification data in response');
          alert('✅ Renewal confirmed! Your plan has been renewed successfully.');
        }

        // Reload customer data to hide renewal reminder
        loadData().catch(err => console.log('Failed to reload data:', err));
      } else {
        setError(response.data.message || 'Failed to submit renewal');
      }
    } catch (error) {
      console.error('Error submitting renewal:', error);
      console.error('Error response:', error.response);
      console.error('Error data:', error.response?.data);
      const errorMsg = error.response?.data?.detail;
      if (typeof errorMsg === 'string') {
        setError(errorMsg);
      } else if (Array.isArray(errorMsg)) {
        // Handle Pydantic validation errors
        const errorText = errorMsg.map(err => `${err.loc?.join('.') || 'field'}: ${err.msg}`).join(', ');
        setError(errorText);
        console.error('Validation errors:', errorText);
      } else if (errorMsg) {
        setError(JSON.stringify(errorMsg));
      } else {
        setError('Failed to submit renewal. Please try again.');
      }
    }
  };

  const submitChangePlan = async () => {
    if (!renewalFormData.mealPlanTerm) {
      setError('Please select a meal plan term');
      return;
    }

    const nvPreference = getEffectiveRenewalNvPreference();
    const isNonVegPlan = renewalFormData.mealPlanTerm.includes('Non-Veg');
    const isHybridPlan = isRenewalHybridPlan();

    if (renewalFormData.mealPlanType === '2 Meals a Day' && (renewalFormData.selectedMeals || []).length !== 2) {
      setError('Please select exactly 2 meal slots for the renewed plan');
      return;
    }

    if (renewalFormData.mealPlanType === '2 Meals a Day' &&
      isNonVegPlan &&
      nvPreference !== 'Both NV' &&
      !(renewalFormData.selectedMeals || []).includes(renewalFormData.nvDayVegSlot)) {
      setError('Please choose which selected slot stays veg on non-veg days');
      return;
    }

    if (isHybridPlan && (renewalFormData.chickenDays || []).length !== 2) {
      setError('Please select exactly 2 non-veg days for the renewed plan');
      return;
    }

    if (renewalFormData.mealPlanType === '3 Meals a Day' && isNonVegPlan) {
      if (isHybridPlan) {
        if (nvPreference === '2 NV/day') {
          if (!renewalFormData.nvDayVegMeal) {
            setError('Please choose the veg meal for non-veg days');
            return;
          }
        } else if ((renewalFormData.nvDayVegMeals || []).length !== 2) {
          setError('Please choose exactly 2 veg meals for non-veg days');
          return;
        }
      } else if (nvPreference === '2 NV/day') {
        if (!renewalFormData.vegMealChoice) {
          setError('Please choose the daily veg meal');
          return;
        }
      } else if ((renewalFormData.dailyVegMeals || []).length !== 2) {
        setError('Please choose exactly 2 daily veg meals');
        return;
      }
    }

    if (!window.confirm('You will be redirected to the Stripe payment interface to complete your plan change. Continue?')) {
      return;
    }

    try {
      const response = await http.post('/customer/renewal/change-plan-checkout', {
        renewal_id: renewalReminder?.renewalId,
        newStartDate: renewalStartMin,
        new_plan_details: {
          new_meal_plan_type: renewalFormData.mealPlanType,
          new_meal_plan_term: renewalFormData.mealPlanTerm,
          new_nv_preference: nvPreference || '-',
          selected_meals: renewalFormData.mealPlanType === '2 Meals a Day'
            ? (renewalFormData.selectedMeals || activeMealSlots.selected_meals || ['Lunch', 'Dinner'])
            : undefined,
          nv_day_veg_slot: renewalFormData.mealPlanType === '2 Meals a Day'
            ? (renewalFormData.nvDayVegSlot || activeMealSlots.nv_day_veg_slot || 'Lunch')
            : undefined,
          chicken_days: isHybridPlan ? renewalFormData.chickenDays : undefined,
          daily_veg_meals: renewalFormData.mealPlanType === '3 Meals a Day' && isNonVegPlan && !isHybridPlan && nvPreference !== '2 NV/day'
            ? renewalFormData.dailyVegMeals
            : undefined,
          veg_meal_choice: renewalFormData.mealPlanType === '3 Meals a Day' && isNonVegPlan && !isHybridPlan && nvPreference === '2 NV/day'
            ? renewalFormData.vegMealChoice
            : undefined,
          nv_day_veg_meal: renewalFormData.mealPlanType === '3 Meals a Day' && isHybridPlan && nvPreference === '2 NV/day'
            ? renewalFormData.nvDayVegMeal
            : undefined,
          nv_day_veg_meals: renewalFormData.mealPlanType === '3 Meals a Day' && isHybridPlan && nvPreference !== '2 NV/day'
            ? renewalFormData.nvDayVegMeals
            : undefined,
          new_billing_term: renewalFormData.planTerm,
          new_add_ons: renewalFormData.addOns
        }
      });

      if (response.data && response.data.success && response.data.url) {
        window.location.href = response.data.url;
      } else {
        setError('Failed to initiate checkout session. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting plan change:', error);
      setError(error.response?.data?.message || 'Failed to submit plan change. Please try again.');
    }
  };

  const handlePayNow = async () => {
    if (!window.confirm('You will be redirected to the Stripe payment interface to complete your renewal. Continue?')) {
      return;
    }
    try {
      setLoading(true);

      const response = await http.post('/renewals/checkout-session', {
        newStartDate: renewalStartMin,
      });

      console.log('Payment response:', response.data);

      if (response.data?.url) {
        window.location.href = response.data.url;
      } else {
        alert('Error: No checkout URL returned from server.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Payment Error:', error);
      alert('Failed to initiate payment: ' + (error.response?.data?.message || error.message));
      setLoading(false);
    }
  };

  const handleCompleteTask = async (taskId) => {
    try {
      await http.put(`/customer/todos/${taskId}/complete`);
      loadData();
    } catch (error) {
      console.error('Error completing task:', error);
      alert('Failed to complete task');
    }
  };

  const handleDeleteTask = async (taskId) => {
    if (!window.confirm('Are you sure you want to delete this task?')) {
      return;
    }

    try {
      await http.delete(`/customer/todos/${taskId}`);
      loadData(); // Reload all data
    } catch (error) {
      console.error('Error deleting task:', error);
      alert('Failed to delete task');
    }
  };

  if (loading && !profile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin mx-auto mb-4 text-orange-500" />
          <p className="text-white">Loading your dashboard...</p>
        </div>
      </div>
    );
  }

  const isTrucker = profile?.planKey?.includes('Truckers');

  // When renewing before end date, new plan must start the day after current end date
  const renewalStartMin = renewalMinStartDate(profile?.planEndDate);

  return (
    <div className="min-h-screen bg-gray-50 pb-20 md:pb-0 relative">
      {/* Dietary Preferences Modal (Moved to Top for Visibility) */}
      {
        showDietaryModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[9999]" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
            <Card className="w-full max-w-lg bg-white max-h-[90vh] overflow-y-auto">
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <MessageSquare className="w-5 h-5 text-orange-500" />
                  Preferences & Feedback
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                {error && (
                  <Alert variant="destructive" className="mb-4">
                    <AlertDescription>{error}</AlertDescription>
                  </Alert>
                )}

                {/* Dynamic Meal Preference Questions */}
                {getPreferenceQuestions().map((q, idx) => (
                  <div key={idx} className="space-y-3 p-4 bg-orange-50 rounded-lg border border-orange-100">
                    <div>
                      <h4 className="font-bold text-gray-900">{q.title}</h4>
                      <p className="text-sm text-gray-600 mb-2">{q.description}</p>
                    </div>

                    {q.type === 'chicken_days' && (
                      <div className="grid grid-cols-2 gap-2">
                        {q.options.map(day => (
                          <div key={day} className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              id={`day-${day}`}
                              className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
                              checked={preferenceFormData.chicken_days?.includes(day)}
                              onChange={(e) => {
                                const current = preferenceFormData.chicken_days || [];
                                let updated;
                                if (e.target.checked) {
                                  if (current.length >= q.required) {
                                    alert(`Please select exactly ${q.required} days.`);
                                    return;
                                  }
                                  updated = [...current, day];
                                } else {
                                  updated = current.filter(d => d !== day);
                                }
                                setPreferenceFormData({ ...preferenceFormData, chicken_days: updated });
                              }}
                            />
                            <label htmlFor={`day-${day}`} className="text-sm font-medium text-gray-700">
                              {day}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}

                    {(q.type === 'single_meal' || q.type === 'two_meals') && (
                      <div className="flex flex-wrap gap-4">
                        {q.options.map(meal => {
                          const isSelected = q.type === 'single_meal'
                            ? preferenceFormData[q.key] === meal
                            : preferenceFormData[q.key]?.includes(meal);

                          return (
                            <div key={meal} className="flex items-center space-x-2">
                              <input
                                type={q.type === 'single_meal' ? 'radio' : 'checkbox'}
                                name={q.key}
                                id={`${q.key}-${meal}`}
                                className={`h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 ${q.type === 'single_meal' ? 'rounded-full' : 'rounded'}`}
                                checked={isSelected || false}
                                onChange={(e) => {
                                  if (q.type === 'single_meal') {
                                    setPreferenceFormData({ ...preferenceFormData, [q.key]: meal });
                                  } else {
                                    const current = preferenceFormData[q.key] || [];
                                    let updated;
                                    if (e.target.checked) {
                                      if (current.length >= q.required) {
                                        alert(`Please select exactly ${q.required} meals.`);
                                        return;
                                      }
                                      updated = [...current, meal];
                                    } else {
                                      updated = current.filter(m => m !== meal);
                                    }
                                    setPreferenceFormData({ ...preferenceFormData, [q.key]: updated });
                                  }
                                }}
                              />
                              <label htmlFor={`${q.key}-${meal}`} className="text-sm font-medium text-gray-700">
                                {meal}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ))}

                <div className="space-y-2">
                  <Label>Food Preferences / Goals</Label>
                  <textarea
                    className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    placeholder="e.g. Low Carb, High Protein, Keto, etc."
                    value={dietaryFormData.foodPreferences}
                    onChange={(e) => setDietaryFormData({ ...dietaryFormData, foodPreferences: e.target.value })}
                  />
                </div>
                <div className="space-y-2">
                  <Label>Ingredients to Avoid</Label>
                  <textarea
                    className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    placeholder="e.g. Mushrooms, Bell Peppers, Cilantro"
                    value={dietaryFormData.ingredientsToAvoid}
                    onChange={(e) => setDietaryFormData({ ...dietaryFormData, ingredientsToAvoid: e.target.value })}
                  />
                </div>
                <div className="space-y-2">
                  <Label className="text-red-500 font-bold">Allergies (Critical)</Label>
                  <textarea
                    className="flex min-h-[80px] w-full rounded-md border-2 border-red-200 focus:border-red-500 bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    placeholder="List any allergies here..."
                    value={dietaryFormData.allergyInfo}
                    onChange={(e) => setDietaryFormData({ ...dietaryFormData, allergyInfo: e.target.value })}
                  />
                </div>
                <div className="space-y-2">
                  <Label>General Feedback / Notes</Label>
                  <textarea
                    className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    placeholder="Any feedback on meals, delivery, or general experience?"
                    value={dietaryFormData.generalFeedback}
                    onChange={(e) => setDietaryFormData({ ...dietaryFormData, generalFeedback: e.target.value })}
                  />
                </div>

                <div className="flex justify-end gap-3 pt-4">
                  <Button variant="outline" onClick={() => setShowDietaryModal(false)}>Cancel</Button>
                  <Button
                    className="bg-orange-500 hover:bg-orange-600 text-white"
                    onClick={handleSaveDietaryPreferences}
                    disabled={savingPreferences}
                  >
                    {savingPreferences ? 'Saving...' : 'Save Preferences'}
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        )
      }
      {/* Header - Mobile Responsive */}
      <div className="bg-black text-white py-3 sm:py-4 px-4 sm:px-6 shadow-xl">
        <div className="container mx-auto sm:flex sm:items-center sm:justify-between">
          {/* First Row: Logo and Title */}
          <div className="flex items-center gap-2 sm:gap-4 mb-3 sm:mb-0">
            <div className="relative">
              {/* Glow effect behind logo */}
              <div className="absolute inset-0 bg-[#FF6A00] rounded-full blur-lg opacity-40"></div>
              {/* Logo container */}
              <div className="relative bg-white rounded-full p-1 border-2 border-[#FF6A00] shadow-[0_0_15px_rgba(255,106,0,0.4)]">
                <img
                  src="/images/just-protein-logo.png"
                  alt="Just Protein Logo"
                  className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
                />
              </div>
            </div>
            <div className="flex-1">
              <h1 className="text-xl sm:text-2xl font-bold text-white">Just Protein</h1>
              <p className="text-xs sm:text-sm text-gray-300">Customer Dashboard</p>
            </div>
            {/* Logout Button - Mobile */}
            <button
              onClick={handleLogout}
              className="sm:hidden p-2 hover:bg-orange-600 rounded-full transition-colors"
              title="Logout"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>

          {/* Second Row: Action Buttons */}
          <div className="flex flex-wrap items-center gap-2 justify-end">
            {/* Set Preferences Button */}
            {profile && (
              <>

                <Button
                  size="sm"
                  className="bg-orange-500 hover:bg-orange-600 text-white font-medium h-8 px-2 text-xs"
                  onClick={() => openMealPreferencesModal()}
                >
                  <Utensils className="w-3 h-3 sm:w-4 sm:h-4 sm:mr-2" />
                  <span className="hidden sm:inline">Set Preferences</span>
                </Button>
              </>
            )}

            {/* Submit Request Button */}
            <Button
              size="sm"
              className="bg-orange-500 hover:bg-orange-600 text-white font-medium h-8 px-2 text-xs"
              onClick={() => setShowRequestModal(true)}
            >
              <MessageSquare className="w-3 h-3 sm:w-4 sm:h-4 sm:mr-2" />
              <span className="hidden sm:inline">Submit Request</span>
              <span className="inline sm:hidden">Request</span>
            </Button>

            {/* Notification Bell */}
            <button
              onClick={() => setShowNotifications(!showNotifications)}
              className="relative p-2 hover:bg-orange-600 rounded-full transition-colors h-8 w-8 flex items-center justify-center"
            >
              <Bell className="w-4 h-4" />
              {unreadCount > 0 && (
                <span className="absolute top-0 right-0 bg-black text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {unreadCount}
                </span>
              )}
            </button>

            <Button
              size="sm"
              className="hidden sm:flex bg-orange-500 hover:bg-orange-600 text-white font-medium h-8 px-2 text-xs items-center gap-1"
              onClick={handleLogout}
            >
              <LogOut className="w-3 h-3 sm:w-4 sm:h-4" />
              <span className="hidden sm:inline">Logout</span>
            </Button>
          </div>
        </div>
      </div >

      {/* Notification Dropdown */}
      {
        showNotifications && (
          <>
            {/* Backdrop overlay */}
            <div
              className="fixed inset-0 bg-black bg-opacity-20 z-40"
              onClick={() => setShowNotifications(false)}
            ></div>

            {/* Dropdown */}
            <div
              ref={notificationRef}
              className="fixed right-4 sm:right-6 top-16 sm:top-20 w-[calc(100vw-2rem)] sm:w-96 max-w-md bg-white shadow-xl rounded-lg border z-50 max-h-[70vh] overflow-y-auto"
            >
              {notifications.length === 0 ? (
                <div className="p-6 text-center text-gray-700">
                  <Bell className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                  <p>No notifications</p>
                </div>
              ) : (
                <>
                  {/* Regular Notifications */}
                  {notifications.map((notif) => (
                    <div
                      key={notif.id}
                      className={`p-4 border-b hover:bg-white ${notif.status === 'unread' ? 'bg-orange-50' : ''
                        }`}
                    >
                      <div className="flex justify-between items-start mb-2">
                        <p className="font-semibold text-sm">{notif.title}</p>
                        {notif.status === 'unread' && (
                          <span className="px-2 py-1 bg-orange-500 text-white text-xs rounded-full">New</span>
                        )}
                      </div>
                      <p className="text-sm text-gray-700 mb-2 whitespace-pre-line">{notif.message}</p>
                      <p className="text-xs text-gray-400">{new Date(notif.created_at).toLocaleString()}</p>

                      {/* Renewal Reminder Actions */}
                      {notif.type === 'renewal_reminder' && notif.data?.actions && notif.status === 'unread' && (
                        <div className="mt-4 space-y-2">
                          <p className="text-xs font-medium text-gray-700 mb-2">Choose an option:</p>
                          {notif.data.actions.map((action) => (
                            <button
                              key={action.type}
                              onClick={() => handleRenewalDecision(notif.id, action.type, action.label)}
                              className={`w-full px-3 py-2 text-sm rounded font-medium transition-colors ${action.type === 'renew_same' ? 'bg-orange-500 hover:bg-orange-600 text-white border-2 border-black' :
                                action.type === 'change_plan' ? 'bg-black hover:bg-gray-900 text-white border-2 border-orange-500' :
                                  'bg-orange-500 hover:bg-orange-600 text-white border-2 border-black'
                                }`}
                            >
                              {action.label}
                            </button>
                          ))}
                        </div>
                      )}

                      {/* View photo if available */}
                      {notif.data?.delivery_photo && (
                        <img
                          src={notif.data.delivery_photo}
                          alt="Delivery"
                          className="mt-2 w-full h-32 object-cover rounded"
                        />
                      )}

                      <div className="flex gap-2 mt-2">
                        {notif.status === 'unread' && notif.type !== 'renewal_reminder' && (
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => markNotificationRead(notif.id)}
                          >
                            Mark as Read
                          </Button>
                        )}
                        <Button
                          size="sm"
                          variant="destructive"
                          className="bg-red-600 hover:bg-red-700 text-white"
                          onClick={() => deleteNotification(notif.id)}
                        >
                          Delete
                        </Button>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </>
        )
      }

      {/* Main Content */}
      <div className="container mx-auto px-6 py-8">
        {/* Payment Pending Alert */}
        {/* Payment Pending Alert */}
        {(profile?.payment?.status === 'Pending' || profile?.status === 'pending_payment') && (
          <div className="mb-6 bg-orange-50 border-l-4 border-[#FF6A00] p-4 rounded shadow-sm flex items-start justify-between">
            <div className="flex items-start">
              <DollarSign className="w-6 h-6 text-[#FF6A00] mr-3 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="text-lg font-bold text-gray-900">Payment Pending</h3>
                <p className="text-gray-700 mt-1">
                  Your account is active, but we haven't received your payment yet.
                  Please send an e-transfer to <strong>justproteinca@gmail.com</strong> to avoid service interruption.
                </p>
                <div className="mt-2 text-sm text-gray-600">
                  <span className="font-semibold">Amount Due:</span> ${profile?.payment?.amountPaid || profile?.totalAmount || '0.00'}
                </div>
              </div>
            </div>
            <Button
              className="bg-[#FF6A00] hover:bg-[#e55f00] text-white ml-4 whitespace-nowrap"
              onClick={() => {
                setPaymentDetails({
                  title: 'Complete Your Payment',
                  plan: profile?.plan?.name || profile?.planKey || 'Meal Plan',
                  totalAmount: profile?.payment?.amountPaid || profile?.totalAmount || '0.00',
                  renewalDate: new Date().toLocaleDateString(),
                  etransferEmail: 'justproteinca@gmail.com',
                  customerName: profile?.firstName || 'Customer'
                });
                setShowPaymentModal(true);
              }}
            >
              Pay Now
            </Button>
          </div>
        )}

        {/* Broadcast Messages Banner - At very top */}
        {broadcasts.length > 0 && (
          <div className="mb-6 space-y-3">
            {broadcasts.map(broadcast => (
              <div key={broadcast.id} className="bg-orange-50 border-l-4 border-l-black px-6 py-4 rounded-lg shadow-sm">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-black font-semibold text-lg">📢 Announcement</span>
                      <span className="text-xs text-orange-500 bg-orange-100 px-2 py-1 rounded">
                        Expires: {new Date(broadcast.expiryDate).toLocaleDateString()}
                      </span>
                    </div>
                    <p className="text-gray-800 text-base">{broadcast.message}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {error && (
          <div className="mb-6 bg-orange-50 border-2 border-black text-black px-4 py-3 rounded">
            ⚠️ <strong>Action Required:</strong> {error}
          </div>
        )}

        {success && (
          <div className="mb-6 bg-orange-50 border-2 border-black text-black px-4 py-3 rounded">
            {success}
          </div>
        )}

        {/* Welcome Message */}
        <div className="mb-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
                Hello, {profile?.firstName || profile?.fullName?.split(' ')[0] || 'Customer'}!
              </h2>
              <p className="text-gray-600 mt-1 text-sm sm:text-base">Welcome to your dashboard — where transformation begins</p>
            </div>
            {/* Payment Status Badge */}
            {profile?.paymentStatus && (
              <div className={`px-4 py-2 rounded-lg font-semibold text-sm sm:text-base whitespace-nowrap ${profile.paymentStatus === 'Paid'
                ? 'bg-orange-100 text-black border-2 border-black'
                : 'bg-white text-orange-500 border-2 border-orange-500'
                }`}>
                {profile.paymentStatus === 'Paid' ? '✅ Payment: Paid' : '⏳ Payment: Pending'}
              </div>
            )}
          </div>
        </div>

        {/* Renewal Reminder Banner */}
        {renewalReminder && renewalReminder.isPendingRenewal ? (
          /* Pending Renewal Confirmation — no action buttons needed */
          <Card className="mb-6 border-l-4 shadow-md bg-green-50 border-l-green-500">
            <CardHeader className="pb-2">
              <CardTitle className="text-xl flex items-center gap-2 text-green-800">
                Renewal Confirmed
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-800 font-medium mb-3">{renewalReminder.message}</p>
              <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 items-center">
                <div>
                  <p className="text-sm text-gray-600">New Plan</p>
                  <p className="font-bold text-gray-900">{renewalReminder.planKey}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Starts On</p>
                  <p className="font-bold text-gray-900">{renewalReminder.renewalDate}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ) : renewalReminder && (
          <Card className={`mb-6 border-l-4 shadow-md ${renewalReminder.daysUntilRenewal <= 0 ? 'bg-red-50 border-l-red-600' :
            renewalReminder.daysUntilRenewal <= 1 ? 'bg-orange-50 border-l-orange-500' :
              'bg-blue-50 border-l-blue-500'
            }`}>
            <CardHeader className="pb-2">
              <CardTitle className={`text-xl flex items-center gap-2 ${renewalReminder.daysUntilRenewal <= 0 ? 'text-red-800' :
                renewalReminder.daysUntilRenewal <= 1 ? 'text-orange-800' :
                  'text-blue-800'
                }`}>
                {renewalReminder.daysUntilRenewal <= 0 ? <span className="animate-pulse">⚠️ Payment Overdue</span> :
                  renewalReminder.daysUntilRenewal === 1 ? '⏰ Renewal Due Tomorrow' :
                    'ℹ️ Upcoming Renewal'}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-800 font-medium mb-3">{renewalReminder.message}</p>

              <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 items-center">
                <div>
                  <p className="text-sm text-gray-600">Plan</p>
                  <p className="font-bold text-gray-900">{renewalReminder.planKey}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">End Date</p>
                  <p className="font-bold text-gray-900">{renewalReminder.renewalDate}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Amount Due</p>
                  <p className="text-xs text-gray-500">Before tax: ${getBasePrice(renewalReminder.totalAmount)}</p>
                  <p className="text-xs text-gray-500">HST (13%): ${getHSTAmount(renewalReminder.totalAmount)}</p>
                  <p className="font-bold text-gray-900 text-lg">${formatPrice(renewalReminder.totalAmount)}</p>
                </div>
                <div className="flex flex-col gap-2 w-full col-span-2 md:col-span-1 md:w-auto md:min-w-[200px]">
                  <Button
                    onClick={handlePayNow}
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-bold shadow-sm"
                  >
                    Pay Now (Renew Same)
                  </Button>
                  <Button
                    onClick={() => {
                      if (renewalReminder.notificationId) {
                        handleRenewalDecision(renewalReminder.notificationId, 'change_plan', 'Change Plan');
                      } else {
                        setShowChangePlanModal(true);
                      }
                    }}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium shadow-sm"
                  >
                    Change Plan / Preferences
                  </Button>
                  {renewalReminder.notificationId && (
                    <Button
                      onClick={() => handleRenewalDecision(renewalReminder.notificationId, 'cancel', 'Cancel Plan')}
                      variant="destructive"
                      className="w-full bg-red-500 hover:bg-red-600 text-white font-medium shadow-sm"
                    >
                      Cancel Plan
                    </Button>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        )}

        {/* Tabs - Professional Icon Design */}
        <div className="bg-white rounded-xl shadow-lg border-2 border-gray-100 p-2 mb-6">
          <div className={`grid ${isTrucker ? 'grid-cols-2' : 'grid-cols-3 sm:grid-cols-6'} gap-2`}>
            <button
              onClick={() => setActiveTab('overview')}
              className={`relative flex flex-col items-center justify-center p-4 rounded-lg font-semibold transition-all transform ${activeTab === 'overview'
                ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-lg scale-105'
                : 'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-black hover:scale-102'
                }`}
            >
              <Home className="w-6 h-6 mb-1" />
              <span className="text-xs sm:text-sm font-bold">Overview</span>
              {activeTab === 'overview' && (
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-3 h-3 bg-orange-500 rotate-45"></div>
              )}
            </button>
            {!isTrucker && (<>
              <button
                onClick={() => setActiveTab('productivity')}
                className={`relative flex flex-col items-center justify-center p-4 rounded-lg font-semibold transition-all transform ${activeTab === 'productivity'
                  ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-lg scale-105'
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-black hover:scale-102'
                  }`}
              >
                <Sparkles className="w-6 h-6 mb-1" />
                <span className="text-xs sm:text-sm font-bold">Reflection</span>
                {activeTab === 'productivity' && (
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-3 h-3 bg-orange-500 rotate-45"></div>
                )}
              </button>
              <button
                onClick={() => setActiveTab('workmode')}
                className={`relative flex flex-col items-center justify-center p-4 rounded-lg font-semibold transition-all transform ${activeTab === 'workmode'
                  ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-lg scale-105'
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-black hover:scale-102'
                  }`}
              >
                <Briefcase className="w-6 h-6 mb-1" />
                <span className="text-xs sm:text-sm font-bold">Work</span>
                {Array.isArray(todos) && todos.filter(t => !t.completed).length > 0 && activeTab !== 'workmode' && (
                  <div className="absolute top-1 right-1 bg-orange-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                    {todos.filter(t => !t.completed).length}
                  </div>
                )}
                {activeTab === 'workmode' && (
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-3 h-3 bg-orange-500 rotate-45"></div>
                )}
              </button>
              <button
                onClick={() => setActiveTab('gymmode')}
                className={`relative flex flex-col items-center justify-center p-4 rounded-lg font-semibold transition-all transform ${activeTab === 'gymmode'
                  ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-lg scale-105'
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-black hover:scale-102'
                  }`}
              >
                <Dumbbell className="w-6 h-6 mb-1" />
                <span className="text-xs sm:text-sm font-bold">Gym</span>
                {activeTab === 'gymmode' && (
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-3 h-3 bg-orange-500 rotate-45"></div>
                )}
              </button>
              <button
                onClick={() => {
                  setActiveTab('measurements');
                  loadMeasurements();
                }}
                className={`relative flex flex-col items-center justify-center p-4 rounded-lg font-semibold transition-all transform ${activeTab === 'measurements'
                  ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-lg scale-105'
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-black hover:scale-102'
                  }`}
              >
                <Ruler className="w-6 h-6 mb-1" />
                <span className="text-xs sm:text-sm font-bold">Measures</span>
                {activeTab === 'measurements' && (
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-3 h-3 bg-orange-500 rotate-45"></div>
                )}
              </button>
            </>)}
            <button
              onClick={() => setActiveTab('myplan')}
              className={`relative flex flex-col items-center justify-center p-4 rounded-lg font-semibold transition-all transform ${activeTab === 'myplan'
                ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-lg scale-105'
                : 'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-black hover:scale-102'
                }`}
            >
              <FileText className="w-6 h-6 mb-1" />
              <span className="text-xs sm:text-sm font-bold">My Plan</span>
              {activeTab === 'myplan' && (
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-3 h-3 bg-orange-500 rotate-45"></div>
              )}
            </button>
          </div>
        </div>

        {/* Overview Tab Content */}
        {activeTab === 'overview' && (
          <div className="space-y-6">
            {/* Power Quote of the Day */}
            <Card className="bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-xl border-2 border-orange-400">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <Star className="w-8 h-8 text-white flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="text-xl font-bold mb-2">Power Quote</h3>
                    <p className="text-lg italic leading-relaxed">
                      {powerQuote?.quote || "Success is not final, failure is not fatal: it is the courage to continue that counts."}
                    </p>
                    <p className="text-sm mt-3 text-orange-100">
                      Best wishes by Team Just Protein
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* My Meals — Current Plan 2-Meal Selection */}
            {!isTrucker && activeMealSlots.plan_context?.is2MealPlan && activeMealSlots.editable && (
              <Card className="bg-white border-2 border-orange-200 shadow-md">
                <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <Utensils className="w-4 h-4 text-orange-500" />
                    My 2-Meal Plan
                    <span className="text-xs bg-orange-500 text-white px-2 py-0.5 rounded ml-auto">Active Cycle</span>
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 space-y-4">
                  <p className="text-xs text-gray-500">
                    Changes here apply to all remaining delivery days in your current cycle.
                  </p>
                  <div className="flex gap-3">
                    {['Breakfast', 'Lunch', 'Dinner'].map((meal) => {
                      const isSelected = activeMealSlots.selected_meals.includes(meal);
                      const atMax = activeMealSlots.selected_meals.length >= 2 && !isSelected;
                      return (
                        <label key={meal} className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm ${atMax ? 'opacity-50' : ''}`}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            disabled={savingActiveMealSlots || atMax}
                            onChange={(e) => {
                              const currentMeals = activeMealSlots.selected_meals || [];
                              const selectedMeals = e.target.checked
                                ? [...currentMeals, meal]
                                : currentMeals.filter(item => item !== meal);
                              const nextVegSlot = selectedMeals.includes(activeMealSlots.nv_day_veg_slot)
                                ? activeMealSlots.nv_day_veg_slot
                                : (selectedMeals[0] || '');
                              setActiveMealSlots({
                                ...activeMealSlots,
                                selected_meals: selectedMeals,
                                nv_day_veg_slot: nextVegSlot
                              });
                            }}
                            className="h-4 w-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500"
                          />
                          <span>{meal}</span>
                        </label>
                      );
                    })}
                  </div>

                  {activeMealSlots.plan_context?.nvMealsPerDay === 1 && !activeMealSlots.plan_context?.isVegPlan && (
                    <div className="space-y-2">
                      <p className="text-sm font-medium text-gray-900">On non-veg days, which selected slot stays veg?</p>
                      <div className="flex gap-3">
                        {(activeMealSlots.selected_meals || []).map((meal) => (
                          <label key={meal} className="flex items-center gap-2 rounded-lg border px-3 py-2 text-sm">
                            <input
                              type="radio"
                              name="active_nv_day_veg_slot"
                              checked={activeMealSlots.nv_day_veg_slot === meal}
                              onChange={() => setActiveMealSlots({
                                ...activeMealSlots,
                                nv_day_veg_slot: meal
                              })}
                              className="h-4 w-4 border-gray-300 text-orange-600 focus:ring-orange-500"
                            />
                            <span>{meal}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}

                  {activeMealSlots.summary_text && (
                    <div className="rounded-lg border border-gray-200 bg-gray-50 p-3 text-xs text-gray-600">
                      {activeMealSlots.summary_text}
                    </div>
                  )}

                  <Button
                    className="bg-orange-500 hover:bg-orange-600 text-white"
                    disabled={
                      savingActiveMealSlots ||
                      (activeMealSlots.selected_meals || []).length !== 2 ||
                      (activeMealSlots.plan_context?.nvMealsPerDay === 1 &&
                        !activeMealSlots.plan_context?.isVegPlan &&
                        !(activeMealSlots.selected_meals || []).includes(activeMealSlots.nv_day_veg_slot))
                    }
                    onClick={() => saveCurrentPlanMeals()}
                  >
                    {savingActiveMealSlots ? 'Saving...' : 'Save Current Plan Meals'}
                  </Button>
                </CardContent>
              </Card>
            )}

            {/* My Meals — Daily B/L/D Selection (legacy 3-meal flow) */}
            {!isTrucker && !activeMealSlots.plan_context?.is2MealPlan && dailyMeals.length > 0 && (
              <Card className="bg-white border-2 border-orange-200 shadow-md">
                <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <Utensils className="w-4 h-4 text-orange-500" />
                    My Meals — Next 2 Days
                    <span className="text-xs bg-orange-500 text-white px-2 py-0.5 rounded ml-auto">{dailyMealsPlanType} Plan</span>
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4">
                  <p className="text-xs text-gray-500 mb-3">
                    {dailyMealsMax === 3
                      ? 'Your plan includes Breakfast, Lunch & Dinner. Changes must be made 24hrs before delivery.'
                      : 'Select any 2 meals per day. Changes must be made 24hrs before delivery.'}
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {dailyMeals.map((day) => (
                      <div key={day.date} className={`p-4 rounded-lg border-2 ${!day.editable ? 'border-gray-200 bg-gray-50' : 'border-orange-200 bg-orange-50'}`}>
                        <div className="flex items-center justify-between mb-3">
                          <div>
                            <p className="font-bold text-gray-900">{day.day_name}</p>
                            <p className="text-xs text-gray-500">{day.date}</p>
                          </div>
                          {!day.editable && (
                            <span className="text-xs bg-gray-200 text-gray-600 px-2 py-1 rounded">🔒 Locked</span>
                          )}
                          {day.is_override && day.editable && (
                            <span className="text-xs bg-orange-200 text-orange-700 px-2 py-1 rounded">Custom</span>
                          )}
                        </div>
                        <div className="flex gap-3">
                          {['Breakfast', 'Lunch', 'Dinner'].map((meal) => {
                            const isSelected = day.meals.includes(meal);
                            const atMax = day.meals.length >= dailyMealsMax && !isSelected;
                            return (
                              <label key={meal} className={`flex items-center gap-1.5 cursor-pointer select-none ${!day.editable || atMax ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                <input
                                  type="checkbox"
                                  className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
                                  checked={isSelected}
                                  disabled={!day.editable || savingDailyMeals === day.date || atMax}
                                  onChange={(e) => {
                                    const updated = dailyMeals.map(d => {
                                      if (d.date !== day.date) return d;
                                      const newMeals = e.target.checked
                                        ? [...d.meals, meal]
                                        : d.meals.filter(m => m !== meal);
                                      return { ...d, meals: newMeals, is_override: true };
                                    });
                                    setDailyMeals(updated);
                                  }}
                                />
                                <span className="text-sm font-medium text-gray-700">{meal.charAt(0)}</span>
                              </label>
                            );
                          })}
                        </div>
                        {day.editable && (
                          <Button
                            size="sm"
                            className="mt-3 w-full bg-orange-500 hover:bg-orange-600 text-white text-xs h-8"
                            disabled={day.meals.length === 0 || savingDailyMeals === day.date}
                            onClick={async () => {
                              if (day.meals.length === 0) { setError('Select at least one meal'); return; }
                              setSavingDailyMeals(day.date);
                              try {
                                await http.post('/customer/daily-meals', { date: day.date, meals: day.meals });
                                setSuccess(`Meals saved for ${day.day_name}`);
                                setTimeout(() => setSuccess(''), 3000);
                              } catch (err) {
                                setError(err.response?.data?.message || 'Failed to save meals');
                              } finally {
                                setSavingDailyMeals(null);
                              }
                            }}
                          >
                            {savingDailyMeals === day.date ? 'Saving...' : 'Save'}
                          </Button>
                        )}
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            )}

            {/* Profile & Delivery Details (Restored) */}
            <Card className="bg-white border-2 border-orange-200 shadow-md">
              <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                <CardTitle className="text-base flex items-center gap-2 text-white">
                  <User className="w-4 h-4 text-orange-500" />
                  Profile & Delivery Details
                </CardTitle>
              </CardHeader>
              <CardContent className="p-4 space-y-3">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs text-gray-500">Name</p>
                    <p className="text-sm font-semibold text-gray-900">
                      {profile?.firstName} {profile?.lastName}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Phone</p>
                    <p className="text-sm font-semibold text-gray-900">{profile?.phone || 'N/A'}</p>
                  </div>
                </div>
                <div className="border-t pt-2">
                  <p className="text-xs text-gray-500">Delivery Address</p>
                  <p className="text-sm font-semibold text-gray-900 mt-0.5">
                    {profile?.address?.street}<br />
                    {profile?.address?.city}, {profile?.address?.postalCode}
                  </p>
                </div>
                {profile?.address?.deliveryInstructions && (
                  <div className="bg-gray-50 p-2 rounded text-xs mt-2 border border-gray-200">
                    <p className="font-semibold text-gray-600 mb-1">Instructions:</p>
                    <p className="text-gray-800 italic">"{profile.address.deliveryInstructions}"</p>
                  </div>
                )}
              </CardContent>
            </Card>

            {/* This Week's Menu */}
            {weeklyMenu && weeklyMenu.length > 0 && (
              <Card className="bg-white border-2 border-orange-200 shadow-lg">
                <CardHeader className="bg-gradient-to-r from-orange-500 to-orange-600">
                  <CardTitle className="flex items-center gap-2 text-white">
                    <Calendar className="w-5 h-5 text-white" />
                    This Week's Menu
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4">
                  {/* Day Selector */}
                  <div className="flex gap-2 overflow-x-auto pb-4 mb-2 no-scrollbar">
                    {weeklyMenu.map((day, idx) => {
                      const todayName = new Date().toLocaleDateString('en-US', { weekday: 'long' });
                      const isSelected = selectedWeeklyDay?.day === day.day;
                      const isToday = day.day === todayName;

                      return (
                        <button
                          key={idx}
                          onClick={() => setSelectedWeeklyDay(day)}
                          className={`flex-shrink-0 px-4 py-2 rounded-lg border-2 transition-all ${isSelected
                            ? 'bg-orange-500 border-orange-600 text-white shadow-md'
                            : 'bg-white border-gray-200 text-gray-700 hover:border-orange-300'
                            }`}
                        >
                          <div className="text-xs font-bold uppercase mb-0.5 opacity-80">
                            {day.day.slice(0, 3)}
                          </div>
                          {isToday && (
                            <div className="text-[10px] mt-1 bg-white text-orange-600 rounded px-1 font-bold">TODAY</div>
                          )}
                        </button>
                      );
                    })}
                  </div>

                  {/* Selected Day Menu Display */}
                  {selectedWeeklyDay ? (() => {
                    const dayName = selectedWeeklyDay.day?.toLowerCase();
                    const hasPrefs = !!preferences?.vegType;
                    const isNonVegDay = !hasPrefs ||
                      preferences.vegType === '5_days_nonveg' ||
                      (preferences.vegType === '2NV_3V' && preferences.nvDays?.includes(dayName));
                    const nvCount = hasPrefs ? (preferences.nvMealCount || 0) : 2;
                    const showNonVeg1 = isNonVegDay && nvCount >= 1;
                    const showNonVeg2 = isNonVegDay && nvCount >= 2;

                    return (
                    <div className="space-y-3 animate-in fade-in duration-300">
                      {selectedWeeklyDay.breakfast?.name && (
                        <div className="flex gap-4 p-3 bg-gray-50 rounded border border-gray-100">
                          <div>
                            <span className="text-xs font-bold text-orange-500 uppercase tracking-wide">Breakfast</span>
                            <h4 className="font-bold text-gray-900">{selectedWeeklyDay.breakfast.name}</h4>
                            <p className="text-xs text-gray-500 mt-1">
                              {selectedWeeklyDay.breakfast.protein}g Pro • {selectedWeeklyDay.breakfast.calories} Cal
                            </p>
                          </div>
                        </div>
                      )}

                      {selectedWeeklyDay.lunch?.name && (
                        <div className="flex gap-4 p-3 bg-gray-50 rounded border border-gray-100">
                          <div>
                            <span className="text-xs font-bold text-orange-500 uppercase tracking-wide">Lunch</span>
                            <h4 className="font-bold text-gray-900">{selectedWeeklyDay.lunch.name}</h4>
                            <p className="text-xs text-gray-500 mt-1">
                              {selectedWeeklyDay.lunch.protein}g Pro • {selectedWeeklyDay.lunch.calories} Cal
                            </p>
                          </div>
                        </div>
                      )}

                      {selectedWeeklyDay.dinner?.name && (
                        <div className="flex gap-4 p-3 bg-gray-50 rounded border border-gray-100">
                          <div>
                            <span className="text-xs font-bold text-orange-500 uppercase tracking-wide">Dinner</span>
                            <h4 className="font-bold text-gray-900">{selectedWeeklyDay.dinner.name}</h4>
                            <p className="text-xs text-gray-500 mt-1">
                              {selectedWeeklyDay.dinner.protein}g Pro • {selectedWeeklyDay.dinner.calories} Cal
                            </p>
                          </div>
                        </div>
                      )}

                      {showNonVeg1 && selectedWeeklyDay.nonveg_item?.name && (
                        <div className="flex gap-4 p-3 bg-orange-50 rounded border border-orange-100">
                          <div>
                            <span className="text-xs font-bold text-orange-600 uppercase tracking-wide">Non-Veg Option</span>
                            <h4 className="font-bold text-gray-900">{selectedWeeklyDay.nonveg_item.name}</h4>
                            <p className="text-xs text-gray-500 mt-1">
                              {selectedWeeklyDay.nonveg_item.protein}g Pro • {selectedWeeklyDay.nonveg_item.calories} Cal
                            </p>
                          </div>
                        </div>
                      )}

                      {showNonVeg2 && selectedWeeklyDay.nonveg_item_2?.name && (
                        <div className="flex gap-4 p-3 bg-orange-50 rounded border border-orange-100">
                          <div>
                            <span className="text-xs font-bold text-orange-600 uppercase tracking-wide">Non-Veg Option 2</span>
                            <h4 className="font-bold text-gray-900">{selectedWeeklyDay.nonveg_item_2.name}</h4>
                            <p className="text-xs text-gray-500 mt-1">
                              {selectedWeeklyDay.nonveg_item_2.protein}g Pro • {selectedWeeklyDay.nonveg_item_2.calories} Cal
                            </p>
                          </div>
                        </div>
                      )}

                      {!selectedWeeklyDay.breakfast?.name && !selectedWeeklyDay.lunch?.name && !selectedWeeklyDay.dinner?.name && !(showNonVeg1 && selectedWeeklyDay.nonveg_item?.name) && !(showNonVeg2 && selectedWeeklyDay.nonveg_item_2?.name) && (
                        <div className="text-center py-6 text-gray-500 bg-gray-50 rounded italic text-sm">
                          No menu set for this day yet.
                        </div>
                      )}
                    </div>
                    );
                  })() : (
                    <div className="text-center py-6 text-gray-500 text-sm">Select a day to view menu</div>
                  )}
                </CardContent>
              </Card>
            )}

            {/* Current Plan & Status (Restored) */}
            <Card className="bg-white border-2 border-orange-200 shadow-md">
              <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                <CardTitle className="text-base flex items-center gap-2 text-white">
                  <Activity className="w-4 h-4 text-orange-500" />
                  Current Plan Status
                </CardTitle>
              </CardHeader>
              <CardContent className="p-4 space-y-3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-orange-50 p-3 rounded border-l-4 border-orange-500">
                    <p className="text-xs text-gray-600 font-semibold mb-1">Current Plan</p>
                    <p className="font-semibold text-gray-900 text-sm">{profile?.planKey || 'N/A'}</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded border-l-4 border-gray-400">
                    <p className="text-xs text-gray-600 font-semibold mb-1">Status</p>
                    <div className="flex items-center gap-2">
                      <span className={`w-2 h-2 rounded-full ${profile?.status === 'Active' || profile?.status === 'active' ? 'bg-green-500' :
                        profile?.status === 'upcoming' ? 'bg-blue-500' :
                          profile?.status === 'pending_payment' ? 'bg-yellow-500' :
                            profile?.status === 'Paused' || profile?.status === 'paused' ? 'bg-orange-500' : 'bg-red-500'
                        }`}></span>
                      <span className={`text-sm font-bold ${profile?.status === 'Active' || profile?.status === 'active' ? 'text-green-700' :
                        profile?.status === 'upcoming' ? 'text-blue-700' :
                          profile?.status === 'pending_payment' ? 'text-yellow-700' :
                            profile?.status === 'Paused' || profile?.status === 'paused' ? 'text-orange-700' : 'text-red-700'
                        }`}>
                        {profile?.status === 'upcoming'
                          ? `Upcoming (Starts ${profile?.planStartDate || 'Soon'})`
                          : profile?.status === 'pending_payment' ? 'Pending Payment' : (profile?.status || 'Active')}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-3 mt-2">
                  <div className="bg-white p-2 rounded border border-gray-200">
                    <p className="text-xs text-gray-500">End Date</p>
                    <p className="text-sm font-semibold text-gray-900">
                      {formatDateWithoutTimezone(profile?.planEndDate)}
                    </p>
                  </div>
                  <div className="bg-white p-2 rounded border border-gray-200">
                    <p className="text-xs text-gray-500">Last Payment</p>
                    <p className="text-sm font-bold text-gray-900">${profile?.lastPaymentAmount || profile?.totalAmount || '0'}</p>
                  </div>
                </div>

                {profile?.addOns && profile.addOns.length > 0 && (
                  <div className="pt-2">
                    <p className="text-xs text-gray-500 mb-1">Your Add-ons:</p>
                    <div className="flex flex-wrap gap-1">
                      {profile.addOns.map((addon, idx) => (
                        <span key={idx} className="px-2 py-1 bg-orange-100 text-orange-800 border border-orange-200 rounded text-xs">
                          {addon.name || addon}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>


            {/* My Daily Meal Display */}
            {(() => {
              const myMeal = getMyDailyMeal();
              if (myMeal && myMeal.items.length > 0) {
                return (
                  <Card className={`bg-white border-2 border-${myMeal.color}-500 shadow-lg mt-6`}>
                    <CardHeader className={`bg-gradient-to-r from-${myMeal.color}-600 to-${myMeal.color}-700`}>
                      <CardTitle className="flex items-center gap-2 text-white">
                        <Utensils className="w-5 h-5 text-white" />
                        Your Meal Today
                        <span className="ml-auto text-xs bg-white text-black px-2 py-1 rounded font-bold uppercase">
                          {myMeal.type}
                        </span>
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="p-6">
                      <p className="text-gray-700 font-medium mb-4 text-center text-lg">
                        {myMeal.description}
                      </p>
                      <div className="space-y-4">
                        {myMeal.items.map((item, idx) => (
                          <div key={idx} className="flex items-start gap-4 p-4 bg-gray-50 rounded border border-gray-200">
                            {item.image_url && (
                              <img
                                src={process.env.REACT_APP_BACKEND_URL + item.image_url}
                                alt={item.name}
                                className="w-16 h-16 object-cover rounded bg-white shadow-sm"
                              />
                            )}
                            <div>
                              <p className="text-xs text-gray-500 font-bold uppercase mb-1">{item.label}</p>
                              <h4 className="font-bold text-gray-900">{item.name || 'Standard Meal'}</h4>
                              <div className="flex gap-3 text-xs text-gray-600 mt-1">
                                <span>{item.protein_grams || 0}g Pro</span>
                                <span>{item.calories || 0} Cal</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </CardContent>
                  </Card>
                );
              }
              return null;
            })()}

            {/* Personal Messages */}
            {personalMessages && personalMessages.length > 0 && (
              <Card className="bg-white border-2 border-orange-200 shadow-lg">
                <CardHeader className="bg-orange-50">
                  <CardTitle className="flex items-center gap-2 text-gray-900">
                    <MessageSquare className="w-5 h-5 text-orange-500" />
                    Personal Messages
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4">
                  <div className="space-y-3">
                    {personalMessages.slice(0, 3).map((msg, idx) => (
                      <div key={idx} className="bg-orange-50 p-4 rounded-lg border-l-4 border-orange-500">
                        <div className="flex justify-between items-start mb-2">
                          <p className="text-sm font-semibold text-gray-900">{msg.subject || 'Message from Admin'}</p>
                          <span className="text-xs text-gray-600">
                            {new Date(msg.createdAt).toLocaleDateString()}
                          </span>
                        </div>
                        <p className="text-sm text-gray-700">{msg.message}</p>
                      </div>
                    ))}
                    {personalMessages.length > 3 && (
                      <Button
                        variant="outline"
                        className="w-full mt-2 text-orange-600 border-orange-300"
                        onClick={() => {
                          // Show all messages logic
                        }}
                      >
                        View All Messages ({personalMessages.length})
                      </Button>
                    )}
                  </div>
                </CardContent>
              </Card>
            )}

            {/* Broadcast Messages */}
            {broadcasts && broadcasts.length > 0 && (
              <Card className="bg-white border-2 border-blue-200 shadow-lg">
                <CardHeader className="bg-blue-50">
                  <CardTitle className="flex items-center gap-2 text-gray-900">
                    <Bell className="w-5 h-5 text-blue-500" />
                    Announcements
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4">
                  <div className="space-y-3">
                    {broadcasts.slice(0, 2).map((msg, idx) => (
                      <div key={idx} className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                        <div className="flex justify-between items-start mb-2">
                          <p className="text-sm font-semibold text-gray-900">{msg.subject || 'Announcement'}</p>
                          <span className="text-xs text-gray-600">
                            {new Date(msg.createdAt).toLocaleDateString()}
                          </span>
                        </div>
                        <p className="text-sm text-gray-700">{msg.message}</p>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            )}

            {/* Removed: Delivery Notifications Card (feature removed for performance optimization) */}

            {/* Meal Preferences Card */}
            <Card className="bg-white border-2 border-orange-500 shadow-lg">
              <CardHeader className="bg-gradient-to-r from-black to-gray-900">
                <CardTitle className="flex items-center gap-2 text-white">
                  <Utensils className="w-5 h-5 text-orange-500" />
                  Meal Preferences
                </CardTitle>
              </CardHeader>
              <CardContent className="p-5">
                {preferences ? (
                  <div className="space-y-3">
                    <div className="bg-orange-50 rounded-lg p-4 border-2 border-orange-200">
                      <p className="text-sm font-bold text-gray-900 mb-2">
                        ✓ Your Preferences:
                      </p>
                      <div className="text-sm text-gray-700 space-y-1">
                        {mealPreferenceSummaryLines.length > 0 && (
                          <p><span className="font-semibold">Meal Setup:</span> {mealPreferenceSummaryLines.join(' | ')}</p>
                        )}
                        {mealPreferenceSummaryLines.length === 0 && (
                          <p className="italic text-gray-500">No specific preferences set.</p>
                        )}
                      </div>
                    </div>
                    <Button
                      className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2.5 transition-all duration-200"
                      onClick={() => openMealPreferencesModal()}
                    >
                      View/Edit Preferences
                    </Button>
                  </div>
                ) : (
                  <div className="space-y-3">
                    <div className="bg-gray-50 rounded-lg p-4 border-2 border-gray-200">
                      <p className="text-sm font-medium text-gray-700">
                        Please set your meal preferences to help us prepare your meals accurately
                      </p>
                    </div>
                    <Button
                      className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2.5 transition-all duration-200"
                      onClick={() => openMealPreferencesModal()}
                    >
                      Set Preferences Now
                    </Button>
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {/* Productivity Tab Content */}
        {activeTab === 'productivity' && (
          <div>
            {/* Reflection Hero Image */}
            <div className="mb-6 rounded-lg overflow-hidden shadow-lg relative">
              <img
                src="https://images.unsplash.com/photo-1506126613408-eca07ce68773"
                alt="Meditation and Mindfulness"
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
                <div className="p-6 text-white">
                  <h3 className="text-3xl font-bold">Reflect & Grow</h3>
                  <p className="text-lg mt-2">Daily mindfulness for a better you</p>
                </div>
              </div>
            </div>

            {/* My Goals & Daily Reflection Section */}
            <Card className="mb-8 bg-white border-2 border-orange-500 shadow-xl">
              <CardHeader className="bg-gradient-to-r from-black to-gray-900">
                <CardTitle className="text-2xl text-white">My Goals & Daily Reflection</CardTitle>
                <p className="text-orange-500 text-sm mt-1 font-medium">Every day is a fresh start</p>
              </CardHeader>
              <CardContent className="space-y-4 p-6">
                {todayReflection ? (
                  <div className="bg-white rounded-lg p-5 border-2 border-gray-200">
                    <div className="flex justify-between items-start mb-3">
                      <p className="text-orange-500 font-semibold">✓ You've completed today's check-in!</p>
                      <button
                        onClick={async () => {
                          if (window.confirm('Are you sure you want to delete today\'s reflection? This action cannot be undone.')) {
                            try {
                              await http.delete('/customer/reflection/today');
                              alert('Reflection deleted successfully!');
                              loadData();
                            } catch (error) {
                              console.error('Error deleting reflection:', error);
                              alert('Failed to delete reflection');
                            }
                          }
                        }}
                        className="text-orange-500 hover:text-black text-sm underline"
                      >
                        Delete
                      </button>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                      <div>
                        <p className="text-gray-700">Reading</p>
                        <p className="font-semibold">{todayReflection.read_today ? '✓ Yes' : '✗ No'}</p>
                      </div>
                      <div>
                        <p className="text-gray-700">Meditation</p>
                        <p className="font-semibold">{todayReflection.meditate_today ? '✓ Yes' : '✗ No'}</p>
                      </div>
                      <div>
                        <p className="text-gray-700">Workout</p>
                        <p className="font-semibold">{todayReflection.workout_duration ? `${todayReflection.workout_duration} min` : 'None'}</p>
                      </div>
                      <div>
                        <p className="text-gray-700">Mood</p>
                        <p className="font-semibold">{getMoodEmoji(todayReflection.mood)}</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="bg-orange-50 rounded-lg p-5 border-2 border-orange-200">
                    <p className="text-gray-700 font-medium">You haven't checked in today yet. Take a moment for yourself!</p>
                  </div>
                )}

                <div className="flex gap-3">
                  <Button
                    onClick={() => setShowReflectionModal(true)}
                    className="flex-1 bg-orange-500 hover:bg-orange-600 text-white font-semibold"
                  >
                    {todayReflection ? 'Update Today\'s Check-in' : 'Complete Daily Check-in'}
                  </Button>
                  <Button
                    onClick={() => setShowReportModal(true)}
                    className="flex-1 bg-orange-500 hover:bg-orange-600 text-white font-semibold"
                  >
                    View Reports
                  </Button>
                </div>
              </CardContent>
            </Card>

          </div>
        )}

        {/* Work Mode Tab Content */}
        {activeTab === 'workmode' && (
          <div>
            {/* Work Mode Hero Image */}
            <div className="mb-6 rounded-lg overflow-hidden shadow-lg relative">
              <img
                src="https://images.unsplash.com/photo-1505209487757-5114235191e5"
                alt="Productive Workspace"
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
                <div className="p-6 text-white">
                  <h3 className="text-3xl font-bold">Get Things Done</h3>
                  <p className="text-lg mt-2">Stay focused, stay productive</p>
                </div>
              </div>
            </div>

            {/* My To-Do & Reminders Section */}
            <Card className="mb-8 bg-white border-2 border-orange-500 shadow-xl">
              <CardHeader className="bg-gradient-to-r from-black to-gray-900">
                <CardTitle className="text-2xl text-white">My To-Do & Reminders</CardTitle>
                <p className="text-orange-500 text-sm mt-1 font-medium">Stay organized and on track</p>
              </CardHeader>
              <CardContent className="space-y-4 p-6">
                {/* Today's Tasks */}
                {todos.todays_tasks.length > 0 && (
                  <div className="bg-white rounded-lg p-5 border-2 border-orange-300 shadow-sm">
                    <h3 className="font-semibold text-orange-600 mb-3 flex items-center gap-2">
                      Today's Tasks ({todos.todays_tasks.length})
                    </h3>
                    <div className="space-y-2">
                      {todos.todays_tasks.map((task) => (
                        <div key={task.id} className="flex items-start gap-3 p-2 hover:bg-orange-50 rounded transition-colors">
                          <input
                            type="checkbox"
                            onChange={() => handleCompleteTask(task.id)}
                            className="w-5 h-5 mt-1 cursor-pointer accent-orange-500"
                          />
                          <div className="flex-1">
                            <p className="font-medium text-gray-800">{task.title}</p>
                            {task.note && <p className="text-sm text-gray-700 mt-1">{task.note}</p>}
                            <p className="text-xs text-orange-500 mt-1">{task.due_date}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Upcoming Tasks */}
                {todos.upcoming_tasks.length > 0 && (
                  <div className="bg-white rounded-lg p-5 border-2 border-gray-200">
                    <h3 className="font-semibold text-gray-900 mb-3">Upcoming ({todos.upcoming_tasks.length})</h3>
                    <div className="space-y-2">
                      {todos.upcoming_tasks.map((task) => (
                        <div key={task.id} className="flex items-start gap-3 p-2 hover:bg-orange-50 rounded transition-colors">
                          <input
                            type="checkbox"
                            onChange={() => handleCompleteTask(task.id)}
                            className="w-5 h-5 mt-1 cursor-pointer accent-orange-500"
                          />
                          <div className="flex-1">
                            <p className="font-medium text-gray-800">{task.title}</p>
                            {task.note && <p className="text-sm text-gray-700 mt-1">{task.note}</p>}
                            {task.due_date && <p className="text-xs text-gray-700 mt-1">{task.due_date}</p>}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Completed Tasks */}
                {todos.completed_tasks.length > 0 && (
                  <details className="bg-white rounded-lg p-5 border-2 border-gray-200">
                    <summary className="font-semibold text-gray-700 cursor-pointer">
                      ✓ Completed ({todos.completed_tasks.length})
                    </summary>
                    <div className="space-y-2 mt-3">
                      {todos.completed_tasks.slice(0, 5).map((task) => (
                        <div key={task.id} className="flex items-start justify-between gap-3 p-2 hover:bg-gray-50 rounded transition-colors">
                          <div className="flex items-start gap-3 flex-1 text-gray-700 line-through">
                            <span className="text-orange-500">✓</span>
                            <div className="flex-1">
                              <p className="text-sm">{task.title}</p>
                              {task.due_date && <p className="text-xs mt-1">{task.due_date}</p>}
                            </div>
                          </div>
                          <button
                            onClick={() => handleDeleteTask(task.id)}
                            className="text-orange-500 hover:text-black text-sm transition-colors flex-shrink-0"
                            title="Delete task"
                          >
                            Delete
                          </button>
                        </div>
                      ))}
                    </div>
                  </details>
                )}

                {/* Empty State */}
                {todos.todays_tasks.length === 0 && todos.upcoming_tasks.length === 0 && (
                  <div className="bg-orange-50 rounded-lg p-6 border-2 border-orange-200 text-center">
                    <p className="text-gray-900 font-medium mb-2">No tasks yet. Stay organized!</p>
                    <p className="text-sm text-gray-600">Add your first task to get started</p>
                  </div>
                )}

                {/* Add Task Button */}
                <Button
                  onClick={() => setShowTodoModal(true)}
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold"
                >
                  ➕ Add New Task
                </Button>
              </CardContent>
            </Card>
          </div>
        )}

        {/* Gym Mode Tab Content */}
        {activeTab === 'gymmode' && (
          <div>
            {/* Gym Hero Image */}
            <div className="mb-6 rounded-lg overflow-hidden shadow-lg relative">
              <img
                src="https://images.unsplash.com/photo-1758448756350-3d0eec02ba37"
                alt="Modern Gym"
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
                <div className="p-6 text-white">
                  <h3 className="text-3xl font-bold">Your Gym Journey Starts Here</h3>
                  <p className="text-lg mt-2">Track workouts, build strength, achieve goals</p>
                </div>
              </div>
            </div>

            {/* Gym Time Section */}
            <Card className="mb-8 bg-white border-2 border-orange-500 shadow-xl">
              <CardHeader className="bg-gradient-to-r from-black to-gray-900">
                <CardTitle className="text-2xl text-white">Gym Time</CardTitle>
                <p className="text-orange-500 text-sm mt-1 font-medium">Let's make today count</p>
              </CardHeader>
              <CardContent className="p-6">
                {/* Tabs */}
                <div className="flex gap-1 sm:gap-2 mb-6 overflow-x-auto pb-2">
                  <button
                    onClick={() => setGymActiveTab('planner')}
                    className={`px-3 sm:px-4 py-2 font-medium transition-colors whitespace-nowrap rounded-lg text-sm sm:text-base ${gymActiveTab === 'planner'
                      ? 'bg-orange-500 text-white'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                  >
                    Planner
                  </button>
                  <button
                    onClick={() => setGymActiveTab('workout')}
                    className={`px-3 sm:px-4 py-2 font-medium transition-colors whitespace-nowrap rounded-lg text-sm sm:text-base ${gymActiveTab === 'workout'
                      ? 'bg-orange-500 text-white'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                  >
                    Workout
                  </button>
                  <button
                    onClick={() => setGymActiveTab('progress')}
                    className={`px-3 sm:px-4 py-2 font-medium transition-colors whitespace-nowrap rounded-lg text-sm sm:text-base ${gymActiveTab === 'progress'
                      ? 'bg-orange-500 text-white'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                  >
                    Progress
                  </button>
                  <button
                    onClick={() => setGymActiveTab('splits')}
                    className={`px-3 sm:px-4 py-2 font-medium transition-colors whitespace-nowrap rounded-lg text-sm sm:text-base ${gymActiveTab === 'splits'
                      ? 'bg-orange-500 text-white'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                      }`}
                  >
                    Splits
                  </button>
                </div>

                {/* Tab Content */}
                {gymActiveTab === 'planner' && (
                  <GymPlannerTab weeklyPlan={weeklyPlan} onUpdate={loadData} />
                )}

                {gymActiveTab === 'workout' && (
                  <DoWorkoutTab
                    weeklyPlan={weeklyPlan}
                    activeSession={activeSession}
                    onUpdate={loadData}
                  />
                )}

                {gymActiveTab === 'progress' && (
                  <GymProgressTab progress={gymProgress} />
                )}

                {gymActiveTab === 'splits' && (
                  <WorkoutSplitsTab />
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {/* Track Measurements Tab Content */}
        {activeTab === 'measurements' && (
          <div>
            {/* Measurements Hero Image */}
            <div className="mb-6 rounded-lg overflow-hidden shadow-lg relative">
              <img
                src="https://images.unsplash.com/photo-1434494878577-86c23bcb06b9"
                alt="Fitness Tracking"
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
                <div className="p-6 text-white">
                  <h3 className="text-3xl font-bold">Track Your Progress</h3>
                  <p className="text-lg mt-2">Measure, monitor, and celebrate your transformation</p>
                </div>
              </div>
            </div>

            <Card className="bg-white border-2 border-orange-500 shadow-xl">
              <CardHeader className="bg-gradient-to-r from-black to-gray-900">
                <CardTitle className="text-2xl text-white flex items-center gap-2">
                  Track Your Measurements
                </CardTitle>
                <p className="text-orange-500 text-sm mt-1 font-medium">Monitor your progress and see your transformation</p>
              </CardHeader>
              <CardContent className="p-6">
                {/* Add Measurement Button */}
                <div className="mb-6">
                  <Button
                    onClick={() => setShowMeasurementModal(true)}
                    className="bg-orange-500 hover:bg-orange-600 text-white"
                  >
                    ➕ Add Measurement
                  </Button>
                </div>

                {/* View Type Selector */}
                <div className="mb-6 flex gap-2">
                  <button
                    onClick={() => setMeasurementViewType('week')}
                    className={`px-4 py-2 rounded ${measurementViewType === 'week'
                      ? 'bg-orange-500 text-white'
                      : 'bg-gray-200 text-gray-700'
                      }`}
                  >
                    Week View
                  </button>
                  <button
                    onClick={() => setMeasurementViewType('month')}
                    className={`px-4 py-2 rounded ${measurementViewType === 'month'
                      ? 'bg-orange-500 text-white'
                      : 'bg-gray-200 text-gray-700'
                      }`}
                  >
                    Month View
                  </button>
                </div>

                {/* Measurements Table */}
                {measurements.length === 0 ? (
                  <div className="text-center py-12 text-gray-500">
                    <p>No measurements recorded yet. Click "Add Measurement" to get started!</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Date</th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Weight</th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Chest</th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Biceps</th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Waist</th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Glutes</th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {measurements
                          .filter(m => {
                            if (measurementViewType === 'week') {
                              const weekAgo = new Date();
                              weekAgo.setDate(weekAgo.getDate() - 7);
                              return new Date(m.date) >= weekAgo;
                            } else {
                              const monthAgo = new Date();
                              monthAgo.setMonth(monthAgo.getMonth() - 1);
                              return new Date(m.date) >= monthAgo;
                            }
                          })
                          .map((measurement, idx) => {
                            // Parse measurements from new format
                            const measurementData = measurement.measurements || {};
                            const weight = measurementData.weight ? `${measurementData.weight.value} ${measurementData.weight.unit}` : (measurement.weight || '-');
                            const chest = measurementData.chest ? `${measurementData.chest.value} ${measurementData.chest.unit}` : (measurement.chest || '-');
                            const biceps = measurementData.biceps ? `${measurementData.biceps.value} ${measurementData.biceps.unit}` : (measurement.biceps || '-');
                            const waist = measurementData.waist ? `${measurementData.waist.value} ${measurementData.waist.unit}` : (measurement.waist || '-');
                            const glutes = measurementData.glutes ? `${measurementData.glutes.value} ${measurementData.glutes.unit}` : (measurement.hips || measurement.glutes || '-');

                            return (
                              <tr key={measurement._id || measurement.id || idx} className="hover:bg-orange-50">
                                <td className="px-4 py-3 text-sm text-gray-900">{measurement.date ? new Date(measurement.date).toLocaleDateString('en-CA') : '-'}</td>
                                <td className="px-4 py-3 text-sm text-gray-900">{weight}</td>
                                <td className="px-4 py-3 text-sm text-gray-900">{chest}</td>
                                <td className="px-4 py-3 text-sm text-gray-900">{biceps}</td>
                                <td className="px-4 py-3 text-sm text-gray-900">{waist}</td>
                                <td className="px-4 py-3 text-sm text-gray-900">{glutes}</td>
                                <td className="px-4 py-3 text-sm">
                                  <Button
                                    size="sm"
                                    variant="destructive"
                                    onClick={() => deleteMeasurement(measurement._id || measurement.id)}
                                    className="bg-red-600 hover:bg-red-700 text-white"
                                  >
                                    Delete
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {/* My Plan Tab Content */}
        {activeTab === 'myplan' && (
          <div className="space-y-4">
            {/* Compact Header */}
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white p-4 rounded-lg shadow">
              <h2 className="text-xl font-bold flex items-center gap-2">
                <FileText className="w-6 h-6" />
                My Plan Details
              </h2>
            </div>

            {/* Compact Cards - Stacks on Mobile, 2 columns on larger screens */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Plan Details */}
              <Card className="bg-white border-2 border-orange-200">
                <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <Package className="w-4 h-4 text-orange-500" />
                    Your Plan
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 space-y-3">
                  <div className="bg-orange-50 p-3 rounded border-l-4 border-orange-500">
                    <p className="text-xs text-gray-600 font-semibold mb-1">Plan Key</p>
                    <p className="font-semibold text-gray-900 text-sm leading-tight break-words">{profile?.planKey || 'N/A'}</p>
                  </div>
                  <div className="bg-blue-50 p-3 rounded border-l-4 border-blue-500">
                    <p className="text-xs text-gray-600 font-semibold mb-1">Subscription Status</p>
                    <div className="flex items-center gap-2">
                      <span className={`w-2 h-2 rounded-full ${profile?.status === 'active' ? 'bg-green-500' :
                        profile?.status === 'upcoming' ? 'bg-blue-500' :
                          profile?.status === 'paused' ? 'bg-orange-500' : 'bg-red-500'
                        }`}></span>
                      <p className="font-semibold text-gray-900 text-sm capitalize">
                        {profile?.status === 'upcoming'
                          ? `Upcoming (Starts ${profile?.planStartDate || 'Soon'})`
                          : (profile?.status || 'Active')}
                      </p>
                    </div>
                  </div>
                  {profile?.addOns && profile.addOns.length > 0 && (
                    <div>
                      <p className="text-xs text-gray-600 font-semibold mb-2">Add-ons</p>
                      <div className="flex flex-wrap gap-1">
                        {profile.addOns.map((addon, idx) => (
                          <span key={idx} className="px-2 py-1 bg-orange-500 text-white rounded text-xs font-medium">
                            {addon.name || addon}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Profile & Delivery Details (New) */}
              <Card className="bg-white border-2 border-orange-200">
                <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <User className="w-4 h-4 text-orange-500" />
                    Profile & Delivery
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 space-y-3">
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <p className="text-xs text-gray-500">Name</p>
                      <p className="text-sm font-semibold text-gray-900">
                        {profile?.firstName} {profile?.lastName}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Phone</p>
                      <p className="text-sm font-semibold text-gray-900">{profile?.phone || 'N/A'}</p>
                    </div>
                  </div>
                  <div className="border-t pt-2">
                    <p className="text-xs text-gray-500">Delivery Address</p>
                    <p className="text-sm font-semibold text-gray-900 mt-0.5">
                      {profile?.address?.street}<br />
                      {profile?.address?.city}, {profile?.address?.postalCode}
                    </p>
                  </div>
                  {profile?.address?.deliveryInstructions && (
                    <div className="bg-gray-50 p-2 rounded text-xs mt-2 border border-gray-200">
                      <p className="font-semibold text-gray-600 mb-1">Instructions:</p>
                      <p className="text-gray-800 italic">"{profile.address.deliveryInstructions}"</p>
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Subscription Actions */}
              <Card className="bg-white border-2 border-orange-200">
                <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <Activity className="w-4 h-4 text-orange-500" />
                    Subscription Actions
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 space-y-3">
                  {/* Status & Add-ons */}
                  <div className="grid grid-cols-1 gap-3">
                    <div className="bg-gray-50 p-3 rounded flex justify-between items-center">
                      <span className="text-sm font-semibold text-gray-700">Status</span>
                      <span className={`px-2 py-1 rounded text-xs font-bold ${profile?.status === 'Active' || profile?.status === 'active' ? 'bg-green-100 text-green-700' :
                        profile?.status === 'upcoming' ? 'bg-blue-100 text-blue-700' :
                          profile?.status === 'pending_payment' ? 'bg-yellow-100 text-yellow-700' :
                            profile?.status === 'Paused' || profile?.status === 'paused' ? 'bg-orange-100 text-orange-700' : 'bg-red-100 text-red-700'
                        }`}>
                        {profile?.status === 'upcoming'
                          ? `Upcoming (Starts ${profile?.planStartDate || 'Soon'})`
                          : profile?.status === 'pending_payment' ? 'Pending Payment' : (profile?.status || 'Active')}
                      </span>
                    </div>

                    {/* Current Add-ons Display */}
                    <div className="bg-orange-50 p-3 rounded border-l-4 border-orange-500 mt-3 mb-3">
                      <p className="text-xs text-gray-600 font-semibold mb-2">Current Add-ons</p>
                      {profile?.addOns && profile.addOns.length > 0 ? (
                        <div className="flex flex-wrap gap-1">
                          {profile.addOns.map((addon, idx) => (
                            <span key={idx} className="px-2 py-1 bg-orange-500 text-white rounded text-xs font-medium">
                              {addon.name || addon}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <p className="text-xs text-gray-500 italic">
                          No Add-ons currently active. You can add add-ons for the next billing cycle, or Contact Support to add them to your current cycle.
                        </p>
                      )}
                    </div>

                    {(() => {
                      const today = new Date().toLocaleDateString('en-CA');
                      const renewalDate = profile?.planRenewalDate ? profile.planRenewalDate.split('T')[0] : null;

                      if (today === renewalDate) {
                        return (
                          <Button
                            variant="destructive"
                            className="w-full"
                            onClick={() => setShowCancelModal(true)}
                          >
                            <LogOut className="w-4 h-4 mr-2" />
                            Cancel Subscription
                          </Button>
                        );
                      } else {
                        return (
                          <div className="text-xs text-center text-gray-400 mt-1">
                            Cancellation available on renewal date ({renewalDate || 'N/A'})
                          </div>
                        );
                      }
                    })()}

                  </div>
                </CardContent>
              </Card>

              {/* Plan Dates */}
              <Card className="bg-white border-2 border-orange-200">
                <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <Calendar className="w-4 h-4 text-orange-500" />
                    Plan Dates
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 space-y-3">
                  <div className="bg-gray-50 p-3 rounded border-l-4 border-gray-400">
                    <p className="text-xs text-gray-600 font-semibold mb-1">Start Date</p>
                    <p className="font-semibold text-gray-900 text-sm">
                      {formatDateWithoutTimezone(profile?.planStartDate)}
                    </p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded border-l-4 border-gray-400">
                    <p className="text-xs text-gray-600 font-semibold mb-1">End Date</p>
                    <p className="font-semibold text-gray-900 text-sm">
                      {formatDateWithoutTimezone(profile?.planEndDate)}
                    </p>
                  </div>
                  <div className="bg-orange-50 p-3 rounded border-l-4 border-orange-500">
                    <p className="text-xs text-gray-600 font-semibold mb-1">Renewal Date</p>
                    <p className="font-semibold text-gray-900 text-sm">
                      {formatDateWithoutTimezone(profile?.planRenewalDate)}
                    </p>
                  </div>
                </CardContent>
              </Card>

              {/* Total Amount */}
              <Card className="bg-white border-2 border-orange-200">
                <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <DollarSign className="w-4 h-4 text-orange-500" />
                    Total Amount
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4">
                  <div className="space-y-2 mb-3">
                    <div className="flex justify-between items-center bg-gray-50 p-2.5 rounded">
                      <span className="text-sm text-gray-600">Plan Price</span>
                      <span className="text-sm font-semibold text-gray-900">${getBasePrice(profile?.planPrice || 0)}</span>
                    </div>
                    <div className="flex justify-between items-center bg-gray-50 p-2.5 rounded">
                      <span className="text-sm text-gray-600">Total Add-ons</span>
                      <span className="text-sm font-semibold text-gray-900">+ ${getBasePrice(profile?.addOnsTotal || 0)}</span>
                    </div>
                    <div className="flex justify-between items-center bg-orange-100 p-2.5 rounded">
                      <span className="text-sm text-gray-600">HST (13%)</span>
                      <span className="text-sm font-semibold text-orange-700">${getHSTAmount(profile?.totalAmount || 0)}</span>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-orange-500 to-orange-600 p-4 rounded-lg text-white text-center">
                    <p className="text-3xl font-bold mb-1">
                      ${formatPrice(profile?.totalAmount || 0)}
                    </p>
                    <p className="text-orange-100 text-xs font-semibold">Total Amount (incl. HST)</p>
                  </div>
                </CardContent>
              </Card>

              {/* Payment Status */}
              <Card className="bg-white border-2 border-orange-200">
                <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <DollarSign className="w-4 h-4 text-orange-500" />
                    Payment Status
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4">
                  <div className={`p-4 rounded-lg text-center border-2 ${profile?.paymentStatus === 'Paid'
                    ? 'bg-orange-50 border-orange-500'
                    : 'bg-gray-50 border-gray-400'
                    }`}>
                    <p className={`text-2xl font-bold mb-1 ${profile?.paymentStatus === 'Paid' ? 'text-orange-600' : 'text-gray-600'
                      }`}>
                      {profile?.paymentStatus || 'Pending'}
                    </p>
                    {profile?.balanceDue > 0 && (
                      <p className="text-gray-700 text-xs font-semibold">
                        Balance: ${profile.balanceDue}
                      </p>
                    )}
                  </div>
                </CardContent>
              </Card>



              {/* Manage Subscription */}
              <Card className="bg-white border-2 border-orange-200">
                <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <Package className="w-4 h-4 text-orange-500" />
                    Manage Subscription
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 space-y-3">
                  {/* Pause buttons - only when active, not paused, and no scheduled pause */}
                  {!isTrucker && !profile?.isPaused && !profile?.activePause && profile?.status === 'active' && (
                    <>
                      {/* Pause Tomorrow Button */}
                      <Button
                        onClick={async () => {
                          try {
                            // Compute next service day (skip weekends)
                            let d = new Date(Date.now() + 86400000);
                            while (d.getDay() === 0 || d.getDay() === 6) {
                              d = new Date(d.getTime() + 86400000);
                            }
                            const nextServiceDay = d.toISOString().split('T')[0];
                            if (!window.confirm(`Pause delivery for ${nextServiceDay}? Your subscription will be paused for that day and your renewal date will be extended by 1 day. This action cannot be undone.`)) {
                              return;
                            }
                            const response = await http.post('/customer/pause', {
                              type: 'single_day',
                              pauseDate: nextServiceDay,
                            });
                            setSuccess(`Delivery paused for ${nextServiceDay}!`);
                            setTimeout(() => setSuccess(''), 5000);
                            loadData();
                            loadPausedDates();
                          } catch (error) {
                            console.error('Failed to pause:', error);
                            setError(error.response?.data?.message || 'Failed to pause delivery');
                            setTimeout(() => setError(''), 5000);
                          }
                        }}
                        variant="outline"
                        className="w-full border-orange-500 text-orange-600 hover:bg-orange-50"
                      >
                        Pause Tomorrow
                      </Button>

                      {/* Pause Subscription Button */}
                      <Button
                        onClick={() => {
                          loadPausedDates();
                          setShowPauseModal(true);
                        }}
                        className="w-full bg-orange-500 hover:bg-orange-600 text-white"
                      >
                        Pause Subscription
                      </Button>
                    </>
                  )}

                  {/* Resume banner - shown when actively paused */}
                  {profile?.isPaused && (
                    <div className="bg-blue-50 border-2 border-blue-300 rounded-lg p-4 space-y-2">
                      <p className="text-sm font-semibold text-blue-900">
                        Your subscription is currently paused
                        {profile?.activePause?.type === 'single_day' && ' for today'}
                        {profile?.activePause?.type === 'date_range' && profile?.activePause?.endDate &&
                          ` until ${new Date(profile.activePause.endDate).toISOString().slice(0, 10)}`}
                        {profile?.activePause?.type === 'indefinite' && ' indefinitely'}
                      </p>
                      <Button
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                        onClick={handleUnpauseSubscription}
                      >
                        Resume Subscription Now
                      </Button>
                    </div>
                  )}

                  {/* Scheduled pause banner - shown when pause is scheduled but not yet started */}
                  {!profile?.isPaused && profile?.activePause && (
                    <div className="bg-yellow-50 border-2 border-yellow-300 rounded-lg p-4 space-y-2">
                      <p className="text-sm font-semibold text-yellow-900">
                        Pause scheduled starting {new Date(profile.activePause.startDate).toISOString().slice(0, 10)}
                        {profile?.activePause?.endDate
                          ? ` until ${new Date(profile.activePause.endDate).toISOString().slice(0, 10)}`
                          : ' (indefinite)'}
                      </p>
                      <Button
                        className="w-full bg-yellow-600 hover:bg-yellow-700 text-white"
                        onClick={handleUnpauseSubscription}
                      >
                        Cancel Scheduled Pause
                      </Button>
                    </div>
                  )}

                  {/* Cancel Subscription Button - Only on Renewal Date */}
                  {(() => {
                    const today = new Date().toISOString().split('T')[0];
                    const renewalDate = profile?.planRenewalDate?.split('T')[0];
                    return today === renewalDate ? (
                      <Button
                        onClick={() => setShowCancelModal(true)}
                        variant="outline"
                        className="w-full border-red-500 text-red-500 hover:bg-red-50"
                      >
                        Cancel Subscription
                      </Button>
                    ) : (
                      <p className="text-xs text-gray-500 text-center">
                        Cancellation available on renewal date ({renewalDate || 'N/A'})
                      </p>
                    );
                  })()}
                </CardContent>
              </Card>

              {/* Change Password */}
              <Card className="bg-white border-2 border-orange-200">
                <CardHeader className="p-4 pb-3 bg-gradient-to-r from-black to-gray-900">
                  <CardTitle className="text-base flex items-center gap-2 text-white">
                    <Lock className="w-4 h-4 text-orange-500" />
                    Change Password
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4">
                  <form onSubmit={handleChangePassword} className="space-y-3">
                    {changePwError && (
                      <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded text-sm">
                        {changePwError}
                      </div>
                    )}
                    {changePwSuccess && (
                      <div className="bg-green-50 border border-green-200 text-green-700 px-3 py-2 rounded text-sm">
                        {changePwSuccess}
                      </div>
                    )}

                    <div>
                      <Label className="text-sm font-semibold text-gray-700">Current Password</Label>
                      <Input
                        type={showChangePwPasswords ? "text" : "password"}
                        value={changePwOld}
                        onChange={(e) => setChangePwOld(e.target.value)}
                        placeholder="Enter current password"
                        className="mt-1"
                      />
                    </div>

                    <div>
                      <Label className="text-sm font-semibold text-gray-700">New Password</Label>
                      <Input
                        type={showChangePwPasswords ? "text" : "password"}
                        value={changePwNew}
                        onChange={(e) => setChangePwNew(e.target.value)}
                        placeholder="Min. 8 characters"
                        className="mt-1"
                      />
                    </div>

                    <div>
                      <Label className="text-sm font-semibold text-gray-700">Confirm New Password</Label>
                      <Input
                        type={showChangePwPasswords ? "text" : "password"}
                        value={changePwConfirm}
                        onChange={(e) => setChangePwConfirm(e.target.value)}
                        placeholder="Re-enter new password"
                        className="mt-1"
                      />
                    </div>

                    <button
                      type="button"
                      onClick={() => setShowChangePwPasswords(!showChangePwPasswords)}
                      className="text-xs font-semibold text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      {showChangePwPasswords ? "HIDE" : "SHOW"} PASSWORDS
                    </button>

                    <Button
                      type="submit"
                      disabled={changePwLoading}
                      className="w-full bg-orange-500 hover:bg-orange-600 text-white"
                    >
                      {changePwLoading ? 'Changing...' : 'Change Password'}
                    </Button>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div >
        )
        }

      </div >

      {/* Request Modal */}
      {
        showRequestModal && (
          <RequestModal
            profile={profile}
            onClose={() => setShowRequestModal(false)}
            onSubmit={() => {
              setShowRequestModal(false);
              loadData();
            }}
          />
        )
      }

      {/* Edit Profile Modal */}
      {
        showEditProfileModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[9999]" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
            <Card className="w-full max-w-lg bg-white max-h-[90vh] overflow-y-auto">
              <CardHeader>
                <CardTitle>Edit Profile Details</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label>First Name</Label>
                    <Input
                      value={profileFormData.firstName}
                      onChange={(e) => setProfileFormData({ ...profileFormData, firstName: e.target.value })}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label>Last Name</Label>
                    <Input
                      value={profileFormData.lastName}
                      onChange={(e) => setProfileFormData({ ...profileFormData, lastName: e.target.value })}
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <Label>Phone Number</Label>
                  <Input
                    value={profileFormData.phone}
                    onChange={(e) => setProfileFormData({ ...profileFormData, phone: e.target.value })}
                  />
                </div>

                <div className="space-y-2">
                  <Label>Street Address</Label>
                  <Input
                    value={profileFormData.address.street}
                    onChange={(e) => setProfileFormData({
                      ...profileFormData,
                      address: { ...profileFormData.address, street: e.target.value }
                    })}
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label>City</Label>
                    <Input
                      value={profileFormData.address.city}
                      onChange={(e) => setProfileFormData({
                        ...profileFormData,
                        address: { ...profileFormData.address, city: e.target.value }
                      })}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label>Postal Code</Label>
                    <Input
                      value={profileFormData.address.postalCode}
                      onChange={(e) => setProfileFormData({
                        ...profileFormData,
                        address: { ...profileFormData.address, postalCode: e.target.value }
                      })}
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <Label>Delivery Instructions</Label>
                  <Textarea
                    value={profileFormData.address.deliveryInstructions}
                    onChange={(e) => setProfileFormData({
                      ...profileFormData,
                      address: { ...profileFormData.address, deliveryInstructions: e.target.value }
                    })}
                    placeholder="Buzz code, side door, etc."
                  />
                </div>

                <div className="flex justify-end gap-3 pt-4">
                  <Button variant="outline" onClick={() => setShowEditProfileModal(false)}>Cancel</Button>
                  <Button className="bg-orange-500 hover:bg-orange-600 text-white" onClick={handleUpdateProfile}>Save Changes</Button>
                </div>
              </CardContent>
            </Card>
          </div>
        )
      }


      {/* Add-ons Modal */}
      {
        showAddonsModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[9999]" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
            <Card className="w-full max-w-lg bg-white max-h-[90vh] overflow-y-auto">
              <CardHeader className="bg-orange-50 border-b border-orange-100">
                <CardTitle className="text-orange-900">Add Add-ons</CardTitle>
              </CardHeader>
              <CardContent className="p-6 space-y-6">
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 text-sm text-blue-800 mb-4">
                  <p><strong>Note:</strong> You will be charged a prorated amount for the remaining days of your current subscription.</p>
                </div>

                <div className="space-y-3">
                  <Label className="text-base font-semibold">Select Add-ons:</Label>
                  <div className="grid gap-3">
                    {Object.entries(getAllAddOns() || {}).map(([name, prices]) => {
                      const weeklyPrice = prices.Weekly || 0;
                      return (
                        <div
                          key={name}
                          onClick={() => {
                            const isSelected = selectedAddons.includes(name);
                            let newSelection;
                            if (isSelected) {
                              newSelection = selectedAddons.filter(a => a !== name);
                            } else {
                              newSelection = [...selectedAddons, name];
                            }
                            setSelectedAddons(newSelection);
                          }}
                          className={`flex items-center justify-between p-4 rounded-lg border-2 cursor-pointer transition-all ${selectedAddons.includes(name)
                            ? 'border-orange-500 bg-orange-50'
                            : 'border-gray-200 hover:border-orange-200'
                            }`}
                        >
                          <div className="flex items-center gap-3">
                            <div className={`w-5 h-5 rounded border flex items-center justify-center ${selectedAddons.includes(name) ? 'bg-orange-500 border-orange-500' : 'border-gray-300'
                              }`}>
                              {selectedAddons.includes(name) && <Check className="w-3 h-3 text-white" />}
                            </div>
                            <div>
                              <p className="font-semibold">{name}</p>
                              <p className="text-sm text-gray-500">${weeklyPrice}/week</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {selectedAddons.length > 0 && (
                  <div className="flex flex-col items-end pt-4 border-t mt-4">
                    {(() => {
                      if (!profile?.planRenewalDate) {
                        return <p className="text-sm text-red-500">Cannot calculate price: No renewal date found.</p>;
                      }
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);
                      const renewal = new Date(profile.planRenewalDate);
                      renewal.setHours(0, 0, 0, 0);

                      // Calculate difference in days
                      const diffTime = renewal - today;
                      const daysRemaining = Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));

                      let totalWeekly = 0;
                      const allAddons = getAllAddOns() || {};

                      selectedAddons.forEach(name => {
                        const weekly = allAddons[name]?.Weekly || 0;
                        totalWeekly += weekly;
                      });

                      const dailyCost = totalWeekly / 5;
                      const totalEstimated = (dailyCost * daysRemaining).toFixed(2);

                      return (
                        <div className="text-right">
                          <p className="text-sm text-gray-600 mb-1">
                            {daysRemaining} days remaining in your plan
                          </p>
                          <p className="text-sm text-gray-600 mb-2">
                            Daily breakdown: ${(dailyCost).toFixed(2)}/day
                          </p>
                          <p className="text-lg font-bold text-orange-600">
                            Estimated Prorated Cost: ${totalEstimated}
                          </p>
                          <p className="text-xs text-gray-400 mt-1">
                            (Final calculation confirmed at checkout)
                          </p>
                        </div>
                      );
                    })()}
                  </div>
                )}

                <div className="flex justify-end gap-3 pt-4 border-t">
                  <Button variant="outline" onClick={() => setShowAddonsModal(false)}>Cancel</Button>
                  <Button
                    className="bg-green-600 hover:bg-green-700 text-white"
                    onClick={handleAddAddons}
                    disabled={selectedAddons.length === 0}
                  >
                    Proceed to Payment
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        )
      }

      {/* Cancel Subscription Modal */}
      {
        showCancelModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[9999]">
            <Card className="w-full max-w-md bg-white">
              <CardHeader>
                <CardTitle className="text-red-600">Cancel Subscription</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="bg-red-50 border-l-4 border-red-500 p-4">
                  <p className="text-sm text-red-800 font-semibold">⚠️ Warning</p>
                  <p className="text-sm text-red-700 mt-1">
                    This will cancel your subscription immediately. This action cannot be undone.
                  </p>
                </div>

                <div className="space-y-2">
                  <Label>Reason for cancellation (optional)</Label>
                  <Textarea
                    value={cancelReason}
                    onChange={(e) => setCancelReason(e.target.value)}
                    placeholder="Help us improve by telling us why you're leaving..."
                    rows={3}
                  />
                </div>

                <div className="flex justify-end gap-3 pt-4">
                  <Button variant="outline" onClick={() => setShowCancelModal(false)}>
                    Keep Subscription
                  </Button>
                  <Button
                    className="bg-red-500 hover:bg-red-600 text-white"
                    onClick={handleCancelSubscription}
                  >
                    Confirm Cancellation
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        )
      }

      {/* Pause Subscription Modal */}
      {showPauseModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[9999]">
          <Card className="w-full max-w-md bg-white max-h-[90vh] overflow-y-auto">
            <CardHeader>
              <CardTitle>Pause Subscription</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="bg-orange-50 border-l-4 border-orange-500 p-4 mb-4">
                <p className="text-sm text-orange-800 font-semibold">ℹ️ How it works</p>
                <p className="text-sm text-orange-700 mt-1">
                  Select a start date (and optionally an end date) to continuously pause your deliveries. You can resume at any time.
                </p>
              </div>

              {pausedData.is_paused && (
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 mb-4">
                  <h4 className="text-sm font-semibold text-blue-900 mb-2">Status: Paused</h4>
                  <p className="text-sm text-blue-800">
                    Your subscription is currently paused starting from <strong>{pausedData.pause_start_date}</strong>
                    {pausedData.pause_end_date ? ` until ${pausedData.pause_end_date}.` : ' indefinitely.'}
                  </p>
                  <Button
                    className="mt-3 w-full bg-blue-600 hover:bg-blue-700 text-white"
                    onClick={() => {
                      setShowPauseModal(false);
                      handleUnpauseSubscription();
                    }}
                  >
                    Resume Subscription Now
                  </Button>
                </div>
              )}

              {!pausedData.is_paused && (
                <div className="space-y-4">
                  <div className="space-y-2">
                    <Label>Start Date *</Label>
                    <Input
                      type="date"
                      min={new Date(Date.now() + 86400000).toISOString().split('T')[0]}
                      value={pauseStartDate}
                      onChange={(e) => setPauseStartDate(e.target.value)}
                      required
                    />
                  </div>
                  <div className="space-y-2">
                    <Label>End Date (Optional)</Label>
                    <Input
                      type="date"
                      min={pauseStartDate || new Date(Date.now() + 86400000).toISOString().split('T')[0]}
                      value={pauseEndDate}
                      onChange={(e) => setPauseEndDate(e.target.value)}
                    />
                    <p className="text-xs text-gray-500">Leave blank to pause indefinitely until you resume.</p>
                  </div>
                  <div className="space-y-2">
                    <Label>Reason (Optional)</Label>
                    <Input
                      type="text"
                      placeholder="e.g. Vacation, taking a break"
                      value={pauseReason}
                      onChange={(e) => setPauseReason(e.target.value)}
                    />
                  </div>

                  <div className="flex justify-end gap-3 pt-4">
                    <Button variant="outline" onClick={() => {
                      setShowPauseModal(false);
                      setPauseStartDate('');
                      setPauseEndDate('');
                      setPauseReason('');
                    }}>
                      Cancel
                    </Button>
                    <Button
                      className="bg-orange-500 hover:bg-orange-600 text-white"
                      onClick={handlePauseSubscription}
                      disabled={!pauseStartDate}
                    >
                      Confirm Pause
                    </Button>
                  </div>
                </div>
              )}
              {pausedData.is_paused && (
                <div className="flex justify-end pt-4">
                  <Button variant="outline" onClick={() => setShowPauseModal(false)}>
                    Close
                  </Button>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      )}


      {/* Renewal Modal */}
      {
        showRenewalModal && renewalReminder && (
          <RenewalModal
            reminder={renewalReminder}
            onClose={() => setShowRenewalModal(false)}
            onSubmit={() => {
              setShowRenewalModal(false);
              loadData();
            }}
          />
        )
      }

      {/* Personal Message Modal */}
      {
        showPersonalMessageModal && currentPersonalMessage && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[80vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                    <span className="text-2xl">💬</span> Message from Admin
                  </h3>
                  <button
                    onClick={closePersonalMessageModal}
                    className="text-gray-400 hover:text-gray-700 text-2xl"
                  >
                    ×
                  </button>
                </div>

                <div className="bg-orange-50 border-l-4 border-l-black p-4 rounded">
                  <p className="text-gray-800 whitespace-pre-wrap">{currentPersonalMessage.message}</p>
                </div>

                <div className="mt-4 flex items-center justify-between text-sm text-gray-700">
                  <span>From: {currentPersonalMessage.sent_by || 'Admin'}</span>
                  <span>{new Date(currentPersonalMessage.created_at).toLocaleDateString()}</span>
                </div>

                <div className="mt-6 flex justify-end">
                  <button
                    onClick={closePersonalMessageModal}
                    className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-md"
                  >
                    Got it!
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* My Information Modal */}
      {
        showMyInfoModal && profile && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-2xl font-bold text-gray-900">My Information</h3>
                  <button
                    onClick={() => setShowMyInfoModal(false)}
                    className="text-gray-400 hover:text-gray-700 text-2xl"
                  >
                    ×
                  </button>
                </div>

                <div className="space-y-6">
                  {/* Personal Details */}
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-lg mb-3 text-gray-800">Personal Details</h4>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-gray-700">Full Name</p>
                        <p className="font-medium text-gray-900">{profile.fullName || 'N/A'}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-700">Email</p>
                        <p className="font-medium text-gray-900">{profile.email || 'N/A'}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-700">Phone</p>
                        <p className="font-medium text-gray-900">{profile.phone || 'N/A'}</p>
                      </div>
                    </div>
                  </div>

                  {/* Address */}
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-lg mb-3 text-gray-800">Delivery Address</h4>
                    <div className="space-y-2">
                      {typeof profile.address === 'string' ? (
                        <p className="font-medium text-gray-900">{profile.address}</p>
                      ) : profile.address ? (
                        <div className="font-medium text-gray-900">
                          <p>{profile.address.street || ''}</p>
                          <p>{profile.address.city || ''} {profile.address.postalCode || ''}</p>
                        </div>
                      ) : (
                        <p className="font-medium text-gray-900">N/A</p>
                      )}
                      {profile.deliveryInstructions && (
                        <div className="mt-2">
                          <p className="text-sm text-gray-700">Delivery Instructions</p>
                          <p className="text-gray-800">{profile.deliveryInstructions}</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Plan Information */}
                  <div className="bg-orange-50 rounded-lg p-4">
                    <h4 className="font-semibold text-lg mb-3 text-orange-800">Current Plan</h4>
                    <div className="space-y-3">
                      <div>
                        <p className="text-sm text-gray-700">Plan Key</p>
                        <p className="font-medium text-gray-900">{profile.planKey || 'N/A'}</p>
                      </div>
                      <div className="grid md:grid-cols-2 gap-4">
                        <div>
                          <p className="text-sm text-gray-700">Start Date</p>
                          <p className="font-medium text-gray-900">{profile.planStartDate || 'N/A'}</p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-700">Renewal Date</p>
                          <p className="font-medium text-gray-900">
                            {formatDateWithoutTimezone(profile.planRenewalDate)}
                          </p>
                        </div>
                      </div>
                      {profile.addOns && profile.addOns.length > 0 && (
                        <div>
                          <p className="text-sm text-gray-700">Add-ons</p>
                          <div className="flex flex-wrap gap-2 mt-1">
                            {profile.addOns.map((addon, idx) => (
                              <span key={idx} className="px-3 py-1 bg-orange-200 text-orange-800 rounded-full text-sm">
                                {addon.name || addon}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                      <div>
                        <p className="text-sm text-gray-700">Total Amount</p>
                        <p className="text-2xl font-bold text-black">${profile.totalAmount || '0'}</p>
                        <p className="text-xs text-gray-700">HST Inclusive</p>
                      </div>
                    </div>
                  </div>

                  {/* Payment Status */}
                  <div className="bg-orange-50 rounded-lg p-4">
                    <h4 className="font-semibold text-lg mb-3 text-black">Payment Status</h4>
                    <div className={`inline-block px-4 py-2 rounded-lg font-semibold ${profile.paymentStatus === 'Paid'
                      ? 'bg-orange-100 text-black'
                      : 'bg-orange-100 text-orange-800'
                      }`}>
                      {profile.paymentStatus === 'Paid' ? '✅ Paid' : '⏳ Pending'}
                    </div>
                  </div>
                </div>

                <div className="mt-6 flex justify-end">
                  <button
                    onClick={() => setShowMyInfoModal(false)}
                    className="bg-black hover:bg-gray-900 border-2 border-orange-500 text-white px-6 py-2 rounded-md"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Meal Preferences Modal */}
      <MealPreferencesModal
        isOpen={showPreferencesModal}
        onClose={() => { setShowPreferencesModal(false); setError(''); }}
        customerId={profile?.id}
        customerName={profile?.fullName}
        mealCount={profile?.mealCount}
        vegType={profile?.vegType}
        isAdmin={false}
        restrictVegNvEditing={true}
        setMessage={(msg) => { setSuccess(msg); setTimeout(() => setSuccess(''), 5000); loadData(); }}
        setError={setError}
      />

      {/* ↓ Old preferences modal removed — replaced by MealPreferencesModal above ↓ */}
      {false && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold flex items-center gap-2">
                  <Utensils className="w-6 h-6 text-orange-500" />
                  {needsPreferences() ? 'Set Your Meal Preferences' : 'Your Meal Preferences'}
                </h2>
                <button
                  onClick={() => setShowPreferencesModal(false)}
                  className="text-gray-400 hover:text-gray-700 text-2xl"
                >
                  ×
                </button>
              </div>

              <div className="bg-orange-50 p-4 rounded-lg border border-orange-200 mb-6">
                <p className="text-sm text-black">
                  <strong>Your Plan:</strong> {profile?.planKey || 'N/A'}
                </p>
                {needsPreferences() ? (
                  <p className="text-sm text-black mt-1">
                    Please specify your meal preferences to help us prepare your meals accurately.
                  </p>
                ) : (
                  <p className="text-sm text-black mt-1">
                    ✅ No meal preferences needed for your plan. Your meals will be prepared according to your plan type.
                  </p>
                )}
              </div>

              {showMealPreferenceModeToggle && (
                <div className="mb-6 flex rounded-lg border border-gray-200 bg-gray-50 p-1">
                  <button
                    onClick={() => setPreferencesModalMode('view')}
                    className={`flex-1 rounded-md px-4 py-2 text-sm font-semibold transition-colors ${preferencesModalMode === 'view' ? 'bg-white text-orange-600 shadow-sm' : 'text-gray-600 hover:text-black'}`}
                  >
                    View
                  </button>
                  <button
                    onClick={() => setPreferencesModalMode('edit')}
                    className={`flex-1 rounded-md px-4 py-2 text-sm font-semibold transition-colors ${preferencesModalMode === 'edit' ? 'bg-white text-orange-600 shadow-sm' : 'text-gray-600 hover:text-black'}`}
                  >
                    Edit
                  </button>
                </div>
              )}

              {preferencesModalMode === 'view' ? (
                <div className="space-y-4">
                  <div className="rounded-lg border border-gray-200 bg-white p-4">
                    <p className="text-sm font-bold text-gray-900 mb-2">Saved Meal Setup</p>
                    {mealPreferenceSummaryLines.length > 0 ? (
                      <div className="space-y-1 text-sm text-gray-700">
                        {mealPreferenceSummaryLines.map((line) => (
                          <p key={line}>{line}</p>
                        ))}
                      </div>
                    ) : (
                      <p className="text-sm italic text-gray-500">No meal preferences have been saved yet.</p>
                    )}
                  </div>

                  {canEditCurrentPlanMeals && (
                    <div className="rounded-lg border border-orange-200 bg-orange-50 p-4">
                      <div className="flex items-start justify-between gap-4">
                        <div>
                          <p className="text-sm font-bold text-black">Current Plan B / L / D</p>
                          <p className="text-sm text-gray-700 mt-1">
                            {activeMealSlots.selected_meals?.length > 0
                              ? activeMealSlots.selected_meals.join(', ')
                              : 'Lunch, Dinner'}
                            {activeMealSlots.nv_day_veg_slot ? ` • Veg slot: ${activeMealSlots.nv_day_veg_slot}` : ''}
                          </p>
                        </div>
                        <Button
                          size="sm"
                          className="bg-orange-500 hover:bg-orange-600 text-white"
                          onClick={() => setPreferencesModalMode('edit')}
                        >
                          Edit B / L / D
                        </Button>
                      </div>
                      <p className="text-xs text-gray-600 mt-3">
                        This changes your recurring meal-slot preference for the active plan, not just the next 2 delivery days.
                      </p>
                    </div>
                  )}

                  {canEditLockedMealPreferences && !canEditCurrentPlanMeals && (
                    <Button
                      className="w-full bg-orange-500 hover:bg-orange-600"
                      onClick={() => setPreferencesModalMode('edit')}
                    >
                      Edit Preferences
                    </Button>
                  )}

                  <div className="flex justify-end mt-6">
                    <Button
                      onClick={() => {
                        setShowPreferencesModal(false);
                        setError('');
                      }}
                      className="bg-orange-500 hover:bg-orange-600"
                    >
                      Close
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="space-y-6">
                    {canEditCurrentPlanMeals && (
                      <div className="rounded-lg border border-orange-200 bg-orange-50 p-4">
                        <div className="flex items-center justify-between gap-4 mb-3">
                          <div>
                            <p className="font-bold text-black">Edit Current Plan B / L / D</p>
                            <p className="text-sm text-gray-700">
                              Update your recurring meal-slot preference for the active plan.
                            </p>
                          </div>
                          <span className="text-xs bg-orange-500 text-white px-2 py-1 rounded">
                            Current Plan
                          </span>
                        </div>

                        <div className="flex flex-wrap gap-3">
                          {['Breakfast', 'Lunch', 'Dinner'].map((meal) => {
                            const isSelected = (activeMealSlots.selected_meals || []).includes(meal);
                            const atMax = (activeMealSlots.selected_meals || []).length >= 2 && !isSelected;
                            return (
                              <label key={meal} className={`flex items-center gap-2 rounded border bg-white px-3 py-2 text-sm ${atMax ? 'opacity-50' : ''}`}>
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  disabled={savingActiveMealSlots || atMax}
                                  onChange={(e) => {
                                    const currentMeals = activeMealSlots.selected_meals || [];
                                    const selectedMeals = e.target.checked
                                      ? [...currentMeals, meal]
                                      : currentMeals.filter(item => item !== meal);
                                    const nextVegSlot = selectedMeals.includes(activeMealSlots.nv_day_veg_slot)
                                      ? activeMealSlots.nv_day_veg_slot
                                      : (selectedMeals[0] || '');
                                    setActiveMealSlots({
                                      ...activeMealSlots,
                                      selected_meals: selectedMeals,
                                      nv_day_veg_slot: nextVegSlot
                                    });
                                  }}
                                  className="rounded"
                                />
                                <span>{meal}</span>
                              </label>
                            );
                          })}
                        </div>

                        {activeMealSlots.plan_context?.nvMealsPerDay === 1 && !activeMealSlots.plan_context?.isVegPlan && (
                          <div className="mt-4 space-y-2">
                            <p className="text-sm font-semibold text-gray-800">Which selected slot stays veg on non-veg days?</p>
                            <div className="flex flex-wrap gap-3">
                              {(activeMealSlots.selected_meals || []).map((meal) => (
                                <label key={meal} className="flex items-center gap-2 rounded border bg-white px-3 py-2 text-sm">
                                  <input
                                    type="radio"
                                    name="modal_active_nv_day_veg_slot"
                                    checked={activeMealSlots.nv_day_veg_slot === meal}
                                    onChange={() => setActiveMealSlots({ ...activeMealSlots, nv_day_veg_slot: meal })}
                                    className="rounded"
                                  />
                                  <span>{meal}</span>
                                </label>
                              ))}
                            </div>
                          </div>
                        )}

                        <div className="mt-4 flex justify-end">
                          <Button
                            className="bg-orange-500 hover:bg-orange-600 text-white"
                            disabled={
                              savingActiveMealSlots ||
                              (activeMealSlots.selected_meals || []).length !== 2 ||
                              (activeMealSlots.plan_context?.nvMealsPerDay === 1 &&
                                !activeMealSlots.plan_context?.isVegPlan &&
                                !(activeMealSlots.selected_meals || []).includes(activeMealSlots.nv_day_veg_slot))
                            }
                            onClick={() => saveCurrentPlanMeals()}
                          >
                            {savingActiveMealSlots ? 'Saving...' : 'Save Current Plan Meals'}
                          </Button>
                        </div>
                      </div>
                    )}

                    {canEditLockedMealPreferences ? (
                      <div className="space-y-6">
                        {getPreferenceQuestions().map((question, index) => (
                          <div key={index} className="space-y-3">
                            <label className="text-lg font-semibold">{question.title} *</label>
                            <p className="text-sm text-gray-700">{question.description}</p>

                            <div className="space-y-2">
                              {question.options.map((option) => {
                                const isChecked = question.type === 'chicken_days'
                                  ? preferenceFormData.chicken_days.includes(option)
                                  : question.type === 'single_meal'
                                    ? preferenceFormData[question.key] === option
                                    : question.type === 'two_meals'
                                      ? preferenceFormData[question.key]?.includes(option)
                                      : false;

                                const currentCount = question.type === 'chicken_days'
                                  ? preferenceFormData.chicken_days.length
                                  : question.type === 'two_meals'
                                    ? preferenceFormData[question.key]?.length || 0
                                    : 0;

                                const isDisabled = question.type === 'single_meal'
                                  ? (question.key === 'nv_day_veg_slot' &&
                                    !(preferenceFormData.selected_meals || []).includes(option))
                                  : !isChecked && currentCount >= question.required;

                                return (
                                  <label key={option} className="flex items-center gap-3 p-3 border rounded-lg hover:bg-white cursor-pointer">
                                    <input
                                      type={question.type === 'single_meal' ? 'radio' : 'checkbox'}
                                      name={question.key}
                                      checked={isChecked}
                                      onChange={(e) => {
                                        if (question.type === 'chicken_days') {
                                          const newDays = e.target.checked
                                            ? [...preferenceFormData.chicken_days, option]
                                            : preferenceFormData.chicken_days.filter(d => d !== option);
                                          setPreferenceFormData({
                                            ...preferenceFormData,
                                            chicken_days: newDays
                                          });
                                        } else if (question.type === 'single_meal') {
                                          setPreferenceFormData({
                                            ...preferenceFormData,
                                            [question.key]: option
                                          });
                                        } else if (question.type === 'two_meals') {
                                          const currentArray = preferenceFormData[question.key] || [];
                                          const newArray = e.target.checked
                                            ? [...currentArray, option]
                                            : currentArray.filter(m => m !== option);
                                          const nextVegSlot = question.key === 'selected_meals' && !newArray.includes(preferenceFormData.nv_day_veg_slot)
                                            ? (newArray[0] || '')
                                            : preferenceFormData.nv_day_veg_slot;
                                          setPreferenceFormData({
                                            ...preferenceFormData,
                                            [question.key]: newArray,
                                            nv_day_veg_slot: nextVegSlot
                                          });
                                        }
                                      }}
                                      disabled={isDisabled}
                                      className="w-5 h-5"
                                    />
                                    <span className="font-medium">{option}</span>
                                  </label>
                                );
                              })}
                            </div>

                            {question.type === 'chicken_days' && preferenceFormData.chicken_days.length > 0 &&
                              preferenceFormData.chicken_days.length !== question.required && (
                                <p className="text-sm text-orange-500">
                                  Please select exactly {question.required} days (currently {preferenceFormData.chicken_days.length} selected)
                                </p>
                              )}
                            {question.type === 'two_meals' && preferenceFormData[question.key]?.length > 0 &&
                              preferenceFormData[question.key]?.length !== question.required && (
                                <p className="text-sm text-orange-500">
                                  Please select exactly {question.required} meals (currently {preferenceFormData[question.key]?.length} selected)
                                </p>
                              )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
                        <p className="text-sm font-semibold text-gray-800">Locked plan preferences</p>
                        <p className="text-sm text-gray-600 mt-1">
                          These preferences are fixed for the current cycle and can be changed again at renewal. You can still update the active plan B / L / D selection above.
                        </p>
                      </div>
                    )}
                  </div>

                  {error && (
                    <div className="mt-4 bg-orange-50 border border-orange-200 text-black px-4 py-3 rounded">
                      {error}
                    </div>
                  )}

                  <div className="flex gap-3 mt-6">
                    {canEditLockedMealPreferences && (
                      <Button
                        onClick={async () => {
                          const questions = getPreferenceQuestions();
                          for (const question of questions) {
                            if (question.type === 'chicken_days' && preferenceFormData.chicken_days.length !== question.required) {
                              setError(`Please select exactly ${question.required} days for chicken`);
                              return;
                            }
                            if (question.type === 'single_meal') {
                              if (!preferenceFormData[question.key]) {
                                setError(`Please select ${question.title.toLowerCase()}`);
                                return;
                              }
                              if (question.key === 'nv_day_veg_slot' &&
                                !(preferenceFormData.selected_meals || []).includes(preferenceFormData[question.key])) {
                                setError('NV day veg slot must be one of your selected meal slots.');
                                return;
                              }
                            }
                            if (question.type === 'two_meals') {
                              if (preferenceFormData[question.key].length !== question.required) {
                                setError(`Please select exactly ${question.required} meals for ${question.title.toLowerCase()}`);
                                return;
                              }
                            }
                          }

                          setError('');
                          await savePreferences();
                        }}
                        className="flex-1 bg-orange-500 hover:bg-orange-600"
                      >
                        Save Preferences
                      </Button>
                    )}
                    <Button
                      onClick={() => {
                        setPreferencesModalMode('view');
                        setError('');
                      }}
                      variant="outline"
                      className="flex-1"
                    >
                      {canEditLockedMealPreferences ? 'Back' : 'Close'}
                    </Button>
                  </div>
                </>
              )}
            </div>
          </div>
        )
      }

      {/* Daily Reflection Modal */}
      {
        showReflectionModal && (
          <DailyReflectionModal
            initialData={todayReflection}
            onClose={() => setShowReflectionModal(false)}
            onSubmit={() => {
              setShowReflectionModal(false);
              loadData();
            }}
          />
        )
      }

      {/* Reports Modal */}
      {
        showReportModal && (
          <ReportsModal
            onClose={() => setShowReportModal(false)}
          />
        )
      }

      {/* To-Do Modal */}
      {
        showTodoModal && (
          <TodoModal
            onClose={() => setShowTodoModal(false)}
            onSubmit={() => {
              setShowTodoModal(false);
              loadData();
            }}
          />
        )
      }

      {/* Renew Same Plan Modal */}
      {
        showRenewSameModal && (() => {
          // Find the selected notification
          const currentNotification = notifications.find(n => n.id === selectedNotification);
          const renewalTotal = currentNotification?.data?.renewal_total || profile?.totalAmount || 0;
          const currentTotal = currentNotification?.data?.current_total || profile?.totalAmount || 0;
          // Only show price change if there's a meaningful difference (more than $0.01)
          const priceChanged = Math.abs(renewalTotal - currentTotal) > 0.01;

          return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-lg max-w-md w-full p-6">
                <h2 className="text-2xl font-bold mb-4">🔄 Renew Current Plan</h2>

                <div className="bg-orange-50 p-4 rounded-lg border border-orange-200 mb-4">
                  <p className="text-sm text-black">
                    <strong>Current Plan:</strong> {profile?.planKey || 'N/A'}
                  </p>
                  <div className="mt-2 space-y-1 text-sm">
                    <div className="flex justify-between text-gray-700">
                      <span>Subtotal (before tax):</span>
                      <span>${getBasePrice(renewalTotal)}</span>
                    </div>
                    <div className="flex justify-between text-gray-700">
                      <span>HST (13%):</span>
                      <span>${getHSTAmount(renewalTotal)}</span>
                    </div>
                    <div className="flex justify-between font-bold text-black pt-1 border-t border-orange-200">
                      <span>Renewal Total:</span>
                      <span>${formatPrice(renewalTotal)}</span>
                    </div>
                  </div>
                  {(profile?.additionalCharges || 0) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">Includes additional charges: +${profile.additionalCharges.toFixed(2)}</p>
                  )}
                  {(profile?.additionalDiscount || 0) > 0 && (
                    <p className="text-xs text-green-700 mt-1">Includes discount: -${profile.additionalDiscount.toFixed(2)}</p>
                  )}
                  {priceChanged && (
                    <p className="text-xs text-orange-600 mt-2">
                      * Price updated. Your previous plan was ${formatPrice(currentTotal)}
                    </p>
                  )}
                </div>

                <div className="mb-4">
                  <Label htmlFor="newStartDate">Select New Start Date *</Label>
                  <Input
                    id="newStartDate"
                    type="date"
                    min={renewalStartMin}
                    value={renewalFormData.newStartDate}
                    onChange={(e) => {
                      const selectedDate = e.target.value;
                      if (selectedDate) {
                        const day = new Date(selectedDate + 'T12:00:00Z').getUTCDay();
                        if (day === 0 || day === 6) {
                          setError('Please select a weekday (Monday-Friday). Delivery is not available on Saturday and Sunday.');
                          setRenewalFormData({ ...renewalFormData, newStartDate: renewalStartMin });
                          return;
                        }
                        if (selectedDate < renewalStartMin) {
                          setError(`Start date cannot be before ${renewalStartMin}. Your current plan runs until the end date.`);
                          return;
                        }
                        setError('');
                      }
                      setRenewalFormData({ ...renewalFormData, newStartDate: selectedDate });
                    }}
                    className="mt-1"
                  />
                  <p className="text-xs text-gray-700 mt-1">Your renewed plan will start after your current plan ends (weekdays only, Mon-Fri)</p>
                </div>

                {error && (
                  <div className="mb-4 bg-orange-50 border border-orange-200 text-black px-4 py-3 rounded">
                    {error}
                  </div>
                )}

                <div className="flex gap-3">
                  <Button
                    onClick={submitRenewSame}
                    className="flex-1 bg-orange-500 hover:bg-orange-600"
                  >
                    ✅ Confirm Renewal
                  </Button>
                  <Button
                    onClick={() => {
                      setShowRenewSameModal(false);
                      setError('');
                    }}
                    variant="outline"
                    className="flex-1"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          );
        })()
      }

      {/* Change Plan Modal */}
      {
        showChangePlanModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto">
              <h2 className="text-2xl font-bold mb-4">🔄 Change Your Plan</h2>

              <div className="bg-orange-50 p-4 rounded-lg border border-black mb-4">
                <p className="text-sm text-orange-500">
                  Our team will review your request and confirm the exact pricing with you before processing.
                </p>
              </div>

              <div className="space-y-4">
                {/* Meal Plan Type */}
                <div>
                  <Label htmlFor="mealPlanType">Meal Plan Type *</Label>
                  <select
                    id="mealPlanType"
                    value={renewalFormData.mealPlanType}
                    onChange={(e) => {
                      const newType = e.target.value;
                      setRenewalFormData({
                        ...renewalFormData,
                        mealPlanType: newType,
                        mealPlanTerm: '5 Days Veg', // Reset to valid option
                        nvPreference: '',  // Reset preference
                        selectedMeals: newType === '2 Meals a Day' ? ['Lunch', 'Dinner'] : ['Breakfast', 'Lunch', 'Dinner'],
                        nvDayVegSlot: 'Lunch',
                        chickenDays: [],
                        dailyVegMeals: ['Breakfast', 'Lunch'],
                        nvDayVegMeal: 'Breakfast',
                        nvDayVegMeals: ['Breakfast', 'Lunch'],
                        vegMealChoice: 'Breakfast'
                      });
                    }}
                    className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md"
                  >
                    <option value="2 Meals a Day">2 Meals a Day</option>
                    <option value="3 Meals a Day">3 Meals a Day</option>
                  </select>
                </div>

                {/* Meal Plan Term - Dynamic based on Meal Plan Type */}
                <div>
                  <Label htmlFor="mealPlanTerm">Meal Plan Term *</Label>
                  <select
                    id="mealPlanTerm"
                    value={renewalFormData.mealPlanTerm}
                    onChange={(e) => {
                      setRenewalFormData({
                        ...renewalFormData,
                        mealPlanTerm: e.target.value,
                        nvPreference: '', // Reset preference when term changes
                        nvDayVegSlot: renewalFormData.selectedMeals?.[0] || 'Lunch',
                        chickenDays: [],
                        dailyVegMeals: ['Breakfast', 'Lunch'],
                        nvDayVegMeal: 'Breakfast',
                        nvDayVegMeals: ['Breakfast', 'Lunch'],
                        vegMealChoice: 'Breakfast'
                      });
                    }}
                    className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md"
                  >
                    <option value="">Select plan term...</option>
                    {renewalFormData.mealPlanType === '2 Meals a Day' ? (
                      <>
                        <option value="5 Days Veg">5 Days Veg</option>
                        <option value="5 Days Non-Veg">5 Days Non-Veg</option>
                        <option value="2 Days Non-Veg, 3 Days Veg">2 Days Non-Veg, 3 Days Veg</option>
                      </>
                    ) : (
                      <>
                        <option value="5 Days Veg">5 Days Veg</option>
                        <option value="5 Days Non-Veg">5 Days Non-Veg</option>
                        <option value="2 Days Non-Veg, 3 Days Veg">2 Days Non-Veg, 3 Days Veg</option>
                      </>
                    )}
                  </select>
                </div>

                {/* Non-Veg Preference - Dynamic based on Meal Plan Type and Term */}
                {renewalFormData.mealPlanTerm && renewalFormData.mealPlanTerm.includes('Non-Veg') && renewalFormData.mealPlanTerm !== '5 Days Veg' && (
                  <div>
                    <Label htmlFor="nvPreference">Non-Veg Preference</Label>
                    <select
                      id="nvPreference"
                      value={renewalFormData.nvPreference}
                      onChange={(e) => setRenewalFormData({ ...renewalFormData, nvPreference: e.target.value })}
                      className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md"
                    >
                      <option value="">Select or leave for default</option>
                      {renewalFormData.mealPlanType === '2 Meals a Day' && renewalFormData.mealPlanTerm === '5 Days Non-Veg' && (
                        <>
                          <option value="1 NV + 1 Veg">1 NV + 1 Veg</option>
                          <option value="Both NV">Both NV</option>
                        </>
                      )}
                      {renewalFormData.mealPlanType === '2 Meals a Day' && renewalFormData.mealPlanTerm === '2 Days Non-Veg, 3 Days Veg' && (
                        <>
                          <option value="1 NV + 1 Veg">1 NV + 1 Veg</option>
                          <option value="Both NV">Both NV</option>
                        </>
                      )}
                      {renewalFormData.mealPlanType === '3 Meals a Day' && renewalFormData.mealPlanTerm === '5 Days Non-Veg' && (
                        <>
                          <option value="1 NV/day">1 NV/day</option>
                          <option value="2 NV/day">2 NV/day</option>
                        </>
                      )}
                      {renewalFormData.mealPlanType === '3 Meals a Day' && renewalFormData.mealPlanTerm === '2 Days Non-Veg, 3 Days Veg' && (
                        <>
                          <option value="1 NV/day">1 NV/day</option>
                          <option value="2 NV/day">2 NV/day</option>
                        </>
                      )}
                    </select>
                  </div>
                )}

                {renewalFormData.mealPlanType === '2 Meals a Day' && (
                  <div className="space-y-3">
                    <Label>Which 2 meal slots do you want?</Label>
                    <div className="flex gap-3">
                      {['Breakfast', 'Lunch', 'Dinner'].map((meal) => {
                        const isSelected = (renewalFormData.selectedMeals || []).includes(meal);
                        const atMax = (renewalFormData.selectedMeals || []).length >= 2 && !isSelected;
                        return (
                          <label key={meal} className={`flex items-center gap-2 rounded border px-3 py-2 text-sm ${atMax ? 'opacity-50' : ''}`}>
                            <input
                              type="checkbox"
                              checked={isSelected}
                              disabled={atMax}
                              onChange={(e) => {
                                const currentMeals = renewalFormData.selectedMeals || [];
                                const selectedMeals = e.target.checked
                                  ? [...currentMeals, meal]
                                  : currentMeals.filter(item => item !== meal);
                                setRenewalFormData({
                                  ...renewalFormData,
                                  selectedMeals,
                                  nvDayVegSlot: selectedMeals.includes(renewalFormData.nvDayVegSlot)
                                    ? renewalFormData.nvDayVegSlot
                                    : (selectedMeals[0] || '')
                                });
                              }}
                              className="rounded"
                            />
                            <span>{meal}</span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                )}

                {renewalFormData.mealPlanType === '2 Meals a Day' &&
                  renewalFormData.mealPlanTerm.includes('Non-Veg') &&
                  renewalFormData.nvPreference !== 'Both NV' && (
                    <div className="space-y-3">
                      <Label>On non-veg days, which selected slot stays veg?</Label>
                      <div className="flex gap-3">
                        {(renewalFormData.selectedMeals || []).map((meal) => (
                          <label key={meal} className="flex items-center gap-2 rounded border px-3 py-2 text-sm">
                            <input
                              type="radio"
                              name="renewalNvDayVegSlot"
                              checked={renewalFormData.nvDayVegSlot === meal}
                              onChange={() => setRenewalFormData({ ...renewalFormData, nvDayVegSlot: meal })}
                              className="rounded"
                            />
                            <span>{meal}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}

                {renewalFormData.mealPlanTerm === '2 Days Non-Veg, 3 Days Veg' && (
                  <div className="space-y-3">
                    <Label>Which 2 days should be non-veg?</Label>
                    <div className="flex flex-wrap gap-3">
                      {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'].map((day) => {
                        const isSelected = (renewalFormData.chickenDays || []).includes(day);
                        const atMax = (renewalFormData.chickenDays || []).length >= 2 && !isSelected;
                        return (
                          <label key={day} className={`flex items-center gap-2 rounded border px-3 py-2 text-sm ${atMax ? 'opacity-50' : ''}`}>
                            <input
                              type="checkbox"
                              checked={isSelected}
                              disabled={atMax}
                              onChange={(e) => {
                                const currentDays = renewalFormData.chickenDays || [];
                                const chickenDays = e.target.checked
                                  ? [...currentDays, day]
                                  : currentDays.filter(item => item !== day);
                                setRenewalFormData({
                                  ...renewalFormData,
                                  chickenDays
                                });
                              }}
                              className="rounded"
                            />
                            <span>{day}</span>
                          </label>
                        );
                      })}
                    </div>
                  </div>
                )}

                {renewalFormData.mealPlanType === '3 Meals a Day' &&
                  renewalFormData.mealPlanTerm === '5 Days Non-Veg' &&
                  getEffectiveRenewalNvPreference() !== '2 NV/day' && (
                    <div className="space-y-3">
                      <Label>Which 2 meals stay veg every day?</Label>
                      <div className="flex gap-3">
                        {['Breakfast', 'Lunch', 'Dinner'].map((meal) => {
                          const isSelected = (renewalFormData.dailyVegMeals || []).includes(meal);
                          const atMax = (renewalFormData.dailyVegMeals || []).length >= 2 && !isSelected;
                          return (
                            <label key={meal} className={`flex items-center gap-2 rounded border px-3 py-2 text-sm ${atMax ? 'opacity-50' : ''}`}>
                              <input
                                type="checkbox"
                                checked={isSelected}
                                disabled={atMax}
                                onChange={(e) => {
                                  const currentMeals = renewalFormData.dailyVegMeals || [];
                                  const dailyVegMeals = e.target.checked
                                    ? [...currentMeals, meal]
                                    : currentMeals.filter(item => item !== meal);
                                  setRenewalFormData({
                                    ...renewalFormData,
                                    dailyVegMeals
                                  });
                                }}
                                className="rounded"
                              />
                              <span>{meal}</span>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  )}

                {renewalFormData.mealPlanType === '3 Meals a Day' &&
                  renewalFormData.mealPlanTerm === '5 Days Non-Veg' &&
                  getEffectiveRenewalNvPreference() === '2 NV/day' && (
                    <div className="space-y-3">
                      <Label>Which 1 meal stays veg every day?</Label>
                      <div className="flex gap-3">
                        {['Breakfast', 'Lunch', 'Dinner'].map((meal) => (
                          <label key={meal} className="flex items-center gap-2 rounded border px-3 py-2 text-sm">
                            <input
                              type="radio"
                              name="renewalVegMealChoice"
                              checked={renewalFormData.vegMealChoice === meal}
                              onChange={() => setRenewalFormData({ ...renewalFormData, vegMealChoice: meal })}
                              className="rounded"
                            />
                            <span>{meal}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}

                {renewalFormData.mealPlanType === '3 Meals a Day' &&
                  renewalFormData.mealPlanTerm === '2 Days Non-Veg, 3 Days Veg' &&
                  getEffectiveRenewalNvPreference() !== '2 NV/day' && (
                    <div className="space-y-3">
                      <Label>On non-veg days, which 2 meals stay veg?</Label>
                      <div className="flex gap-3">
                        {['Breakfast', 'Lunch', 'Dinner'].map((meal) => {
                          const isSelected = (renewalFormData.nvDayVegMeals || []).includes(meal);
                          const atMax = (renewalFormData.nvDayVegMeals || []).length >= 2 && !isSelected;
                          return (
                            <label key={meal} className={`flex items-center gap-2 rounded border px-3 py-2 text-sm ${atMax ? 'opacity-50' : ''}`}>
                              <input
                                type="checkbox"
                                checked={isSelected}
                                disabled={atMax}
                                onChange={(e) => {
                                  const currentMeals = renewalFormData.nvDayVegMeals || [];
                                  const nvDayVegMeals = e.target.checked
                                    ? [...currentMeals, meal]
                                    : currentMeals.filter(item => item !== meal);
                                  setRenewalFormData({
                                    ...renewalFormData,
                                    nvDayVegMeals
                                  });
                                }}
                                className="rounded"
                              />
                              <span>{meal}</span>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  )}

                {renewalFormData.mealPlanType === '3 Meals a Day' &&
                  renewalFormData.mealPlanTerm === '2 Days Non-Veg, 3 Days Veg' &&
                  getEffectiveRenewalNvPreference() === '2 NV/day' && (
                    <div className="space-y-3">
                      <Label>On non-veg days, which 1 meal stays veg?</Label>
                      <div className="flex gap-3">
                        {['Breakfast', 'Lunch', 'Dinner'].map((meal) => (
                          <label key={meal} className="flex items-center gap-2 rounded border px-3 py-2 text-sm">
                            <input
                              type="radio"
                              name="renewalNvDayVegMeal"
                              checked={renewalFormData.nvDayVegMeal === meal}
                              onChange={() => setRenewalFormData({ ...renewalFormData, nvDayVegMeal: meal })}
                              className="rounded"
                            />
                            <span>{meal}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}

                {/* Billing Term */}
                <div>
                  <Label htmlFor="planTerm">Billing Term *</Label>
                  <select
                    id="planTerm"
                    value={renewalFormData.planTerm}
                    onChange={(e) => setRenewalFormData({ ...renewalFormData, planTerm: e.target.value })}
                    className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md"
                  >
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                  </select>
                </div>

                {/* Add-ons - Actual add-ons from pricing calculator */}
                <div>
                  <Label>Add-ons (Optional)</Label>
                  <div className="mt-2 space-y-2">
                    {['5 Eggs Daily', '1 Veg Meal Daily', '1 Non Veg Meal Daily', 'Bulk Me Up', 'Protein Balls (2)', 'Fruit on the Side'].map(addon => (
                      <label key={addon} className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={renewalFormData.addOns.includes(addon)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setRenewalFormData({
                                ...renewalFormData,
                                addOns: [...renewalFormData.addOns, addon]
                              });
                            } else {
                              setRenewalFormData({
                                ...renewalFormData,
                                addOns: renewalFormData.addOns.filter(a => a !== addon)
                              });
                            }
                          }}
                          className="rounded"
                        />
                        <span className="text-sm">{addon}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              {/* Price Preview - Calculate new plan pricing */}
              {renewalFormData.mealPlanTerm && (() => {
                let preference = renewalFormData.nvPreference;
                if (!preference && renewalFormData.mealPlanTerm.includes('Non-Veg')) {
                  preference = renewalFormData.mealPlanType === '2 Meals a Day' ? '1 NV + 1 Veg' : '1 NV/day';
                }
                const mealPlanPrice = lookupPlanPrice(renewalFormData.mealPlanType, renewalFormData.mealPlanTerm, preference, renewalFormData.planTerm);
                const addOnsPrice = sumAddOnsPrice(renewalFormData.addOns, renewalFormData.planTerm);
                const charges = profile?.additionalCharges || 0;
                const discount = profile?.additionalDiscount || 0;
                const newTotal = mealPlanPrice + addOnsPrice + charges - discount;

                return (
                  <div className="mt-4 rounded-lg border-2 border-orange-200 bg-orange-50 p-4">
                    <h3 className="font-semibold mb-3 text-black text-lg">New Plan Price Preview</h3>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span>Meal Plan Price:</span>
                        <strong>${getBasePrice(mealPlanPrice)}</strong>
                      </div>
                      <div className="flex justify-between">
                        <span>Add-ons Price:</span>
                        <strong>${getBasePrice(addOnsPrice)}</strong>
                      </div>
                      {charges > 0 && (
                        <div className="flex justify-between">
                          <span>Additional Charges:</span>
                          <strong>+${getBasePrice(charges)}</strong>
                        </div>
                      )}
                      {discount > 0 && (
                        <div className="flex justify-between text-green-700">
                          <span>Discount:</span>
                          <strong>-${getBasePrice(discount)}</strong>
                        </div>
                      )}
                      <div className="flex justify-between pt-2 mt-1 border-t border-orange-200">
                        <span>Subtotal:</span>
                        <strong>${getBasePrice(newTotal)}</strong>
                      </div>
                      <div className="flex justify-between text-orange-700">
                        <span>HST (13%):</span>
                        <strong>${getHSTAmount(newTotal)}</strong>
                      </div>
                      <div className="flex justify-between text-lg font-bold mt-3 pt-3 border-t-2 border-orange-300">
                        <span>New Total:</span>
                        <span className="text-orange-500">${formatPrice(newTotal)}</span>
                      </div>
                    </div>
                    <p className="text-xs text-gray-700 mt-3">
                      This is a price preview based on your selections. Our team will confirm the final pricing with you before processing.
                    </p>
                    {!renewalFormData.nvPreference && renewalFormData.mealPlanTerm.includes('Non-Veg') && (
                      <p className="text-xs text-orange-500 mt-2">
                        ℹ️ No preference selected - showing price for default option (1 NV option). Select preference above for different pricing.
                      </p>
                    )}
                  </div>
                );
              })()}

              {error && (
                <div className="mt-4 bg-orange-50 border border-orange-200 text-black px-4 py-3 rounded">
                  {error}
                </div>
              )}

              <div className="flex gap-3 mt-6">
                <Button
                  onClick={submitChangePlan}
                  className="flex-1 bg-orange-500 hover:bg-orange-600"
                >
                  📤 Submit Plan Change Request
                </Button>
                <Button
                  onClick={() => {
                    setShowChangePlanModal(false);
                    setError('');
                    setRenewalFormData(prev => ({
                      ...prev,
                      newStartDate: renewalStartMin,
                      mealPlanType: '2 Meals a Day',
                      mealPlanTerm: '5 Days Veg',
                      nvPreference: '',
                      selectedMeals: ['Lunch', 'Dinner'],
                      nvDayVegSlot: 'Lunch',
                      chickenDays: [],
                      dailyVegMeals: ['Breakfast', 'Lunch'],
                      nvDayVegMeal: 'Breakfast',
                      nvDayVegMeals: ['Breakfast', 'Lunch'],
                      vegMealChoice: 'Breakfast',
                      addOns: [],
                      planTerm: 'Monthly'
                    }));
                  }}
                  variant="outline"
                  className="flex-1"
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )
      }
      {/* Add Measurement Modal */}
      {
        showMeasurementModal && (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
            <Card className="bg-white w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl border-2 border-orange-500">
              <CardHeader className="bg-gradient-to-r from-black via-gray-900 to-black text-white rounded-t-lg border-b-4 border-orange-500">
                <div className="flex justify-between items-center">
                  <div>
                    <CardTitle className="text-2xl font-bold">📏 Add Measurement</CardTitle>
                    <p className="text-orange-300 text-sm mt-1">Track your progress and transformation</p>
                  </div>
                  <button
                    onClick={() => {
                      setShowMeasurementModal(false);
                      setMeasurementPresets(prev => prev.map(p => ({ ...p, value: '' })));
                      setMeasurementDate(new Date().toISOString().split('T')[0]);
                    }}
                    className="text-white hover:text-orange-500 transition-colors text-3xl font-bold"
                  >
                    ×
                  </button>
                </div>
              </CardHeader>
              <CardContent className="p-6 space-y-6 bg-gradient-to-b from-white to-gray-50">
                {/* Date Selection */}
                <div className="bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-lg border-2 border-orange-200">
                  <Label className="text-black font-bold text-lg flex items-center gap-2 mb-3">
                    <span className="text-orange-500 text-2xl">📅</span> Date of Recording *
                  </Label>
                  <Input
                    type="date"
                    value={measurementDate}
                    onChange={(e) => setMeasurementDate(e.target.value)}
                    className="border-2 border-gray-300 focus:border-orange-500 rounded-lg text-lg py-6 px-4"
                  />
                </div>

                {/* Measurement Presets */}
                <div className="bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-lg border-2 border-orange-200">
                  <div className="flex justify-between items-center mb-4">
                    <Label className="text-black font-bold text-lg flex items-center gap-2">
                      <span className="text-orange-500 text-2xl">📐</span> Measurements
                    </Label>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => setShowAddPresetModal(true)}
                      className="border-2 border-orange-500 text-orange-600 hover:bg-orange-50 font-semibold"
                    >
                      + Add Custom
                    </Button>
                  </div>

                  <div className="space-y-4">
                    {measurementPresets.map((preset, index) => (
                      <div key={index} className="bg-white rounded-lg p-4 shadow-md border-l-4 border-orange-500 hover:shadow-xl transition-shadow">
                        <div className="flex gap-3 items-center">
                          <div className="flex-1">
                            <Label className="text-gray-900 font-semibold text-base mb-2 block">{preset.name}</Label>
                            <div className="flex gap-3">
                              <Input
                                type="number"
                                step="0.1"
                                value={preset.value}
                                onChange={(e) => updatePresetValue(index, e.target.value)}
                                placeholder="0.0"
                                className="flex-1 border-2 border-gray-300 focus:border-orange-500 rounded-lg py-3 px-4 text-lg"
                              />
                              <select
                                value={preset.unit}
                                onChange={(e) => updatePresetUnit(index, e.target.value)}
                                className="px-4 py-3 border-2 border-gray-300 focus:border-orange-500 rounded-lg bg-white text-gray-900 font-semibold"
                              >
                                <option value="kg">kg</option>
                                <option value="inches">inches</option>
                                <option value="cm">cm</option>
                                <option value="m">m</option>
                              </select>
                            </div>
                          </div>
                          {index >= 5 && (
                            <Button
                              size="sm"
                              variant="destructive"
                              onClick={() => removePreset(index)}
                              className="bg-red-500 hover:bg-red-600 text-white px-3 py-6 rounded-lg font-bold"
                            >
                              ×
                            </Button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </CardContent>
              <div className="flex justify-end gap-3 p-6 pt-0 border-t-2 border-gray-200">
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowMeasurementModal(false);
                    setMeasurementPresets(prev => prev.map(p => ({ ...p, value: '' })));
                    setMeasurementDate(new Date().toISOString().split('T')[0]);
                  }}
                  className="border-2 border-gray-300 px-6 py-3 hover:bg-gray-100"
                >
                  Cancel
                </Button>
                <Button
                  onClick={saveMeasurement}
                  className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-8 py-3 text-lg font-semibold shadow-lg"
                >
                  💾 Save Measurement
                </Button>
              </div>
            </Card>
          </div>
        )
      }

      {/* Add Preset Modal */}
      {
        showAddPresetModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <Card className="bg-white w-full max-w-md">
              <CardHeader className="bg-orange-500">
                <CardTitle className="text-xl text-white">Add Custom Preset</CardTitle>
              </CardHeader>
              <CardContent className="p-6 space-y-4">
                <div>
                  <Label className="text-gray-900">Preset Name *</Label>
                  <Input
                    value={newPreset.name}
                    onChange={(e) => setNewPreset({ ...newPreset, name: e.target.value })}
                    placeholder="e.g., Thigh, Neck, Forearm"
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label className="text-gray-900">Default Unit *</Label>
                  <select
                    value={newPreset.unit}
                    onChange={(e) => setNewPreset({ ...newPreset, unit: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded bg-white text-gray-900 mt-1"
                  >
                    <option value="kg">kg</option>
                    <option value="inches">inches</option>
                    <option value="cm">cm</option>
                    <option value="m">m</option>
                  </select>
                </div>
              </CardContent>
              <div className="flex justify-end gap-2 p-6 pt-0">
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowAddPresetModal(false);
                    setNewPreset({ name: '', unit: 'inches' });
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={addPreset}
                  className="bg-orange-500 hover:bg-orange-600 text-white"
                >
                  Add Preset
                </Button>
              </div>
            </Card>
          </div>
        )
      }



      {/* Payment Instructions Modal */}
      {
        showPaymentModal && paymentDetails && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-xl border-2 border-orange-500">
              <h2 className="text-2xl font-bold mb-4 text-center text-black">{paymentDetails.title}</h2>

              <div className="bg-black p-4 rounded-lg border-2 border-orange-500 mb-4">
                <p className="text-sm text-white mb-2">
                  <strong>Plan:</strong> {paymentDetails.plan}
                </p>
                <p className="text-2xl text-orange-500 font-bold mb-2">
                  Total: ${typeof paymentDetails.totalAmount === 'number' ? paymentDetails.totalAmount.toFixed(2) : paymentDetails.totalAmount}
                </p>
                {paymentDetails.renewalDate && (
                  <p className="text-sm text-white">
                    <strong>Next Renewal:</strong> {paymentDetails.renewalDate}
                  </p>
                )}
              </div>

              <div className="bg-orange-50 p-4 rounded-lg border-2 border-orange-500 mb-4">
                <h3 className="font-bold text-black mb-3 text-lg">📧 Payment Instructions</h3>
                <p className="text-sm text-black mb-2">
                  <strong>Send e-transfer to:</strong>
                </p>
                <p className="text-xl text-orange-600 font-bold mb-3 bg-white px-3 py-2 rounded border border-orange-300">
                  justproteinca@gmail.com
                </p>
                <p className="text-sm text-black mb-2">
                  <strong>Amount:</strong> <span className="text-orange-600 font-bold">${typeof paymentDetails.totalAmount === 'number' ? paymentDetails.totalAmount.toFixed(2) : paymentDetails.totalAmount}</span>
                </p>
                <p className="text-sm text-black">
                  <strong>Message:</strong> <span className="text-gray-700">{paymentDetails.customerName}</span>
                </p>
              </div>

              <p className="text-xs text-gray-600 text-center mb-4">
                You can find these details anytime in your notifications (bell icon)
              </p>

              <Button
                onClick={() => setShowPaymentModal(false)}
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold"
              >
                Got it!
              </Button>
            </div>
          </div>
        )
      }
    </div >
  );
}

// ─── Toast Notification System ─────────────────────────────────────────────
function useToastState() {
  const [toasts, setToasts] = React.useState([]);

  const addToast = React.useCallback((message, type = 'success') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type, visible: true }]);
    setTimeout(() => {
      setToasts(prev => prev.map(t => t.id === id ? { ...t, visible: false } : t));
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 400);
    }, 4000);
  }, []);

  return { toasts, addToast };
}

function ToastContainer({ toasts }) {
  const icons = {
    success: <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" />,
    error: <XCircle className="w-5 h-5 text-red-400 flex-shrink-0" />,
    warning: <AlertCircle className="w-5 h-5 text-amber-400 flex-shrink-0" />,
  };
  const bars = {
    success: 'bg-emerald-500',
    error: 'bg-red-500',
    warning: 'bg-amber-500',
  };
  const borders = {
    success: 'border-l-emerald-500',
    error: 'border-l-red-500',
    warning: 'border-l-amber-500',
  };

  return (
    <div className="fixed top-5 right-5 z-[9999] flex flex-col gap-3 pointer-events-none" style={{ minWidth: 0 }}>
      {toasts.map(t => (
        <div
          key={t.id}
          className={`
            pointer-events-auto
            flex items-start gap-3 p-4 pr-5 rounded-xl shadow-2xl
            bg-gray-900 border border-gray-700 border-l-4 ${borders[t.type] || borders.success}
            w-80 max-w-[calc(100vw-2.5rem)]
            transition-all duration-400 ease-out
            ${t.visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}
          `}
          style={{
            transform: t.visible ? 'translateX(0)' : 'translateX(2rem)',
            opacity: t.visible ? 1 : 0,
            transition: 'opacity 0.35s ease, transform 0.35s ease',
          }}
        >
          {icons[t.type] || icons.success}
          <p className="text-sm text-gray-100 leading-snug flex-1">{t.message}</p>
          {/* Progress bar */}
          <div className="absolute bottom-0 left-0 right-0 h-[3px] rounded-b-xl overflow-hidden">
            <div
              className={`h-full ${bars[t.type] || bars.success} origin-left`}
              style={{ animation: 'shrink 4s linear forwards' }}
            />
          </div>
        </div>
      ))}
      <style>{`
        @keyframes shrink {
          from { transform: scaleX(1); }
          to   { transform: scaleX(0); }
        }
      `}</style>
    </div>
  );
}
// ─── End Toast System ────────────────────────────────────────────────────────

// Rating Widget Component
function RatingWidget({ onSubmit }) {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { toasts, addToast } = useToastState();

  const handleSubmit = async () => {
    if (rating === 0) {
      addToast('Please select a rating before submitting.', 'warning');
      return;
    }

    try {
      setSubmitting(true);
      await http.post('/customer/update-requests', {
        request_type: 'feedback',
        decision: 'food_rating',
        rating: rating,
        feedback: feedback
      });

      addToast('Thank you for your feedback! ⭐', 'success');
      setRating(0);
      setFeedback('');
      onSubmit && onSubmit();
    } catch (error) {
      console.error('Error submitting rating:', error);
      addToast('Failed to submit rating. Please try again.', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer toasts={toasts} />
      <div className="space-y-3">
        <div className="flex justify-center gap-2">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              onClick={() => setRating(star)}
              className="focus:outline-none"
            >
              <Star
                className={`w-8 h-8 ${star <= rating ? 'fill-yellow-400 text-orange-500' : 'text-gray-300'
                  }`}
              />
            </button>
          ))}
        </div>
        <Textarea
          placeholder="Optional: Tell us more about your experience"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          rows={2}
        />
        <Button
          onClick={handleSubmit}
          disabled={submitting || rating === 0}
          className="w-full bg-orange-500 hover:bg-orange-600 text-white"
        >
          Submit Rating
        </Button>
      </div>
    </>
  );
}

// Request Modal Component
function RequestModal({ profile, onClose, onSubmit }) {
  const { toasts, addToast } = useToastState();
  const [requestType, setRequestType] = useState('');
  const [formData, setFormData] = useState({
    address: profile?.address?.street || '',
    city: profile?.address?.city || '',
    postalCode: profile?.address?.postalCode || '',
    phone: profile?.phone || '',
    deliveryInstructions: profile?.deliveryInstructions || '',
    foodInstructions: profile?.avoid || '',
    feedback: '',
    complaint: '',
    reason: '',
    effective_date: '',
    effectiveStartDate: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const requestTypes = [
    { value: 'change_address', label: 'Change Address' },
    { value: 'change_phone', label: 'Change Phone Number' },
    { value: 'change_delivery_instructions', label: 'Update Delivery Instructions' },
    { value: 'change_food_instructions', label: 'Update Food Preferences' },
    { value: 'delivery_feedback', label: 'Delivery Feedback' },
    { value: 'food_feedback', label: 'Food Feedback' }
  ];

  const handleSubmit = async () => {
    if (!requestType) {
      addToast('Please select a request type first.', 'warning');
      return;
    }

    // Validate address change requests
    if (requestType === 'change_address') {
      if (!formData.address || !formData.city || !formData.postalCode || !formData.propertyType || !formData.effectiveStartDate) {
        addToast('Please fill in all required fields: street, city, postal code, property type, and effective start date.', 'warning');
        return;
      }
    }

    try {
      setSubmitting(true);

      const requestData = {
        request_type: requestType,
        decision: requestType,
        details: formData
      };

      await http.post('/customer/update-requests', requestData);

      addToast('✅ Request submitted! Admin will review it soon.', 'success');
      setTimeout(() => { onSubmit && onSubmit(); }, 1500);
    } catch (error) {
      console.error('Error submitting request:', error);
      addToast('Failed to submit request: ' + (error.response?.data?.message || error.message), 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer toasts={toasts} />
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <Card className="w-full max-w-2xl max-h-[90vh] overflow-y-auto">
          <CardHeader>
            <CardTitle className="text-2xl">Submit a Request</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {/* Request Type Selection */}
            <div>
              <Label>What would you like to request?</Label>
              <select
                value={requestType}
                onChange={(e) => setRequestType(e.target.value)}
                className="w-full mt-1 p-2 border rounded"
              >
                <option value="">Select request type...</option>
                {requestTypes.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Dynamic Form Fields */}
            {requestType === 'change_address' && (
              <>
                <div className="bg-blue-50 border border-blue-200 rounded-md p-3 text-sm text-blue-800">
                  Note: Address changes require admin approval and will take effect from your selected start date.
                </div>
                <div>
                  <Label>Street Address *</Label>
                  <Input
                    value={formData.address}
                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                    required
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>City *</Label>
                    <Input
                      value={formData.city}
                      onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                      required
                    />
                  </div>
                  <div>
                    <Label>Postal Code *</Label>
                    <Input
                      value={formData.postalCode}
                      onChange={(e) => setFormData({ ...formData, postalCode: e.target.value })}
                      required
                    />
                  </div>
                </div>
                <div>
                  <Label>Property Type *</Label>
                  <select
                    value={formData.propertyType || ''}
                    onChange={(e) => setFormData({ ...formData, propertyType: e.target.value })}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
                    required
                  >
                    <option value="">Select property type...</option>
                    <option value="House">House</option>
                    <option value="Apartment">Apartment</option>
                    <option value="Condo">Condo</option>
                    <option value="Townhouse">Townhouse</option>
                    <option value="Office">Office</option>
                  </select>
                </div>
                <div>
                  <Label>Delivery Instructions</Label>
                  <Textarea
                    value={formData.deliveryInstructions}
                    onChange={(e) => setFormData({ ...formData, deliveryInstructions: e.target.value })}
                    rows={3}
                    placeholder="e.g., Leave at side door, ring bell twice, buzz code: 1234"
                  />
                </div>
                <div>
                  <Label>Effective Start Date *</Label>
                  <Input
                    type="date"
                    min={tomorrowToronto()}
                    value={formData.effectiveStartDate}
                    onChange={(e) => setFormData({ ...formData, effectiveStartDate: e.target.value })}
                    required
                  />
                  <p className="text-xs text-gray-500 mt-1">Earliest available date is tomorrow.</p>
                </div>
              </>
            )}

            {requestType === 'change_phone' && (
              <div>
                <Label>New Phone Number</Label>
                <Input
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  placeholder="416-555-0123"
                />
              </div>
            )}

            {requestType === 'change_delivery_instructions' && (
              <div>
                <Label>Delivery Instructions</Label>
                <Textarea
                  value={formData.deliveryInstructions}
                  onChange={(e) => setFormData({ ...formData, deliveryInstructions: e.target.value })}
                  rows={4}
                  placeholder="e.g., Leave at side door, ring bell twice"
                />
              </div>
            )}

            {requestType === 'change_food_instructions' && (
              <div>
                <Label>Food Preferences / Allergies</Label>
                <Textarea
                  value={formData.foodInstructions}
                  onChange={(e) => setFormData({ ...formData, foodInstructions: e.target.value })}
                  rows={4}
                  placeholder="e.g., No nuts, extra spicy"
                />
              </div>
            )}

            {(requestType === 'delivery_feedback' || requestType === 'food_feedback') && (
              <div>
                <Label>Your Feedback</Label>
                <Textarea
                  value={formData.feedback}
                  onChange={(e) => setFormData({ ...formData, feedback: e.target.value })}
                  rows={5}
                  placeholder="Share your experience..."
                />
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex justify-end gap-2 pt-4">
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button
                onClick={handleSubmit}
                disabled={submitting}
                className="bg-orange-500 hover:bg-orange-600 text-white"
              >
                {submitting ? 'Submitting...' : 'Submit Request'}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}

// Renewal Modal Component
function RenewalModal({ reminder, onClose, onSubmit }) {
  const [decision, setDecision] = useState('');
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!decision) {
      alert('Please select an option');
      return;
    }

    if (decision === 'cancel' && !reason) {
      alert('Please provide a reason for cancellation');
      return;
    }

    try {
      setSubmitting(true);

      const requestData = {
        request_type: 'renewal',
        decision: decision,
        cancellation_reason: reason
      };

      await http.post('/customer/update-requests', requestData);

      alert('Your decision has been submitted to admin for processing');
      onSubmit && onSubmit();
    } catch (error) {
      console.error('Error submitting renewal decision:', error);
      alert('Failed to submit decision');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle className="text-2xl">Plan Renewal Options</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-gray-700">{reminder.message}</p>

          {/* Decision Options */}
          <div className="space-y-3">
            <button
              onClick={() => setDecision('renew')}
              className={`w-full p-4 border-2 rounded-lg text-left transition-all ${decision === 'renew'
                ? 'border-black bg-orange-50'
                : 'border-gray-200 hover:border-orange-300'
                }`}
            >
              <p className="font-semibold text-black">Renew with Same Plan</p>
              <p className="text-sm text-gray-700">Continue with your current plan</p>
            </button>

            <button
              onClick={() => setDecision('change_plan')}
              className={`w-full p-4 border-2 rounded-lg text-left transition-all ${decision === 'change_plan'
                ? 'border-black bg-orange-50'
                : 'border-gray-200 hover:border-orange-300'
                }`}
            >
              <p className="font-semibold text-black">Change Plan</p>
              <p className="text-sm text-gray-700">Switch to a different plan or term</p>
            </button>

            <button
              onClick={() => setDecision('cancel')}
              className={`w-full p-4 border-2 rounded-lg text-left transition-all ${decision === 'cancel'
                ? 'border-black bg-orange-50'
                : 'border-gray-200 hover:border-orange-300'
                }`}
            >
              <p className="font-semibold text-black">Cancel Subscription</p>
              <p className="text-sm text-gray-700">End your subscription</p>
            </button>
          </div>

          {/* Cancellation Reason */}
          {decision === 'cancel' && (
            <div>
              <Label>Please tell us why you're cancelling</Label>
              <Textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows={3}
                placeholder="Your feedback helps us improve..."
              />
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex justify-end gap-2 pt-4">
            <Button variant="outline" onClick={onClose}>
              Close
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={submitting || !decision}
              className="bg-orange-500 hover:bg-orange-600 text-white"
            >
              {submitting ? 'Submitting...' : 'Submit Decision'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

// Helper function for mood emojis
function getMoodEmoji(mood) {
  const moodMap = {
    'feeling_low': '😔 Feeling Low',
    'sad': '😢 Sad',
    'not_sure': '😐 Not Sure',
    'happy': '🙂 Happy',
    'very_happy': '😄 Very Happy',
    'grateful': '🥰 Grateful'
  };
  return moodMap[mood] || '😐';
}

// Daily Reflection Modal Component
function DailyReflectionModal({ initialData, onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    read_today: initialData?.read_today || false,
    meditate_today: initialData?.meditate_today || false,
    mindful_today: initialData?.mindful_today || false,
    workout_type: initialData?.workout_type || '',
    workout_duration: initialData?.workout_duration || 0,
    current_weight: initialData?.current_weight || '',
    mood: initialData?.mood || '',
    grateful_for: initialData?.grateful_for || '',
    appreciated_self: initialData?.appreciated_self || '',
    improve: initialData?.improve || '',
    advice_tomorrow: initialData?.advice_tomorrow || '',
    closer_to_future: initialData?.closer_to_future || ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [currentSection, setCurrentSection] = useState(0);

  const moods = [
    { value: 'feeling_low', label: 'Feeling Low', emoji: '😔' },
    { value: 'sad', label: 'Sad', emoji: '😢' },
    { value: 'not_sure', label: 'Not Sure', emoji: '😐' },
    { value: 'happy', label: 'Happy', emoji: '🙂' },
    { value: 'very_happy', label: 'Very Happy', emoji: '😄' },
    { value: 'grateful', label: 'Grateful', emoji: '🥰' }
  ];

  const sections = ['Practices', 'Mood', 'Reflection'];

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      await http.post('/customer/reflection', formData);

      alert('Daily check-in saved successfully! 🌟');
      onSubmit && onSubmit();
    } catch (error) {
      console.error('Error submitting reflection:', error);
      alert('Failed to save reflection');
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete today\'s reflection? This action cannot be undone.')) {
      return;
    }

    try {
      setSubmitting(true);
      await http.delete('/customer/reflection/today');

      alert('Reflection deleted successfully!');
      onSubmit && onSubmit();
    } catch (error) {
      console.error('Error deleting reflection:', error);
      alert('Failed to delete reflection');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <Card className="w-full max-w-3xl max-h-[90vh] overflow-y-auto bg-white shadow-2xl border-2 border-orange-500">
        <CardHeader className="bg-gradient-to-r from-black via-gray-900 to-black text-white rounded-t-lg border-b-4 border-orange-500">
          <div className="flex justify-between items-center">
            <div>
              <CardTitle className="text-3xl font-bold">✨ Daily Check-in & Reflection</CardTitle>
              <p className="text-orange-300 text-sm mt-1">Take a moment for yourself</p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:text-orange-500 transition-colors text-3xl font-bold"
            >
              ×
            </button>
          </div>

          {/* Progress Steps */}
          <div className="flex justify-center gap-2 mt-4">
            {sections.map((section, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentSection(idx)}
                className={`px-4 py-2 rounded-lg transition-all ${currentSection === idx
                  ? 'bg-orange-500 text-white scale-105'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  }`}
              >
                {section}
              </button>
            ))}
          </div>
        </CardHeader>

        <CardContent className="space-y-6 pt-6 bg-gradient-to-b from-white to-gray-50">
          {/* Section 0: Daily Practices */}
          {currentSection === 0 && (
            <div className="space-y-6 animate-fadeIn">
              <div className="bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-lg border-2 border-orange-200">
                <h3 className="font-bold text-2xl mb-6 text-black flex items-center gap-2">
                  <span className="text-orange-500">📋</span> Today's Practices
                </h3>

                <div className="space-y-6">
                  {/* Reading */}
                  <div className="bg-white rounded-lg p-4 shadow-md border-l-4 border-orange-500 hover:shadow-xl transition-shadow">
                    <p className="text-gray-900 font-semibold mb-3 flex items-center gap-2">
                      <span className="text-2xl">📚</span> Did you take some time to read today?
                    </p>
                    <div className="flex gap-4 ml-8">
                      <button
                        onClick={() => setFormData({ ...formData, read_today: true })}
                        className={`flex-1 py-3 px-6 rounded-lg font-semibold transition-all ${formData.read_today === true
                          ? 'bg-orange-500 text-white scale-105 shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-gray-300'
                          }`}
                      >
                        ✓ Yes
                      </button>
                      <button
                        onClick={() => setFormData({ ...formData, read_today: false })}
                        className={`flex-1 py-3 px-6 rounded-lg font-semibold transition-all ${formData.read_today === false
                          ? 'bg-black text-white scale-105 shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-gray-300'
                          }`}
                      >
                        ✗ No
                      </button>
                    </div>
                  </div>

                  {/* Meditation */}
                  <div className="bg-white rounded-lg p-4 shadow-md border-l-4 border-orange-500 hover:shadow-xl transition-shadow">
                    <p className="text-gray-900 font-semibold mb-3 flex items-center gap-2">
                      <span className="text-2xl">🧘‍♂️</span> Did you take a moment to meditate or quiet your mind?
                    </p>
                    <div className="flex gap-4 ml-8">
                      <button
                        onClick={() => setFormData({ ...formData, meditate_today: true })}
                        className={`flex-1 py-3 px-6 rounded-lg font-semibold transition-all ${formData.meditate_today === true
                          ? 'bg-orange-500 text-white scale-105 shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-gray-300'
                          }`}
                      >
                        ✓ Yes
                      </button>
                      <button
                        onClick={() => setFormData({ ...formData, meditate_today: false })}
                        className={`flex-1 py-3 px-6 rounded-lg font-semibold transition-all ${formData.meditate_today === false
                          ? 'bg-black text-white scale-105 shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-gray-300'
                          }`}
                      >
                        ✗ No
                      </button>
                    </div>
                  </div>

                  {/* Mindfulness */}
                  <div className="bg-white rounded-lg p-4 shadow-md border-l-4 border-orange-500 hover:shadow-xl transition-shadow">
                    <p className="text-gray-900 font-semibold mb-3 flex items-center gap-2">
                      <span className="text-2xl">🌟</span> Did you stay mindful and present throughout the day?
                    </p>
                    <div className="flex gap-4 ml-8">
                      <button
                        onClick={() => setFormData({ ...formData, mindful_today: true })}
                        className={`flex-1 py-3 px-6 rounded-lg font-semibold transition-all ${formData.mindful_today === true
                          ? 'bg-orange-500 text-white scale-105 shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-gray-300'
                          }`}
                      >
                        ✓ Yes
                      </button>
                      <button
                        onClick={() => setFormData({ ...formData, mindful_today: false })}
                        className={`flex-1 py-3 px-6 rounded-lg font-semibold transition-all ${formData.mindful_today === false
                          ? 'bg-black text-white scale-105 shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-gray-300'
                          }`}
                      >
                        ✗ No
                      </button>
                    </div>
                  </div>

                  {/* Workout */}
                  <div className="bg-white rounded-lg p-4 shadow-md border-l-4 border-orange-500 hover:shadow-xl transition-shadow">
                    <p className="text-gray-900 font-semibold mb-3 flex items-center gap-2">
                      <span className="text-2xl">💪</span> Did you do a workout today?
                    </p>
                    <div className="flex gap-4 ml-8">
                      <button
                        onClick={() => setFormData({ ...formData, workout_duration: formData.workout_duration > 0 ? 0 : 30 })}
                        className={`flex-1 py-3 px-6 rounded-lg font-semibold transition-all ${formData.workout_duration > 0
                          ? 'bg-orange-500 text-white scale-105 shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-gray-300'
                          }`}
                      >
                        ✓ Yes
                      </button>
                      <button
                        onClick={() => setFormData({ ...formData, workout_duration: 0 })}
                        className={`flex-1 py-3 px-6 rounded-lg font-semibold transition-all ${formData.workout_duration === 0
                          ? 'bg-black text-white scale-105 shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-2 border-gray-300'
                          }`}
                      >
                        ✗ No
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-end">
                <Button
                  onClick={() => setCurrentSection(1)}
                  className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 text-lg"
                >
                  Next: Mood →
                </Button>
              </div>
            </div>
          )}

          {/* Section 1: Mood */}
          {currentSection === 1 && (
            <div className="space-y-6 animate-fadeIn">
              <div className="bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-lg border-2 border-orange-200">
                <h3 className="font-bold text-2xl mb-6 text-black text-center">
                  <span className="text-orange-500">💭</span> How are you feeling today?
                </h3>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {moods.map((mood) => (
                    <button
                      key={mood.value}
                      type="button"
                      onClick={() => setFormData({ ...formData, mood: mood.value })}
                      className={`p-6 rounded-xl border-3 transition-all transform hover:scale-105 ${formData.mood === mood.value
                        ? 'border-orange-500 bg-gradient-to-br from-orange-100 to-orange-50 shadow-xl scale-105'
                        : 'border-gray-300 bg-white hover:border-orange-300 hover:shadow-lg'
                        }`}
                    >
                      <span className="text-5xl block mb-2">{mood.emoji}</span>
                      <span className={`text-sm font-semibold ${formData.mood === mood.value ? 'text-orange-600' : 'text-gray-600'}`}>
                        {mood.label}
                      </span>
                    </button>
                  ))}
                </div>
              </div>

              <div className="flex justify-between">
                <Button
                  onClick={() => setCurrentSection(0)}
                  variant="outline"
                  className="border-2 border-gray-300 text-gray-700 px-8 py-3 text-lg hover:bg-gray-100"
                >
                  ← Back
                </Button>
                <Button
                  onClick={() => setCurrentSection(2)}
                  className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 text-lg"
                >
                  Next: Reflection →
                </Button>
              </div>
            </div>
          )}

          {/* Section 2: Reflection */}
          {currentSection === 2 && (
            <div className="space-y-6 animate-fadeIn">
              <div className="bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-lg border-2 border-orange-200">
                <h3 className="font-bold text-2xl mb-6 text-black flex items-center gap-2">
                  <span className="text-orange-500">📝</span> Daily Reflection
                </h3>

                <div className="space-y-5">
                  <div className="bg-white rounded-lg p-4 shadow-md border-l-4 border-orange-500">
                    <Label className="text-gray-900 font-semibold flex items-center gap-2 mb-2">
                      <span className="text-xl">💭</span> One thing you're grateful for today
                    </Label>
                    <Textarea
                      value={formData.grateful_for}
                      onChange={(e) => setFormData({ ...formData, grateful_for: e.target.value })}
                      rows={2}
                      placeholder="I'm grateful for..."
                      className="border-2 border-gray-300 focus:border-orange-500 rounded-lg"
                    />
                  </div>

                  <div className="bg-white rounded-lg p-4 shadow-md border-l-4 border-orange-500">
                    <Label className="text-gray-900 font-semibold flex items-center gap-2 mb-2">
                      <span className="text-xl">💫</span> One thing you appreciated about yourself today
                    </Label>
                    <Textarea
                      value={formData.appreciated_self}
                      onChange={(e) => setFormData({ ...formData, appreciated_self: e.target.value })}
                      rows={2}
                      placeholder="I appreciated myself for..."
                      className="border-2 border-gray-300 focus:border-orange-500 rounded-lg"
                    />
                  </div>

                  <div className="bg-white rounded-lg p-4 shadow-md border-l-4 border-orange-500">
                    <Label className="text-gray-900 font-semibold flex items-center gap-2 mb-2">
                      <span className="text-xl">🎯</span> One thing you'd like to improve
                    </Label>
                    <Textarea
                      value={formData.improve}
                      onChange={(e) => setFormData({ ...formData, improve: e.target.value })}
                      rows={2}
                      placeholder="I'd like to improve..."
                      className="border-2 border-gray-300 focus:border-orange-500 rounded-lg"
                    />
                  </div>

                  <div className="bg-white rounded-lg p-4 shadow-md border-l-4 border-orange-500">
                    <Label className="text-gray-900 font-semibold flex items-center gap-2 mb-2">
                      <span className="text-xl">💌</span> One advice for tomorrow
                    </Label>
                    <Textarea
                      value={formData.advice_tomorrow}
                      onChange={(e) => setFormData({ ...formData, advice_tomorrow: e.target.value })}
                      rows={2}
                      placeholder="Tomorrow I will..."
                      className="border-2 border-gray-300 focus:border-orange-500 rounded-lg"
                    />
                  </div>
                </div>
              </div>

              {/* Final Reflection */}
              <div className="bg-gradient-to-br from-black to-gray-900 rounded-xl p-6 border-4 border-orange-500 shadow-2xl">
                <Label className="text-white font-bold text-lg flex items-center gap-2 mb-3">
                  <span className="text-2xl">🌠</span> Did the way you spent today move you closer to your future?
                </Label>
                <Textarea
                  value={formData.closer_to_future}
                  onChange={(e) => setFormData({ ...formData, closer_to_future: e.target.value })}
                  rows={3}
                  placeholder="Reflect on your day's progress..."
                  className="bg-white border-2 border-orange-500 focus:border-orange-400 rounded-lg"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex justify-between items-center gap-4 pt-4 border-t-2 border-gray-200">
                <div className="flex gap-2">
                  <Button
                    onClick={() => setCurrentSection(1)}
                    variant="outline"
                    className="border-2 border-gray-300 text-gray-700 px-6 py-3 hover:bg-gray-100"
                  >
                    ← Back
                  </Button>
                  {initialData && (
                    <Button
                      variant="outline"
                      onClick={handleDelete}
                      disabled={submitting}
                      className="border-2 border-red-500 text-red-600 hover:bg-red-50 px-6 py-3"
                    >
                      🗑️ Delete
                    </Button>
                  )}
                </div>
                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    onClick={onClose}
                    disabled={submitting}
                    className="border-2 border-gray-300 px-6 py-3 hover:bg-gray-100"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    disabled={submitting}
                    className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-8 py-3 text-lg font-semibold shadow-lg"
                  >
                    {submitting ? 'Saving...' : (initialData ? '✨ Update' : '✨ Save Reflection')}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

// Reports Modal Component
function ReportsModal({ onClose }) {
  const [period, setPeriod] = useState('weekly');
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadReport();
  }, [period]);

  const loadReport = async () => {
    try {
      setLoading(true);
      const res = await http.get(`/customer/reflection/report/${period}`);
      if (res.data?.ok) {
        setReport(res.data.report);
      }
    } catch (error) {
      console.error('Error loading report:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <CardHeader className="bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-t-lg">
          <CardTitle className="text-2xl">📊 Your Progress Report</CardTitle>
          <div className="flex gap-2 mt-4">
            <Button
              size="sm"
              onClick={() => setPeriod('weekly')}
              className={period === 'weekly' ? 'bg-white text-orange-500' : 'bg-orange-600 hover:bg-purple-800'}
            >
              Weekly
            </Button>
            <Button
              size="sm"
              onClick={() => setPeriod('monthly')}
              className={period === 'monthly' ? 'bg-white text-orange-500' : 'bg-orange-600 hover:bg-purple-800'}
            >
              Monthly
            </Button>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          {loading ? (
            <div className="text-center py-12">
              <Loader2 className="w-12 h-12 animate-spin mx-auto mb-4 text-orange-500" />
              <p>Loading your report...</p>
            </div>
          ) : report ? (
            <div className="space-y-6">
              {/* Key Metrics */}
              <div className="grid md:grid-cols-4 gap-4">
                <Card className="bg-orange-50">
                  <CardContent className="pt-6 text-center">
                    <p className="text-3xl font-bold text-black">{report.days_tracked}</p>
                    <p className="text-sm text-gray-700">Days Tracked</p>
                  </CardContent>
                </Card>
                <Card className="bg-orange-50">
                  <CardContent className="pt-6 text-center">
                    <p className="text-3xl font-bold text-black">{report.total_workouts}</p>
                    <p className="text-sm text-gray-700">Workouts</p>
                  </CardContent>
                </Card>
                <Card className="bg-orange-50">
                  <CardContent className="pt-6 text-center">
                    <p className="text-3xl font-bold text-black">{report.total_workout_time}</p>
                    <p className="text-sm text-gray-700">Total Minutes</p>
                  </CardContent>
                </Card>
                <Card className="bg-orange-50">
                  <CardContent className="pt-6 text-center">
                    <p className="text-3xl font-bold text-orange-600">{report.goal_completion_percentage}%</p>
                    <p className="text-sm text-gray-700">Goal Completion</p>
                  </CardContent>
                </Card>
              </div>

              {/* Activities */}
              <div className="grid md:grid-cols-3 gap-4">
                <Card>
                  <CardContent className="pt-6 text-center">
                    <p className="text-2xl font-bold">✅ {report.read_days}</p>
                    <p className="text-sm text-gray-700">Days Read</p>
                  </CardContent>
                </Card>
                <Card>
                  <CardContent className="pt-6 text-center">
                    <p className="text-2xl font-bold">🧘‍♂️ {report.meditate_days}</p>
                    <p className="text-sm text-gray-700">Days Meditated</p>
                  </CardContent>
                </Card>
                <Card>
                  <CardContent className="pt-6 text-center">
                    <p className="text-2xl font-bold">{getMoodEmoji(report.average_mood)}</p>
                    <p className="text-sm text-gray-700">Average Mood</p>
                  </CardContent>
                </Card>
              </div>

              {/* Weight Trend (Monthly only) */}
              {period === 'monthly' && report.weight_trend && (
                <Card className="bg-gradient-to-r from-green-50 to-blue-50">
                  <CardHeader>
                    <CardTitle>⚖️ Weight Trend</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-3 gap-4 text-center">
                      <div>
                        <p className="text-2xl font-bold">{report.weight_trend.start_weight}</p>
                        <p className="text-sm text-gray-700">Start</p>
                      </div>
                      <div>
                        <p className="text-2xl font-bold">{report.weight_trend.end_weight}</p>
                        <p className="text-sm text-gray-700">Current</p>
                      </div>
                      <div>
                        <p className={`text-2xl font-bold ${report.weight_trend.change < 0 ? 'text-orange-500' : 'text-orange-500'}`}>
                          {report.weight_trend.change > 0 ? '+' : ''}{report.weight_trend.change.toFixed(1)}
                        </p>
                        <p className="text-sm text-gray-700">Change</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Recent Reflections */}
              {report.gratitude_notes && report.gratitude_notes.length > 0 && (
                <Card>
                  <CardHeader>
                    <CardTitle>💭 Recent Gratitude</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-2">
                      {report.gratitude_notes.map((note, idx) => (
                        <li key={idx} className="text-sm text-gray-700 border-l-4 border-orange-300 pl-3 py-1">
                          {note}
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              )}

              {report.appreciation_notes && report.appreciation_notes.length > 0 && (
                <Card>
                  <CardHeader>
                    <CardTitle>💫 Self Appreciation</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-2">
                      {report.appreciation_notes.map((note, idx) => (
                        <li key={idx} className="text-sm text-gray-700 border-l-4 border-orange-300 pl-3 py-1">
                          {note}
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              )}
            </div>
          ) : (
            <div className="text-center py-12 text-gray-700">
              <p>No data available yet. Start tracking your daily reflections!</p>
            </div>
          )}

          <div className="flex justify-end pt-4">
            <Button onClick={onClose} className="bg-orange-500 hover:bg-orange-600 text-white">
              Close
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

// To-Do Modal Component
function TodoModal({ onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    title: '',
    note: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!formData.title.trim()) {
      alert('Please enter a task');
      return;
    }

    try {
      setSubmitting(true);
      const today = new Date().toISOString().split('T')[0];
      await http.post('/customer/todos', {
        ...formData,
        due_date: today
      });

      alert('Task added successfully! 🎯');
      onSubmit && onSubmit();
    } catch (error) {
      console.error('Error adding task:', error);
      alert('Failed to add task');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <Card className="w-full max-w-md bg-white shadow-2xl border-2 border-orange-500 transform transition-all">
        <CardHeader className="bg-gradient-to-r from-black via-gray-900 to-black text-white rounded-t-lg border-b-4 border-orange-500">
          <div className="flex justify-between items-center">
            <div>
              <CardTitle className="text-2xl font-bold">➕ Add New Task</CardTitle>
              <p className="text-orange-300 text-sm mt-1">Stay organized and on track</p>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:text-orange-500 transition-colors text-3xl font-bold"
            >
              ×
            </button>
          </div>
        </CardHeader>
        <CardContent className="space-y-6 pt-6 bg-gradient-to-b from-white to-gray-50">
          <div className="bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-lg border-2 border-orange-200">
            <Label className="text-black font-bold text-lg flex items-center gap-2 mb-3">
              <span className="text-orange-500 text-2xl">📝</span> Today's Task *
            </Label>
            <Input
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              placeholder="What do you need to do today?"
              className="border-2 border-gray-300 focus:border-orange-500 rounded-lg text-lg py-6 px-4"
              maxLength={100}
            />
            <p className="text-xs text-gray-500 mt-2">{formData.title.length}/100 characters</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-orange-500">
            <Label className="text-black font-bold text-lg flex items-center gap-2 mb-3">
              <span className="text-orange-500 text-2xl">📌</span> Reminders (Optional)
            </Label>
            <Textarea
              value={formData.note}
              onChange={(e) => setFormData({ ...formData, note: e.target.value })}
              rows={4}
              placeholder="Add any reminders or details..."
              className="border-2 border-gray-300 focus:border-orange-500 rounded-lg"
              maxLength={500}
            />
            <p className="text-xs text-gray-500 mt-2">{formData.note.length}/500 characters</p>
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t-2 border-gray-200">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={submitting}
              className="border-2 border-gray-300 px-6 py-3 hover:bg-gray-100"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={submitting}
              className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-8 py-3 text-lg font-semibold shadow-lg"
            >
              {submitting ? 'Adding...' : '➕ Add Task'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

// ============================================================================
// GYM TIME COMPONENTS
// ============================================================================

// Gym Planner Tab Component
function GymPlannerTab({ weeklyPlan, onUpdate }) {
  const [selectedDay, setSelectedDay] = useState('Monday');
  const [showAddForm, setShowAddForm] = useState(false);
  const [workoutType, setWorkoutType] = useState('');
  const [formData, setFormData] = useState({});
  const [workoutQueue, setWorkoutQueue] = useState([]);

  const days = [
    { name: 'Monday', short: 'Mon', emoji: '' },
    { name: 'Tuesday', short: 'Tue', emoji: '' },
    { name: 'Wednesday', short: 'Wed', emoji: '' },
    { name: 'Thursday', short: 'Thu', emoji: '' },
    { name: 'Friday', short: 'Fri', emoji: '' },
    { name: 'Saturday', short: 'Sat', emoji: '' },
    { name: 'Sunday', short: 'Sun', emoji: '' }
  ];

  const dayWorkouts = weeklyPlan[selectedDay] || [];

  const handleAddToQueue = () => {
    if (!workoutType) return;

    const newWorkout = {
      tempId: Date.now(),
      workout_type: workoutType,
      details: { ...formData }
    };

    setWorkoutQueue([...workoutQueue, newWorkout]);
    setWorkoutType('');
    setFormData({});
  };

  const handleSaveAll = async () => {
    try {
      for (let i = 0; i < workoutQueue.length; i++) {
        const workout = workoutQueue[i];
        const payload = {
          day: selectedDay,
          workout_type: workout.workout_type,
          order: dayWorkouts.length + i,
          details: workout.details
        };
        await http.post('/customer/gym/workout-plan', payload);
      }

      alert(`${workoutQueue.length} workouts added! 💪`);
      setWorkoutQueue([]);
      setShowAddForm(false);
      onUpdate && onUpdate();
    } catch (error) {
      console.error('Error saving workouts:', error);
      alert('Failed to save workouts');
    }
  };

  const removeFromQueue = (tempId) => {
    setWorkoutQueue(workoutQueue.filter(w => w.tempId !== tempId));
  };

  const handleDeleteWorkout = async (workoutId) => {
    if (!window.confirm('Remove this workout?')) return;

    try {
      await http.delete(`/customer/gym/workout-plan/${workoutId}`);
      onUpdate && onUpdate();
    } catch (error) {
      console.error('Error deleting workout:', error);
    }
  };

  return (
    <div className="space-y-4">
      {/* Day Selector - Improved with emoji and better layout */}
      <div className="bg-white rounded-lg p-3 border-2 border-orange-200 shadow-sm">
        <p className="text-xs font-bold text-gray-600 mb-2 uppercase tracking-wide">Select Day</p>
        <div className="grid grid-cols-7 gap-2">
          {days.map(day => {
            const isSelected = selectedDay === day.name;
            const hasWorkouts = weeklyPlan[day.name]?.length > 0;
            return (
              <button
                key={day.name}
                onClick={() => setSelectedDay(day.name)}
                className={`relative flex flex-col items-center justify-center p-3 rounded-lg font-semibold transition-all ${isSelected
                  ? 'bg-orange-500 text-white scale-105 shadow-lg'
                  : 'bg-gray-50 text-gray-700 hover:bg-orange-50 border border-gray-200 hover:border-orange-300'
                  }`}
              >
                <span className="text-2xl mb-1">{day.emoji}</span>
                <span className="text-xs">{day.short}</span>
                {hasWorkouts && !isSelected && (
                  <div className="absolute top-1 right-1 w-2 h-2 bg-orange-500 rounded-full"></div>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Current Day's Workouts */}
      <div className="bg-white rounded-lg border-2 border-orange-200 shadow-sm overflow-hidden">
        <div className="bg-orange-500 px-4 py-3 flex justify-between items-center">
          <h3 className="font-bold text-white flex items-center gap-2">
            <span className="text-2xl">{days.find(d => d.name === selectedDay)?.emoji}</span>
            {selectedDay}'s Workouts ({dayWorkouts.length})
          </h3>
          {dayWorkouts.length > 0 && (
            <Button
              onClick={async () => {
                if (window.confirm(`Delete all ${dayWorkouts.length} workouts for ${selectedDay}?`)) {
                  try {
                    for (const workout of dayWorkouts) {
                      await http.delete(`/customer/gym/workout-plan/${workout.id}`);
                    }
                    alert('All workouts deleted!');
                    onUpdate && onUpdate();
                  } catch (error) {
                    console.error('Error deleting workouts:', error);
                    alert('Failed to delete some workouts');
                  }
                }
              }}
              size="sm"
              variant="outline"
              className="bg-white text-orange-600 border-white hover:bg-orange-50 font-semibold"
            >
              🗑️ Clear Day
            </Button>
          )}
        </div>

        <div className="p-4">
          {dayWorkouts.length > 0 ? (
            <div className="space-y-2">
              {dayWorkouts.map((workout, idx) => (
                <div key={workout.id} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200 hover:border-orange-300 transition-colors">
                  <div className="flex items-center justify-center w-8 h-8 bg-orange-500 text-white rounded-full font-bold text-sm">
                    {idx + 1}
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-gray-900 flex items-center gap-2">
                      <span className="capitalize">{workout.workout_type}</span>
                    </p>
                    <p className="text-sm text-gray-600">
                      {workout.workout_type === 'cardio' && `${workout.details?.activity} - ${workout.details?.duration} min`}
                      {workout.workout_type === 'weight' && `${workout.details?.body_part} - ${workout.details?.exercise} (${workout.details?.sets}×${workout.details?.reps})`}
                      {workout.workout_type === 'stretching' && `${workout.details?.duration} min`}
                      {workout.workout_type === 'rest' && 'Recovery day'}
                    </p>
                  </div>
                  <button
                    onClick={() => handleDeleteWorkout(workout.id)}
                    className="text-gray-400 hover:text-red-500 hover:bg-red-50 p-2 rounded transition-colors"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-400 text-lg mb-2">No workouts planned</p>
              <p className="text-sm text-gray-500">Click "Add Workout" below to get started!</p>
            </div>
          )}
        </div>
      </div>

      {/* Workout Queue */}
      {workoutQueue.length > 0 && (
        <div className="bg-orange-50 rounded-lg p-4 border-2 border-orange-300">
          <div className="flex justify-between items-center mb-3">
            <h4 className="font-bold text-black flex items-center gap-2">
              Ready to Save ({workoutQueue.length})
            </h4>
            <Button
              onClick={handleSaveAll}
              className="bg-orange-500 hover:bg-orange-600 text-white font-semibold"
              size="sm"
            >
              Save to {days.find(d => d.name === selectedDay)?.short}
            </Button>
          </div>
          <div className="space-y-2">
            {workoutQueue.map((workout) => (
              <div key={workout.tempId} className="flex items-center justify-between p-2 bg-white rounded border border-orange-200">
                <span className="text-sm font-medium text-gray-700">
                  {workout.workout_type === 'cardio' && `${workout.details?.activity} - ${workout.details?.duration}min`}
                  {workout.workout_type === 'weight' && `${workout.details?.body_part} - ${workout.details?.exercise}`}
                  {workout.workout_type === 'stretching' && `${workout.details?.duration}min`}
                  {workout.workout_type === 'rest' && `Rest Day`}
                </span>
                <button
                  onClick={() => removeFromQueue(workout.tempId)}
                  className="text-gray-400 hover:text-red-500 hover:bg-red-50 px-2 py-1 rounded transition-colors"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Add Workout Form */}
      {!showAddForm ? (
        <Button
          onClick={() => setShowAddForm(true)}
          className="w-full bg-orange-500 hover:bg-orange-600 text-white"
        >
          ➕ Add Workout
        </Button>
      ) : (
        <div className="bg-white rounded-lg p-4 border-2 border-orange-300 space-y-4">
          <h4 className="font-semibold text-orange-600">Add New Workout</h4>

          <div>
            <Label>Workout Type</Label>
            <select
              value={workoutType}
              onChange={(e) => {
                setWorkoutType(e.target.value);
                setFormData({});
              }}
              className="w-full p-2 border rounded"
            >
              <option value="">Select Type</option>
              <option value="cardio">Cardio</option>
              <option value="weight">Weight Training</option>
              <option value="stretching">Stretching / Mobility</option>
              <option value="rest">Rest Day</option>
            </select>
          </div>

          {workoutType === 'cardio' && (
            <>
              <div>
                <Label>Activity</Label>
                <select
                  value={formData.activity || ''}
                  onChange={(e) => setFormData({ ...formData, activity: e.target.value })}
                  className="w-full p-2 border rounded"
                >
                  <option value="">Select Activity</option>
                  <option value="Running">Running</option>
                  <option value="Skipping">Skipping</option>
                  <option value="Cycling">Cycling</option>
                  <option value="Swimming">Swimming</option>
                  <option value="Playing Sports">Playing Sports</option>
                </select>
              </div>
              <div>
                <Label>Duration (minutes)</Label>
                <Input
                  type="number"
                  value={formData.duration || ''}
                  onChange={(e) => setFormData({ ...formData, duration: parseInt(e.target.value) || 0 })}
                  placeholder="30"
                />
              </div>
            </>
          )}

          {workoutType === 'weight' && (
            <>
              <div>
                <Label>Body Part</Label>
                <select
                  value={formData.body_part || ''}
                  onChange={(e) => setFormData({ ...formData, body_part: e.target.value })}
                  className="w-full p-2 border rounded"
                >
                  <option value="">Select Body Part</option>
                  <option value="Chest">Chest</option>
                  <option value="Back">Back</option>
                  <option value="Shoulders">Shoulders</option>
                  <option value="Biceps">Arms - Biceps</option>
                  <option value="Triceps">Arms - Triceps</option>
                  <option value="Forearms">Arms - Forearms</option>
                  <option value="Quads">Legs - Quads</option>
                  <option value="Hamstrings">Legs - Hamstrings</option>
                  <option value="Calves">Legs - Calves</option>
                  <option value="Glutes">Legs - Glutes</option>
                  <option value="Core">Core / Abs</option>
                  <option value="Full Body">Full Body</option>
                </select>
              </div>
              <div>
                <Label>Exercise / Machine</Label>
                <Input
                  value={formData.exercise || ''}
                  onChange={(e) => setFormData({ ...formData, exercise: e.target.value })}
                  placeholder="e.g., Bench Press, Pull Ups"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Sets</Label>
                  <Input
                    type="number"
                    value={formData.sets || ''}
                    onChange={(e) => setFormData({ ...formData, sets: parseInt(e.target.value) || 0 })}
                    placeholder="3"
                  />
                </div>
                <div>
                  <Label>Reps</Label>
                  <Input
                    type="number"
                    value={formData.reps || ''}
                    onChange={(e) => setFormData({ ...formData, reps: parseInt(e.target.value) || 0 })}
                    placeholder="10"
                  />
                </div>
              </div>
            </>
          )}

          {workoutType === 'stretching' && (
            <div>
              <Label>Duration (minutes)</Label>
              <Input
                type="number"
                value={formData.duration || ''}
                onChange={(e) => setFormData({ ...formData, duration: parseInt(e.target.value) || 0 })}
                placeholder="15"
              />
            </div>
          )}

          {workoutType === 'rest' && (
            <div className="bg-orange-50 p-4 rounded border border-orange-200">
              <p className="text-sm text-black">
                🌙 Rest days are important for recovery! This day won't count as missed and your streak will continue.
              </p>
            </div>
          )}

          <div className="flex gap-2">
            <Button
              onClick={() => {
                setShowAddForm(false);
                setWorkoutType('');
                setFormData({});
              }}
              variant="outline"
            >
              Done Adding
            </Button>
            <Button
              onClick={handleAddToQueue}
              disabled={!workoutType}
              className="bg-orange-500 hover:bg-orange-600 text-white flex-1"
            >
              ➕ Add Another
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

// Do Workout Tab Component
function DoWorkoutTab({ weeklyPlan, activeSession, onUpdate }) {
  const [session, setSession] = useState(activeSession);
  const [completedIds, setCompletedIds] = useState(activeSession?.completed_workouts || []);
  const [showSummary, setShowSummary] = useState(false);
  const [summary, setSummary] = useState(null);
  const [showDurationModal, setShowDurationModal] = useState(false);
  const [showMoodModal, setShowMoodModal] = useState(false);
  const [weightHours, setWeightHours] = useState(0);
  const [weightMinutes, setWeightMinutes] = useState(0);
  const [selectedMood, setSelectedMood] = useState('');
  const [finishing, setFinishing] = useState(false);

  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' });
  const todaysWorkouts = weeklyPlan[today] || [];

  // Update session and completed IDs when activeSession prop changes
  React.useEffect(() => {
    console.log('ActiveSession prop changed:', activeSession);
    if (activeSession) {
      // Make sure we have the right structure
      const sessionData = {
        session_id: activeSession.session_id || activeSession.id,
        workouts: activeSession.workouts || [],
        completed_workouts: activeSession.completed_workouts || []
      };
      console.log('Setting session from prop:', sessionData);
      setSession(sessionData);
      setCompletedIds(sessionData.completed_workouts);
    }
  }, [activeSession]);

  const handleStartWorkout = async () => {
    try {
      const res = await http.post('/customer/gym/start-workout');
      console.log('Start workout response:', res.data);

      if (res.data?.ok) {
        const sessionData = {
          session_id: res.data.session_id,
          workouts: res.data.workouts || [],
          completed_workouts: []
        };
        console.log('Setting session:', sessionData);
        setSession(sessionData);
        setCompletedIds([]);
        onUpdate && onUpdate();
      } else {
        alert(res.data?.message || 'No workouts planned for today');
      }
    } catch (error) {
      console.error('Error starting workout:', error);
      alert('Failed to start workout');
    }
  };

  const handleMarkDone = async (workoutId) => {
    try {
      console.log('Marking done:', { session_id: session?.session_id, workout_id: workoutId });
      await http.post(`/customer/gym/mark-done/${session?.session_id}/${workoutId}`);
      setCompletedIds([...completedIds, workoutId]);
    } catch (error) {
      console.error('Error marking done:', error);
      alert('Failed to mark exercise as done');
    }
  };

  const handlePrepareFinish = () => {
    console.log('Preparing to finish. Session:', session);
    console.log('Completed IDs:', completedIds);

    // Check if there are any weight exercises that need duration
    const workouts = session?.workouts || [];
    const completedWeightWorkouts = workouts.filter(
      w => completedIds.includes(w.id) && w.workout_type === 'weight'
    );

    console.log('Completed weight workouts:', completedWeightWorkouts);

    if (completedWeightWorkouts.length > 0) {
      setShowDurationModal(true);
    } else {
      setShowMoodModal(true);
    }
  };

  const handleDurationNext = () => {
    setShowDurationModal(false);
    setShowMoodModal(true);
  };

  const handleFinishWorkout = async () => {
    if (!selectedMood) {
      alert('Please select how you feel after your workout');
      return;
    }

    if (finishing) {
      console.log('Already finishing, please wait...');
      return;
    }

    setFinishing(true);

    try {
      const totalWeightTime = (weightHours * 60) + weightMinutes;

      console.log('Finishing workout with:', {
        session_id: session?.session_id,
        total_weight_time: totalWeightTime,
        mood_rating: selectedMood
      });

      const res = await http.post(`/customer/gym/finish-workout/${session?.session_id}`, {
        total_weight_time: totalWeightTime,
        mood_rating: selectedMood
      });

      console.log('Finish workout response:', res.data);

      if (res.data?.ok) {
        setSummary(res.data.summary);
        setShowSummary(true);
        setShowDurationModal(false);
        setShowMoodModal(false);
        setSession(null);
        setWeightHours(0);
        setWeightMinutes(0);
        setSelectedMood('');
        setFinishing(false);
        onUpdate && onUpdate();
      } else {
        setFinishing(false);
        alert(res.data?.message || 'Failed to finish workout');
      }
    } catch (error) {
      setFinishing(false);
      console.error('Error finishing workout:', error);
      console.error('Error details:', error.response?.data);
      alert('Failed to finish workout: ' + (error.response?.data?.message || error.message));
    }
  };

  if (showSummary && summary) {
    return (
      <div className="bg-white rounded-lg p-6 border-2 border-green-400 text-center space-y-4">
        <h3 className="text-2xl font-bold text-black">🎉 Workout Complete!</h3>
        <div className="grid grid-cols-2 gap-4 text-left">
          <div className="bg-orange-50 p-4 rounded">
            <p className="text-sm text-gray-700">Total Time</p>
            <p className="text-xl font-bold text-black">{summary.total_time_minutes} min</p>
          </div>
          <div className="bg-orange-50 p-4 rounded">
            <p className="text-sm text-gray-700">Exercises</p>
            <p className="text-xl font-bold text-black">{summary.completed_exercises}/{summary.total_exercises}</p>
          </div>
        </div>

        {summary.workout_types?.length > 0 && (
          <div className="bg-orange-50 p-4 rounded text-left">
            <p className="text-sm text-gray-700 mb-2">Workout Types</p>
            <p className="font-medium">{summary.workout_types.join(', ')}</p>
          </div>
        )}

        {summary.body_parts_trained?.length > 0 && (
          <div className="bg-orange-50 p-4 rounded text-left">
            <p className="text-sm text-gray-700 mb-2">Body Parts Trained</p>
            <p className="font-medium">{summary.body_parts_trained.join(', ')}</p>
          </div>
        )}

        <Button
          onClick={() => {
            setShowSummary(false);
            setSummary(null);
          }}
          className="w-full bg-orange-500 hover:bg-orange-600 text-white"
        >
          Done
        </Button>
      </div>
    );
  }

  if (!session) {
    return (
      <div className="text-center space-y-4 py-8">
        {todaysWorkouts.length > 0 ? (
          <>
            <p className="text-gray-700 font-medium">Ready to crush your {today} workout? 💪</p>
            <p className="text-sm text-gray-700">{todaysWorkouts.length} exercises planned</p>
            <Button
              onClick={handleStartWorkout}
              className="bg-orange-500 hover:bg-orange-600 text-white"
            >
              🔥 Start Workout
            </Button>
          </>
        ) : (
          <div className="bg-white p-6 rounded-lg">
            <p className="text-gray-700">No workouts planned for {today}</p>
            <p className="text-sm text-gray-700 mt-2">Go to Planner to add workouts</p>
          </div>
        )}
      </div>
    );
  }

  const workouts = session.workouts || [];
  const pendingWorkouts = workouts.filter(w => !completedIds.includes(w.id));
  const completedWorkouts = workouts.filter(w => completedIds.includes(w.id));

  return (
    <div className="space-y-4">
      <div className="bg-orange-100 p-4 rounded-lg border border-orange-300">
        <p className="font-semibold text-orange-800">Workout in Progress 🔥</p>
        <p className="text-sm text-orange-600">{completedIds.length}/{workouts.length} exercises completed</p>
      </div>

      {/* Pending Exercises */}
      {pendingWorkouts.length > 0 && (
        <div className="space-y-2">
          <h4 className="font-semibold text-gray-700">To Do:</h4>
          {pendingWorkouts.map((workout, idx) => (
            <div key={workout.id} className="flex items-center gap-3 p-4 bg-white rounded border border-orange-200">
              <input
                type="checkbox"
                onChange={() => handleMarkDone(workout.id)}
                className="w-5 h-5 accent-orange-500"
              />
              <div className="flex-1">
                <p className="font-medium">
                  {workout.workout_type?.toUpperCase()}
                </p>
                <p className="text-sm text-gray-700">
                  {workout.workout_type === 'cardio' && `${workout.details?.activity} - ${workout.details?.duration} min`}
                  {workout.workout_type === 'weight' && `${workout.details?.body_part} - ${workout.details?.exercise} (${workout.details?.sets}×${workout.details?.reps})`}
                  {workout.workout_type === 'stretching' && `${workout.details?.duration} min`}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Completed Exercises */}
      {completedWorkouts.length > 0 && (
        <details className="bg-orange-50 p-4 rounded border border-orange-200">
          <summary className="font-semibold text-black cursor-pointer">✓ Completed ({completedWorkouts.length})</summary>
          <div className="space-y-2 mt-3">
            {completedWorkouts.map(workout => (
              <div key={workout.id} className="text-sm text-gray-700 line-through">
                {workout.workout_type} - {workout.details?.exercise || workout.details?.activity}
              </div>
            ))}
          </div>
        </details>
      )}

      {/* Debug Info */}
      <div className="bg-orange-50 p-3 rounded border border-black text-sm">
        <p className="font-bold mb-2">📊 Workout Status:</p>
        <div className="space-y-1">
          <p>✅ Session Active: {session?.session_id ? 'YES' : 'NO'}</p>
          <p>📋 Total Exercises: {workouts.length}</p>
          <p>✓ Completed: <span className="font-bold text-orange-500">{completedIds.length}</span></p>
          <p>⏳ Pending: <span className="font-bold text-orange-500">{pendingWorkouts.length}</span></p>
          <p className="pt-2 border-t">
            🎯 Finish Button: <span className={`font-bold ${pendingWorkouts.length === 0 && session?.session_id ? 'text-orange-500' : 'text-orange-500'}`}>
              {pendingWorkouts.length === 0 && session?.session_id ? 'ENABLED ✓' : 'DISABLED ✗'}
            </span>
          </p>
          {pendingWorkouts.length > 0 && (
            <p className="text-orange-600 font-medium pt-2">
              ⚠️ Check off all {pendingWorkouts.length} exercises above to enable Finish button!
            </p>
          )}
        </div>
      </div>

      <div className="flex gap-2">
        <Button
          onClick={async () => {
            if (window.confirm('Cancel this workout session? All progress will be lost.')) {
              try {
                // Delete the session from backend
                if (session?.session_id) {
                  console.log('Cancelling session:', session.session_id);
                  await http.delete(`/customer/gym/session/${session.session_id}`);
                }

                // Reset state completely
                setSession(null);
                setCompletedIds([]);
                setShowSummary(false);
                setSummary(null);
                setShowDurationModal(false);
                setShowMoodModal(false);
                setWeightHours(0);
                setWeightMinutes(0);
                setSelectedMood('');
                setFinishing(false);

                // Reload data to clear active session
                onUpdate && onUpdate();

                alert('Workout cancelled. You can start a new workout now.');
              } catch (error) {
                console.error('Error cancelling:', error);
                alert('Failed to cancel workout: ' + (error.response?.data?.message || error.message));
              }
            }
          }}
          variant="outline"
          className="flex-1 border-black text-orange-500 hover:bg-orange-50"
        >
          🗑️ Cancel Workout
        </Button>

        <Button
          onClick={() => {
            console.log('Finish button clicked. Session:', session);
            console.log('Session ID:', session?.session_id);
            console.log('Pending workouts:', pendingWorkouts.length);
            console.log('Completed IDs:', completedIds);
            if (pendingWorkouts.length > 0) {
              alert(`You still have ${pendingWorkouts.length} exercises to complete!`);
              return;
            }
            if (!session?.session_id) {
              alert('Session ID is missing! Please restart the workout.');
              return;
            }
            handlePrepareFinish();
          }}
          disabled={pendingWorkouts.length > 0 || !session?.session_id}
          className="flex-1 bg-orange-500 hover:bg-orange-600 text-white disabled:bg-gray-300"
        >
          {pendingWorkouts.length > 0 ? `${pendingWorkouts.length} more to go...` : '✅ Finish Workout'}
        </Button>
      </div>

      {/* Duration Collection Modal */}
      {showDurationModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <Card className="w-full max-w-md bg-white">
            <CardHeader className="bg-orange-500 text-white rounded-t-lg">
              <CardTitle>How long did weight training take?</CardTitle>
              <p className="text-sm text-orange-100">Total time spent on all weight exercises</p>
            </CardHeader>
            <CardContent className="space-y-4 pt-6">
              <div className="bg-orange-50 p-4 rounded border border-orange-200">
                <p className="text-sm text-gray-700 mb-3">Weight exercises completed:</p>
                {(session?.workouts || [])
                  .filter(w => completedIds.includes(w.id) && w.workout_type === 'weight')
                  .map(workout => (
                    <p key={workout.id} className="text-sm text-gray-700">
                      • {workout.details?.body_part} - {workout.details?.exercise}
                    </p>
                  ))}
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Hours</Label>
                  <select
                    value={weightHours}
                    onChange={(e) => setWeightHours(parseInt(e.target.value))}
                    className="w-full p-2 border rounded"
                  >
                    {[0, 1, 2, 3, 4].map(h => (
                      <option key={h} value={h}>{h} hr</option>
                    ))}
                  </select>
                </div>
                <div>
                  <Label>Minutes</Label>
                  <select
                    value={weightMinutes}
                    onChange={(e) => setWeightMinutes(parseInt(e.target.value))}
                    className="w-full p-2 border rounded"
                  >
                    {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].map(m => (
                      <option key={m} value={m}>{m} min</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="flex gap-2 pt-4">
                <Button
                  onClick={() => setShowDurationModal(false)}
                  variant="outline"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleDurationNext}
                  className="flex-1 bg-orange-500 hover:bg-orange-600 text-white"
                >
                  Next →
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Mood Rating Modal */}
      {showMoodModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <Card className="w-full max-w-lg bg-white">
            <CardHeader className="bg-orange-500 text-white rounded-t-lg">
              <CardTitle>How do you feel after your workout?</CardTitle>
              <p className="text-sm text-green-100">Rate your mood</p>
            </CardHeader>
            <CardContent className="space-y-3 pt-6">
              <button
                onClick={() => setSelectedMood('pushing_through')}
                className={`w-full p-4 text-left rounded-lg border-2 transition-all ${selectedMood === 'pushing_through'
                  ? 'border-#FF6A00 bg-orange-50'
                  : 'border-gray-200 hover:border-orange-300'
                  }`}
              >
                <p className="font-medium">💭 Still pushing through</p>
                <p className="text-sm text-gray-700">Not my best day, but I showed up.</p>
              </button>

              <button
                onClick={() => setSelectedMood('feeling_better')}
                className={`w-full p-4 text-left rounded-lg border-2 transition-all ${selectedMood === 'feeling_better'
                  ? 'border-black bg-orange-50'
                  : 'border-gray-200 hover:border-orange-300'
                  }`}
              >
                <p className="font-medium">🙂 Feeling better than before</p>
                <p className="text-sm text-gray-700">Proud I made the effort.</p>
              </button>

              <button
                onClick={() => setSelectedMood('energized')}
                className={`w-full p-4 text-left rounded-lg border-2 transition-all ${selectedMood === 'energized'
                  ? 'border-black bg-orange-50'
                  : 'border-gray-200 hover:border-orange-300'
                  }`}
              >
                <p className="font-medium">😄 Energized and strong</p>
                <p className="text-sm text-gray-700">Great session, feeling accomplished.</p>
              </button>

              <button
                onClick={() => setSelectedMood('grateful_blissful')}
                className={`w-full p-4 text-left rounded-lg border-2 transition-all ${selectedMood === 'grateful_blissful'
                  ? 'border-black bg-orange-50'
                  : 'border-gray-200 hover:border-orange-300'
                  }`}
              >
                <p className="font-medium">🥰 Grateful and blissful</p>
                <p className="text-sm text-gray-700">Completely at peace and satisfied.</p>
              </button>

              <div className="flex gap-2 pt-4">
                <Button
                  onClick={() => {
                    setShowMoodModal(false);
                    if ((session?.workouts || []).some(w => completedIds.includes(w.id) && w.workout_type === 'weight')) {
                      setShowDurationModal(true);
                    }
                  }}
                  variant="outline"
                >
                  ← Back
                </Button>
                <Button
                  onClick={handleFinishWorkout}
                  disabled={!selectedMood || finishing}
                  className="flex-1 bg-orange-500 hover:bg-orange-600 text-white disabled:bg-gray-300"
                >
                  {finishing ? '⏳ Finishing...' : '✅ Finish Workout'}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
      {/* Dietary Preferences Modal */}
      {/* Dietary Preferences Modal */}
      {showDietaryModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[9999]" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
          <Card className="w-full max-w-lg bg-white max-h-[90vh] overflow-y-auto">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <MessageSquare className="w-5 h-5 text-orange-500" />
                Preferences & Feedback
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              {error && (
                <Alert variant="destructive" className="mb-4">
                  <AlertDescription>{error}</AlertDescription>
                </Alert>
              )}
              <div className="space-y-2">
                <Label>Food Preferences / Goals</Label>
                <textarea
                  className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                  placeholder="e.g. Low Carb, High Protein, Keto, etc."
                  value={dietaryFormData.foodPreferences}
                  onChange={(e) => setDietaryFormData({ ...dietaryFormData, foodPreferences: e.target.value })}
                />
              </div>
              <div className="space-y-2">
                <Label>Ingredients to Avoid</Label>
                <textarea
                  className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                  placeholder="e.g. Mushrooms, Bell Peppers, Cilantro"
                  value={dietaryFormData.ingredientsToAvoid}
                  onChange={(e) => setDietaryFormData({ ...dietaryFormData, ingredientsToAvoid: e.target.value })}
                />
              </div>
              <div className="space-y-2">
                <Label className="text-red-500 font-bold">Allergies (Critical)</Label>
                <textarea
                  className="flex min-h-[80px] w-full rounded-md border-2 border-red-200 focus:border-red-500 bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                  placeholder="List any allergies here..."
                  value={dietaryFormData.allergyInfo}
                  onChange={(e) => setDietaryFormData({ ...dietaryFormData, allergyInfo: e.target.value })}
                />
              </div>
              <div className="space-y-2">
                <Label>General Feedback / Notes</Label>
                <textarea
                  className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                  placeholder="Any feedback on meals, delivery, or general experience?"
                  value={dietaryFormData.generalFeedback}
                  onChange={(e) => setDietaryFormData({ ...dietaryFormData, generalFeedback: e.target.value })}
                />
              </div>

              <div className="flex justify-end gap-3 pt-4">
                <Button variant="outline" onClick={() => setShowDietaryModal(false)}>Cancel</Button>
                <Button
                  className="bg-orange-500 hover:bg-orange-600 text-white"
                  onClick={handleSaveDietaryPreferences}
                  disabled={savingPreferences}
                >
                  {savingPreferences ? 'Saving...' : 'Save Preferences'}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
}

// Progress Tab Component
function GymProgressTab({ progress }) {
  const [sessions, setSessions] = useState(progress?.completed_sessions || []);

  React.useEffect(() => {
    if (progress?.completed_sessions) {
      setSessions(progress.completed_sessions);
    }
  }, [progress]);

  if (!progress) {
    return <div className="text-center py-8 text-gray-700">Loading progress...</div>;
  }

  const hours = Math.floor(progress.total_workout_time_minutes / 60);
  const mins = progress.total_workout_time_minutes % 60;

  const handleDeleteSession = async (sessionId) => {
    if (!window.confirm('Delete this workout session? This cannot be undone.')) return;

    try {
      await http.delete(`/customer/gym/session/${sessionId}`);
      setSessions(sessions.filter(s => s.id !== sessionId));
      alert('Workout session deleted');
      window.location.reload(); // Refresh to update stats
    } catch (error) {
      console.error('Error deleting session:', error);
      alert('Failed to delete session');
    }
  };

  return (
    <div className="space-y-4">
      {/* Motivational Highlights */}
      <div className="relative">
        <div className="absolute top-2 right-2 z-10">
          <button
            onClick={async () => {
              if (window.confirm('🔄 Start a new streak? This will delete all your workout data and reset your progress. This cannot be undone!')) {
                try {
                  // Delete all completed sessions
                  if (progress?.completed_sessions) {
                    for (const session of progress.completed_sessions) {
                      await http.delete(`/customer/gym/session/${session.id}`);
                    }
                  }
                  alert('New streak started! Let\'s go! 💪');
                  window.location.reload();
                } catch (error) {
                  console.error('Error deleting data:', error);
                  alert('Failed to reset data');
                }
              }
            }}
            className="text-xs bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-1 rounded transition-colors"
            title="Start new streak"
          >
            🔄 Start new streak
          </button>
        </div>
        <div className="bg-orange-500 p-4 rounded-lg">
          <h3 className="text-xl font-bold mb-3 text-white">This Week's Highlights 🔥</h3>
          <div className="space-y-2">
            {progress.total_workout_days > 0 && (
              <p className="text-lg text-white">💪 You trained {progress.total_workout_days} {progress.total_workout_days === 1 ? 'day' : 'days'} this week!</p>
            )}
            {progress.most_trained_body_part && (
              <p className="text-lg text-white">🎯 Most trained: {progress.most_trained_body_part}</p>
            )}
            {progress.total_workout_time_minutes > 0 && (
              <p className="text-lg text-white">⏱️ Total time: {hours}h {mins}m</p>
            )}
            {progress.consistency_streak > 0 && (
              <p className="text-lg text-white">🔥 {progress.consistency_streak} day streak!</p>
            )}
          </div>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-white p-4 rounded-lg border border-orange-200 text-center">
          <p className="text-3xl font-bold text-orange-500">{progress.total_workout_days}</p>
          <p className="text-sm text-gray-700">Workout Days</p>
        </div>
        <div className="bg-white p-4 rounded-lg border border-orange-200 text-center">
          <p className="text-3xl font-bold text-orange-500">{hours}h {mins}m</p>
          <p className="text-sm text-gray-700">Total Time</p>
        </div>
        <div className="bg-white p-4 rounded-lg border border-orange-200 text-center">
          <p className="text-3xl font-bold text-orange-500">{progress.consistency_streak}</p>
          <p className="text-sm text-gray-700">Day Streak</p>
        </div>
        <div className="bg-white p-4 rounded-lg border border-orange-200 text-center">
          <p className="text-3xl font-bold text-orange-500">{progress.missed_days}</p>
          <p className="text-sm text-gray-700">Missed Days</p>
        </div>
      </div>

      {/* Workout Types */}
      {Object.keys(progress.workout_types || {}).length > 0 && (
        <div className="bg-white p-4 rounded-lg border border-orange-200">
          <h4 className="font-semibold text-gray-700 mb-3">Workout Types</h4>
          <div className="space-y-2">
            {Object.entries(progress.workout_types).map(([type, count]) => (
              <div key={type} className="flex justify-between">
                <span className="capitalize">{type}</span>
                <span className="font-medium">{count} sessions</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Body Parts */}
      {Object.keys(progress.body_parts_trained || {}).length > 0 && (
        <div className="bg-white p-4 rounded-lg border border-orange-200">
          <h4 className="font-semibold text-gray-700 mb-3">Body Parts Trained</h4>
          <div className="space-y-2">
            {Object.entries(progress.body_parts_trained)
              .sort((a, b) => b[1] - a[1])
              .map(([part, count]) => (
                <div key={part} className="flex justify-between">
                  <span>{part}</span>
                  <span className="font-medium">{count}×</span>
                </div>
              ))}
          </div>
        </div>
      )}

      {/* Weekly Mood Ratings */}
      {progress.mood_ratings && progress.mood_ratings.length > 0 && (
        <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-lg border-2 border-orange-200">
          <h4 className="font-semibold text-black mb-3">💝 Weekly Feelings After Workouts</h4>
          <div className="space-y-2">
            {progress.mood_ratings.map((entry, idx) => (
              <div key={idx} className="flex justify-between items-center bg-white p-2 rounded">
                <span className="text-sm text-gray-700">{entry.date}</span>
                <span className="text-sm font-medium">
                  {entry.mood === 'pushing_through' && '💭 Pushing through'}
                  {entry.mood === 'feeling_better' && '🙂 Feeling better'}
                  {entry.mood === 'energized' && '😄 Energized'}
                  {entry.mood === 'grateful_blissful' && '🥰 Grateful & blissful'}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Completed Workouts History */}
      {sessions.length > 0 && (
        <div className="bg-white p-4 rounded-lg border border-orange-200">
          <h4 className="font-semibold text-gray-700 mb-3">Workout History</h4>
          <div className="space-y-2">
            {sessions.map((session) => (
              <div key={session.id} className="p-3 border rounded hover:bg-white">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <p className="font-medium text-sm">{session.day} - {session.date}</p>
                    <p className="text-xs text-gray-700">
                      {session.summary?.completed_exercises} exercises • {session.summary?.total_time_minutes} min
                    </p>
                  </div>
                  <button
                    onClick={() => handleDeleteSession(session.id)}
                    className="text-orange-500 hover:text-black text-sm"
                  >
                    🗑️
                  </button>
                </div>
                {session.summary?.workout_types && (
                  <p className="text-xs text-gray-700">
                    {session.summary.workout_types.join(', ')}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}


    </div>
  );
}

// Workout Splits Tab Component
function WorkoutSplitsTab() {
  const [expandedCard, setExpandedCard] = useState(null);

  const splits = [
    {
      name: 'Full Body Split',
      description: 'Train all major muscle groups in one session, 3–4 times per week.',
      idealFor: 'Beginners or people with limited time',
      example: 'Mon: Full Body • Wed: Full Body • Fri: Full Body',
      emoji: '',
      frequency: '3-4x/week',
      duration: '60-90 min',
      level: 'Beginner'
    },
    {
      name: 'Upper / Lower Split',
      description: 'Alternate between upper and lower body workouts.',
      idealFor: 'Intermediate lifters',
      example: 'Mon: Upper • Tue: Lower • Thu: Upper • Fri: Lower',
      emoji: '',
      frequency: '4x/week',
      duration: '45-60 min',
      level: 'Intermediate'
    },
    {
      name: 'Push / Pull / Legs (PPL)',
      description: 'Push: Chest, Shoulders, Triceps • Pull: Back, Biceps • Legs: Quads, Hamstrings, Glutes.',
      idealFor: 'Intermediate–Advanced lifters',
      example: 'Mon: Push • Tue: Pull • Wed: Legs • Thu: Rest • Fri: Push',
      emoji: '',
      frequency: '5-6x/week',
      duration: '60-75 min',
      level: 'Advanced'
    },
    {
      name: 'Bro Split',
      description: 'Train one major muscle group each day.',
      idealFor: 'Advanced bodybuilders focusing on isolation',
      example: 'Mon: Chest • Tue: Back • Wed: Shoulders • Thu: Arms • Fri: Legs',
      emoji: '',
      frequency: '5x/week',
      duration: '60-90 min',
      level: 'Advanced'
    },
    {
      name: 'Upper / Lower / Full Split',
      description: 'Combines strength and conditioning with varied intensity.',
      idealFor: 'Balanced programs for all levels',
      example: 'Mon: Upper • Wed: Lower • Fri: Full Body',
      emoji: '',
      frequency: '3x/week',
      duration: '60-75 min',
      level: 'All Levels'
    },
    {
      name: 'Cardio + Strength Hybrid',
      description: 'Mix of endurance and resistance training.',
      idealFor: 'Weight loss and fitness balance',
      example: 'M/W/F: Cardio + Core • T/Th: Strength',
      emoji: '',
      frequency: '5x/week',
      duration: '45-60 min',
      level: 'All Levels'
    }
  ];

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="bg-orange-500 text-white p-4 rounded-lg border-l-8 border-orange-600">
        <p className="font-bold text-lg">Choose what fits your lifestyle — consistency is key 💪</p>
      </div>

      {/* Split Cards Grid - 2 columns on larger screens */}
      <div className="grid md:grid-cols-2 gap-4">
        {splits.map((split, idx) => {
          const isExpanded = expandedCard === idx;
          return (
            <div
              key={idx}
              className="bg-white rounded-lg border-2 border-gray-200 hover:border-orange-500 transition-all overflow-hidden cursor-pointer"
              onClick={() => setExpandedCard(isExpanded ? null : idx)}
            >
              {/* Header */}
              <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-4 py-3">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="text-3xl">{split.emoji}</span>
                    <div>
                      <h3 className="text-lg font-bold text-white">{split.name}</h3>
                      <span className="text-xs text-orange-100 font-semibold">{split.level}</span>
                    </div>
                  </div>
                  <div className="text-white text-xl">
                    {isExpanded ? '▼' : '▶'}
                  </div>
                </div>
              </div>

              {/* Quick Stats - Always Visible */}
              <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                <div className="flex justify-around text-center">
                  <div>
                    <p className="text-xs text-gray-600 font-semibold">Frequency</p>
                    <p className="text-sm text-orange-600 font-bold">{split.frequency}</p>
                  </div>
                  <div className="border-l border-gray-300"></div>
                  <div>
                    <p className="text-xs text-gray-600 font-semibold">Duration</p>
                    <p className="text-sm text-orange-600 font-bold">{split.duration}</p>
                  </div>
                </div>
              </div>

              {/* Expandable Content */}
              {isExpanded && (
                <div className="p-4 space-y-3 animate-fadeIn">
                  <p className="text-gray-800 text-sm leading-relaxed">{split.description}</p>

                  <div className="bg-orange-50 p-3 rounded-lg border border-orange-200">
                    <p className="text-xs font-bold text-gray-700 mb-1">🎯 IDEAL FOR</p>
                    <p className="text-sm text-gray-800">{split.idealFor}</p>
                  </div>

                  <div className="bg-gray-900 text-white p-3 rounded-lg">
                    <p className="text-xs font-bold text-orange-400 mb-2">📅 SAMPLE SCHEDULE</p>
                    <p className="font-mono text-sm">{split.example}</p>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Pro Tip */}
      <div className="bg-orange-50 border-2 border-orange-300 p-4 rounded-lg">
        <div className="flex items-start gap-3">
          <span className="text-2xl">💡</span>
          <div>
            <p className="font-bold text-black mb-1">Pro Tip</p>
            <p className="text-gray-800 text-sm">Start with what you can maintain consistently, then progress to more advanced splits as you build strength and experience!</p>
          </div>
        </div>
      </div>
    </div>
  );
}
